<template>
  <div class="container-fluid p-0 pdv-venda-page">
    <template v-if="!isPagamentoModalOpen">
      <Keypress
        key-event="keyup"
        :prevent-default="true"
        :key-code="teclasEnum.F2"
        @success="buscarProduto"
      />
      <Keypress
        key-event="keyup"
        :prevent-default="true"
        :key-code="teclasEnum.F3"
        @success="abrirModalCalculoQuantidade"
      />
      <Keypress
        key-event="keyup"
        :prevent-default="true"
        :key-code="teclasEnum.F4"
        @success="handleShowPagamentoModal({ transmitir: true, isSave: false })"
      />
      <Keypress
        key-event="keyup"
        :prevent-default="true"
        :key-code="teclasEnum.F8"
        @success="
          handleShowPagamentoModal({ transmitir: false, isSave: false })
        "
      />
    </template>

    <b-sidebar
      id="sidebar-caixa"
      :width="'400px'"
      :title="caixaInfo.caixa"
      backdrop-variant="dark"
      backdrop
      right
      shadow
    >
      <template #default="{ hide }">
        <div class="px-2 py-2">
          <div style="width: 100%" class="mb-2">
            <button
              style="width: 100%"
              class="btn btn-success btn-hover-dark font-weight-bold"
              v-b-toggle.sidebar-sangria-suprimento
              @click="
                () => {
                  caixaOperacao = 'Suprimento';
                  hide();
                }
              "
            >
              Suprimento
            </button>
          </div>
          <div style="width: 100%" class="mb-2">
            <button
              style="width: 100%"
              class="btn btn-warning btn-hover-dark font-weight-bold"
              v-b-toggle.sidebar-sangria-suprimento
              @click="
                () => {
                  caixaOperacao = 'Sangria';
                  hide();
                }
              "
            >
              Sangria
            </button>
          </div>

          <div
            class="border-bottom mt-2"
            style="
              display: flex;
              flex-direction: row;
              gap: 1.4rem;
              text-align: end;
              justify-content: space-between;
            "
          ></div>
          <div
            v-if="caixaInfo.pagamentos.length > 0"
            class="my-4"
            style="text-align: center"
          >
            <p class="mb-0 font-weight-bolder">
              Formas de pagamento utilizadas
            </p>
          </div>
          <div
            class="py-2 px-6 border-bottom"
            v-for="pagamento in caixaInfo.pagamentos"
            v-bind:key="pagamento.descricao"
            style="
              display: flex;
              flex-direction: row;
              gap: 1.4rem;
              text-align: end;
              justify-content: space-between;
            "
          >
            <p class="mb-0 font-weight-bold">{{ pagamento.descricao }} R$</p>
            <span class="font-weight-bolder">
              {{
                store.fechamentoAsCegas ? "-" : numberToReal(pagamento.total)
              }}</span
            >
          </div>
          <div class="py-4 px-6 border-top border-bottom mt-2">
            <div
              style="
                display: flex;
                flex-direction: row;
                gap: 1.4rem;
                text-align: end;
                justify-content: space-between;
              "
            >
              <p
                class="mb-1"
                v-b-tooltip.hover.top="'Soma de todas as vendas feitas'"
              >
                Total de vendas R$
              </p>
              <span style="font-size: 16px">
                {{ formatCaixaValorSigiloso(caixaInfo.total) }}
              </span>
            </div>
            <div
              style="
                display: flex;
                flex-direction: row;
                gap: 1.4rem;
                text-align: end;
                justify-content: space-between;
              "
            >
              <p class="mb-1">Total de contas recebidas R$</p>
              <span style="font-size: 16px">
                {{ formatCaixaValorSigiloso(caixaInfo.total_contas_recebidas) }}
              </span>
            </div>
            <div
              style="
                display: flex;
                flex-direction: row;
                gap: 1.4rem;
                justify-content: space-between;
              "
            >
              <p class="text-danger mb-1">Total de vendas canceladas R$(-)</p>
              <span class="text-danger" style="font-size: 16px">
                {{
                  formatCaixaValorSigiloso(caixaInfo.total_vendas_canceladas)
                }}
              </span>
            </div>
            <div
              style="
                display: flex;
                flex-direction: row;
                gap: 1.4rem;
                text-align: end;
                justify-content: space-between;
              "
            >
              <p class="text-success mb-1">Abertura de caixa R$(+)</p>
              <span class="text-success" style="font-size: 16px">{{
                numberToReal(caixaInfo.dados_abertura.valor_abertura)
              }}</span>
            </div>
            <div
              style="
                display: flex;
                flex-direction: row;
                gap: 1.4rem;
                text-align: end;
                justify-content: space-between;
              "
            >
              <p class="text-success mb-1">Suprimento R$(+)</p>
              <span class="text-success" style="font-size: 16px">{{
                numberToReal(caixaInfo.suprimento)
              }}</span>
            </div>
            <div
              style="
                display: flex;
                flex-direction: row;
                gap: 1.4rem;
                text-align: end;
                justify-content: space-between;
              "
            >
              <p class="text-danger mb-1">Sangria R$(-)</p>
              <span class="text-danger" style="font-size: 16px">{{
                numberToReal(caixaInfo.sangria)
              }}</span>
            </div>
          </div>
          <div
            class="py-4 px-6 border-bottom mt-2"
            style="
              display: flex;
              flex-direction: row;
              gap: 1.4rem;
              text-align: end;
              justify-content: space-between;
            "
          >
            <p
              class="mb-0 font-weight-bold"
              v-b-tooltip.hover.top="
                'Soma de todas vendas feitas no Dinheiro/Cheque + Abertura de Caixa + Suprimento - Sangria'
              "
            >
              Total na gaveta R$(=)
            </p>
            <span class="font-weight-bolder" style="font-size: 16px">{{
              formatCaixaValorSigiloso(caixaInfo.total_da_gaveta)
            }}</span>
          </div>
          <div
            class="py-4 px-6 border-bottom mt-2"
            style="
              display: flex;
              flex-direction: row;
              gap: 1.4rem;
              text-align: end;
              justify-content: space-between;
            "
          >
            <p
              class="mb-0 font-weight-bold"
              v-b-tooltip.hover.top="
                'Soma das vendas que não foram recebidas no Dinheiro (Á vista)'
              "
            >
              Total no caixa geral R$(=)
            </p>
            <span class="font-weight-bold" style="font-size: 16px">
              {{ formatCaixaValorSigiloso(caixaInfo.total_venda_nao_gaveta) }}
            </span>
          </div>
        </div>
      </template>
      <template #footer="{ hide }">
        <div style="width: 98%" class="ml-2 mb-2">
          <button
            style="width: 98%"
            class="btn btn-danger btn-hover-dark font-weight-bold"
            @click="
              () => {
                fecharCaixa();
                hide();
              }
            "
          >
            Fechar<span
              v-if="mostrarAtalhosEmTela"
              class="pdv-btn-atalho ml-1"
              >(Ctrl + F)</span
            >
          </button>
        </div>
      </template>
    </b-sidebar>

    <b-sidebar
      id="sidebar-sangria-suprimento"
      :title="caixaOperacao"
      backdrop-variant="dark"
      backdrop
      right
      shadow
    >
      <div class="px-2 py-2">
        <div style="width: 100%" class="mb-2">
          <b-form-group label-for="caixaValorOperacao" label="Valor R$">
            <VMoney
              class="form-control"
              id="caixaValorOperacao"
              name="caixaValorOperacao"
              v-model="caixaValorOperacao"
              v-bind="configMask"
              :key="keyToRender"
              v-on:keyup.native.enter="
                () => {
                  salvarSangriaSuprimento(caixaOperacao);
                  $root.$emit(
                    'bv::toggle::collapse',
                    'sidebar-sangria-suprimento'
                  );
                }
              "
            />
          </b-form-group>
          <b-form-group label-for="descricaoOperacao" label="Descrição">
            <b-form-input v-model="descricaoOperacao"></b-form-input>
          </b-form-group>
        </div>
        <div style="width: 100%" class="mb-2">
          <b-form-group
            label-for="sangria_suprimento_comprovante"
            label="Imprimir comprovante"
          >
            <span class="switch switch-icon">
              <label v-b-tooltip.hover.right="'Imprimir comprovante?'">
                <input
                  type="checkbox"
                  v-model="sangria_suprimento_comprovante"
                />
                <span></span>
              </label>
            </span>
          </b-form-group>
        </div>
      </div>
      <template #footer="{ hide }">
        <div class="d-flex text-light align-items-center px-3 py-2">
          <button
            style="width: 100%"
            class="btn btn-primary btn-hover-dark font-weight-bold"
            :disabled="isSavingSangriaSuprimento"
            @click="
              () => {
                salvarSangriaSuprimento(caixaOperacao);
                hide();
              }
            "
          >
            Salvar
          </button>
        </div>
      </template>
    </b-sidebar>

    <b-modal
      id="modal-receber-conta-pdv"
      title="Receber conta"
      size="xl"
      centered
      hide-footer
      modal-class="receber-conta-pdv-modal"
      header-class="receber-conta-pdv-header"
      body-class="receber-conta-pdv-body"
      @hidden="resetReceberContaPdv"
    >
      <div class="receber-conta-shell">
        <div class="receber-conta-topbar">
          <div class="receber-conta-search">
            <label for="receberContaBusca">Cliente ou CPF/CNPJ</label>
            <b-form-input
              id="receberContaBusca"
              v-model="receberContaBusca"
              autocomplete="off"
              placeholder="Nome, CPF ou CNPJ"
              @input="buscarContasReceberPdv"
            />
            <span>{{ receberContaStatusTexto }}</span>
          </div>

          <div class="receber-conta-payment">
            <label for="receberContaFormaPagamento">Meio de pagamento</label>
            <b-form-select v-model="receberContaFormaPagamento">
              <b-form-select-option :value="null">
                Selecione
              </b-form-select-option>
              <b-form-select-option
                v-for="forma in listaMeiosPagamento"
                :key="'receber-conta-forma-' + forma.id"
                :value="forma"
              >
                {{ forma.descricao }}
              </b-form-select-option>
            </b-form-select>
          </div>

          <div class="receber-conta-total-card">
            <span>Selecionado</span>
            <strong>R$ {{ numberToReal(receberContaTotal) }}</strong>
            <small>{{ receberContaSelecionadas.length }} conta(s)</small>
          </div>
        </div>

        <div class="receber-conta-list-header">
          <div>
            <strong>Contas abertas</strong>
            <span>Vencidas e a vencer, sem pagamento parcial</span>
          </div>
          <b-badge variant="light">
            {{ receberContaResultados.length }} resultado(s)
          </b-badge>
        </div>

        <div class="receber-conta-table-wrap">
          <b-table
            small
            hover
            :busy="receberContaLoading"
            :items="receberContaResultados"
            :fields="receberContaFields"
            empty-text="Nenhuma conta aberta encontrada"
            show-empty
            class="receber-conta-table"
          >
            <template #table-busy>
              <div class="text-center text-primary my-3">
                Buscando contas...
              </div>
            </template>
            <template #cell(selecionar)="row">
              <b-form-checkbox
                :checked="isContaReceberSelecionada(row.item.id)"
                @change="toggleContaReceberPdv(row.item)"
              />
            </template>
            <template #cell(cliente)="row">
              <div class="receber-conta-cliente">
                <strong>{{ row.item.cliente || "-" }}</strong>
                <span v-if="row.item.cnpj_cpf">
                  {{ formatCpfCnpj(row.item.cnpj_cpf) }}
                </span>
              </div>
            </template>
            <template #cell(historico)="row">
              <span class="receber-conta-descricao">
                {{ row.item.historico || "-" }}
              </span>
            </template>
            <template #cell(data_vencimento)="row">
              <div class="receber-conta-vencimento">
                <span>{{ formatDate(row.item.data_vencimento) }}</span>
                <b-badge :variant="getContaReceberSituacaoVariant(row.item)">
                  {{ getContaReceberSituacaoTexto(row.item) }}
                </b-badge>
              </div>
            </template>
            <template #cell(valor_receber)="row">
              <strong class="receber-conta-valor">
                R$ {{ numberToReal(getValorContaReceberPdv(row.item)) }}
              </strong>
            </template>
          </b-table>
        </div>

        <div class="receber-conta-actionbar">
          <b-button
            variant="light"
            :disabled="isRecebendoContaPdv"
            @click="$bvModal.hide('modal-receber-conta-pdv')"
          >
            Cancelar
          </b-button>
          <b-button
            variant="outline-primary"
            :disabled="!canReceberContaParcialPdv"
            @click="abrirModalReceberContaParcialPdv"
          >
            {{
              isLoadingRecebimentoParcialPdv
                ? "Carregando..."
                : "Receber parcial"
            }}
          </b-button>
          <b-button
            variant="primary"
            ref="receberContaPdv"
            :disabled="!canReceberContaPdv"
            @click="receberContaPdv"
          >
            Receber R$ {{ numberToReal(receberContaTotal) }}
          </b-button>
        </div>
      </div>
    </b-modal>

    <RecebimentoParcialModal
      modal-id="modal-receber-conta-parcial-pdv"
      :conta="receberContaSelecionadas[0] || null"
      :bancos="receberContaBancos"
      :meios-pagamentos="receberContaMeiosPagamentoParcial"
      recebimento-pdv
      @success="handleRecebimentoParcialPdv"
    />

    <b-form class="form" @submit.stop.prevent="onSubmit">
      <div>
        <b-row class="mb-2 pdv-top-actions-row">
          <b-col cols="1" class="mt-1 pdv-filter-col">
            <b-dropdown
              id="dropdown-dropright"
              dropright
              variant="primary"
              v-b-tooltip.hover.right
              title="Mudar tipo de filtro"
            >
              <template #button-content>
                <FilterOutline :size="20" />
              </template>
              <b-dropdown-item
                @click="
                  () => {
                    typeFilter = 1;
                  }
                "
                :class="typeFilter === 1 ? 'bg-primary' : ''"
              >
                <p :class="typeFilter === 1 ? 'text-white' : ''">
                  Começando com
                </p>
              </b-dropdown-item>
              <b-dropdown-item
                @click="
                  () => {
                    typeFilter = 2;
                  }
                "
                :class="typeFilter === 2 ? 'bg-primary' : ''"
              >
                <p :class="typeFilter === 2 ? 'text-white' : ''">
                  Terminando com
                </p>
              </b-dropdown-item>
              <b-dropdown-item
                @click="
                  () => {
                    typeFilter = 3;
                  }
                "
                :class="typeFilter === 3 ? 'bg-primary' : ''"
              >
                <p :class="typeFilter === 3 ? 'text-white' : ''">Contendo</p>
              </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-header>Ordenar</b-dropdown-header>

              <b-dropdown-item
                @click="setSort('preco', 'ASC')"
                :class="
                  sortField === 'preco' && sortDir === 'ASC'
                    ? 'bg-primary text-white'
                    : ''
                "
              >
                Preço ↑ (crescente)
              </b-dropdown-item>

              <b-dropdown-item
                @click="setSort('preco', 'DESC')"
                :class="
                  sortField === 'preco' && sortDir === 'DESC'
                    ? 'bg-primary text-white'
                    : ''
                "
              >
                Preço ↓ (decrescente)
              </b-dropdown-item>

              <b-dropdown-item
                @click="setSort('descricao', 'ASC')"
                :class="
                  sortField === 'descricao' && sortDir === 'ASC'
                    ? 'bg-primary text-white'
                    : ''
                "
              >
                Descrição ↑ (A–Z)
              </b-dropdown-item>

              <b-dropdown-item
                @click="setSort('descricao', 'DESC')"
                :class="
                  sortField === 'descricao' && sortDir === 'DESC'
                    ? 'bg-primary text-white'
                    : ''
                "
              >
                Descrição ↓ (Z–A)
              </b-dropdown-item>
            </b-dropdown>
          </b-col>
          <b-col
            class="pdv-caixa-status"
            style="display: flex; align-items: center; margin-left: 20px"
            v-if="caixaAberturaHorario && !isCaixaFechadoManual"
          >
            <h4 class="m-0 mt-2">Caixa aberto às {{ caixaAberturaHorario }}</h4>
          </b-col>
          <b-col
            v-if="selectedLista"
            class="d-flex align-items-center ml-2 pdv-selected-list"
          >
            <span class="badge badge-light px-3 py-2">
              <strong>Lista de preço selecionada:</strong>
              {{ selectedLista.descricao }}
              <button
                type="button"
                class="btn btn-link text-danger p-0 ml-2"
                @click="selectedLista = null"
                title="Remover lista selecionada"
              >
                <CloseCircleOutline :size="18" />
              </button>
            </span>
          </b-col>
          <b-col
            class="pdv-actions-toolbar"
            style="display: flex; justify-content: end; align-items: center"
          >
            <b-button
              class="btn btn-primary font-weight-bold mr-2"
              variant="primary"
              v-b-tooltip.hover.right
              title="Selecionar lista de preço"
              @click="$bvModal.show('listaPreco')"
            >
              <TagOutline :size="20" class="mr-1" /> Lista
              <span
                v-if="mostrarAtalhosEmTela"
                class="pdv-btn-atalho"
                >(Ctrl + L)</span
              >
            </b-button>
            <button
              type="button"
              class="btn btn-primary font-weight-bold mr-2"
              v-b-tooltip.top="'Receber contas abertas no caixa'"
              @click="abrirModalReceberContaPdv"
            >
              Receber conta
              <span v-if="mostrarAtalhosEmTela" class="pdv-btn-atalho"
                >(Ctrl + R)</span
              >
            </button>
            <button
              type="button"
              class="btn btn-primary font-weight-bold mr-2"
              v-b-tooltip.top="'Somente irá importar com status: Autorizado'"
              @click="buscarOrcamentos"
            >
              Importar Orçamento
              <span v-if="mostrarAtalhosEmTela" class="pdv-btn-atalho"
                >(Ctrl + O)</span
              >
            </button>
            <button
              type="button"
              class="btn btn-primary font-weight-bold mr-2"
              ref="import-pedido-button"
              v-b-tooltip.top="'Somente irá importar com status: Autorizado'"
              @click="buscarPedidos"
            >
              Importar Pedido
              <span v-if="mostrarAtalhosEmTela" class="pdv-btn-atalho"
                >(Ctrl + P)</span
              >
            </button>
            <button
              type="button"
              class="btn btn-primary font-weight-bold mr-2"
              ref="import-orcamento-button"
              v-b-tooltip.top="
                'Somente irá importar as OS: Autorizadas, Finalizadas, Em andamento e Serviço concluído'
              "
              @click="buscarOS"
            >
              Importar OS
              <span v-if="mostrarAtalhosEmTela" class="pdv-btn-atalho"
                >(Ctrl + U)</span
              >
            </button>
            <button
              type="button"
              class="btn btn-primary font-weight-bold mr-2"
              v-b-tooltip="'Mais opções'"
              v-b-toggle.sidebar-caixa
              v-if="!isCaixaFechadoManual && store.aberturaCaixa"
            >
              <DotsHorizontal :size="20" />
            </button>
            <button
              type="button"
              v-if="isCaixaFechadoManual && store.aberturaCaixa"
              class="btn btn-primary font-weight-bold mr-2"
              v-b-tooltip="'Abrir caixa'"
              v-b-modal.caixa-modal
            >
              Abrir Caixa
            </button>
            <button
              type="button"
              class="btn btn-primary font-weight-bold"
              v-b-tooltip="
                !isFullScreen ? 'Entrar em Fullscreen' : 'Sair de Fullscreen'
              "
              @click="
                () => {
                  if (!isFullScreen) requestFullScreen();
                  else closeFullscreen();
                }
              "
            >
              <Fullscreen :size="20" v-if="!isFullScreen" />
              <Close :size="20" v-else />
            </button>
          </b-col>
        </b-row>
        <b-row class="pdv-main-row">
          <b-col md="8" class="pdv-main-sale-col">
            <b-row align-v="center" class="pdv-search-row">
              <b-col class="pdv-search-col">
                <CardBusca>
                  <template v-slot:quantidade>
                    <Money
                      ref="quantidade"
                      id="quantidade"
                      :options="quantityOptions"
                      style="text-align: right"
                      labelBold
                      :onEnter="informarValor"
                      v-model="quantidade"
                      :label="'1'"
                    />
                  </template>
                  <template v-slot:valor>
                    <Money
                      ref="valor"
                      id="valor"
                      :options="priceOptions"
                      style="text-align: right"
                      labelBold
                      :onEnter="adicionarProduto"
                      v-model="price"
                      :label="'2'"
                    />
                  </template>
                  <template v-slot:addButton>
                    <div
                      class="d-flex justify-content-between align-items-center w-100 h-100"
                    >
                      <button
                        type="button"
                        @click="() => adicionarProduto()"
                        :class="
                          windowWidth > 768
                            ? 'btn btn-sm btn-info btn-hover-info btn-icon mr-2'
                            : 'btn btn-info btn-hover-dark font-weight-bolder font-size-lg mr-2'
                        "
                      >
                        <Plus v-if="windowWidth > 768" />
                        <template v-else> + Adicionar </template>
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-light-primary btn-hover-primary d-flex align-items-center px-3"
                        v-b-tooltip="'Calcular quantidade pelo valor'"
                        @click="abrirModalCalculoQuantidade"
                      >
                        <CalculatorVariantOutline
                          :size="20"
                          class="flex-shrink-0 mr-2"
                        />
                        <span class="text-nowrap">(F3) Conversor</span>
                      </button>
                      <button
                        v-if="balancaDisponivelParaProduto()"
                        type="button"
                        class="btn btn-sm btn-light-success btn-hover-success d-flex align-items-center px-3 ml-2"
                        v-b-tooltip="'Capturar peso da balança'"
                        @click="capturarPesoManual"
                      >
                        <ScaleBathroom :size="20" class="flex-shrink-0 mr-2" />
                        <span class="text-nowrap">Balança</span>
                      </button>
                    </div>
                  </template>
                  <template v-slot:formulario>
                    <Select
                      placeholder="Informe o código, descrição, código de barras ou referência do produto"
                      labelBusca="descricao"
                      v-model="produto"
                      ref="buscarProduto"
                      :options="produtos"
                      inputClass="busca-produto"
                      :change="setProduto"
                      :search="onSearch"
                      id="buscarProduto"
                    >
                      <template slot="options" slot-scope="props">
                        <div
                          v-if="
                            !props.data.isKit &&
                            !props.data?.preco_lista_cliente
                          "
                          class="selected"
                          style="text-transform: uppercase"
                        >
                          {{ props.data.codigo }}
                          -
                          {{ props.data.descricao }}
                          <br />
                          R$
                          {{
                            numberToReal(
                              parseFloat(props.data.preco),
                              "preco"
                            ) +
                            " | Qtd.: " +
                            numberToReal(
                              parseFloat(props.data.quantidade),
                              "quantidade"
                            )
                          }}
                          <template v-if="props.data.referencia">
                            | Ref.: {{ props.data.referencia }}
                          </template>
                          | Reservado:
                          {{ numberToReal(parseFloat(props.data.quantidade_reservada_condicional), "quantidade") }}
                        </div>
                        <div
                          v-else-if="
                            !props.data.isKit &&
                            props.data?.preco_lista_cliente &&
                            props.data.preco_lista_cliente > 0
                          "
                          class="selected"
                          style="text-transform: uppercase"
                        >
                          {{ props.data.codigo }} - {{ props.data.descricao }}
                          <br />
                          R$
                          {{
                            numberToReal(
                              parseFloat(props.data.preco_lista_cliente),
                              "preco"
                            ) +
                            " | Qtd.: " +
                            numberToReal(
                              parseFloat(props.data.quantidade),
                              "quantidade"
                            )
                          }}
                          <template v-if="props.data.referencia">
                            | Ref.: {{ props.data.referencia }}
                          </template>
                          | Reservado:
                          {{ numberToReal(parseFloat(props.data.quantidade_reservada_condicional), "quantidade") }}
                        </div>
                        <div v-else class="d-flex justify-content-between">
                          <div>
                            <div>
                              {{ props.data.codigo }} -
                              {{ props.data.descricao }}
                              <span
                                id="kitInfo"
                                v-if="props.data.isKit"
                                :title="getKitInfo(props.data)"
                                v-b-tooltip.hover.html.right
                              >
                                <InformationOutline :size="14" />
                              </span>
                            </div>
                            <small v-if="props.data.referencia">
                              Ref.: {{ props.data.referencia }}
                            </small>
                          </div>
                          <span class="text-muted">{{
                            !props.data.isKit
                              ? `QTD: ${props.data.quantidade} | Reservado: ${props.data.quantidade_reservada_condicional}`
                              : `R$
                            ${numberToReal(props.data.totalPrice)}`
                          }}</span>
                        </div>
                      </template>
                      <template slot="selected">
                        <div class="selected" style="text-transform: uppercase">
                          <h3
                            class="font-weight-boldest"
                            style="font-size: 2.05rem"
                          >
                            {{ ultimoProduto.descricao }}
                          </h3>
                        </div>
                      </template>
                    </Select>
                  </template>
                </CardBusca>
                <div
                  v-if="balancaDisponivelParaProduto()"
                  class="balanca-indicador"
                  :class="`balanca-indicador--${store.balancaEstado}`"
                >
                  <ScaleBathroom :size="18" class="balanca-indicador__icone" />
                  <span class="balanca-indicador__texto">
                    <template v-if="store.balancaEstado === 'estavel'">
                      Peso estável — adicionando {{ store.balancaPesoTempoReal }} kg
                    </template>
                    <template v-else-if="store.balancaConectada">
                      Pesando... {{ store.balancaPesoTempoReal }} kg
                    </template>
                    <template v-else>
                      Aguardando balança...
                    </template>
                  </span>
                </div>
              </b-col>
            </b-row>
            <CardItensVenda
              :total="total"
              :valorPago="valorPago"
              :acrescimo="valorUS(venda.extraValue)"
              :desconto="valorUS(venda.discount)"
              :substractQtd="substractQtd"
              :addQtd="addQtd"
              :ajusteItem="abrirModalAjusteItem"
              :editarProdutoFiscal="abrirModalProdutoFiscalPDV"
              @produtos-alterados="_onProdutosAlteradosManualmente"
            />
          </b-col>

          <b-col col lg="4" class="pdv-side-col">
            <div class="card card-custom right-card">
              <div
                class="justify-content-center pl-0py-8 px-8 py-md-10 px-md-0"
              >
                <div class="col-md-12">
                  <div
                    class="justify-content-between flex-column flex-md-row font-size-lg"
                  >
                    <div class="d-flex flex-column mb-10 mb-md-0">
                      <div>
                        <b-row class="form-group">
                          <b-col>
                            <div class="accordion" role="tablist">
                              <b-card no-body class="mb-1">
                                <b-card-header
                                  header-tag="header"
                                  class="p-1"
                                  role="tab"
                                >
                                  <b-button
                                    block
                                    v-b-toggle.accordion-2
                                    variant="primary"
                                    >Descontos/Acréscimos<span
                                      v-if="mostrarAtalhosEmTela"
                                      class="pdv-btn-atalho ml-1"
                                      >(Ctrl + T)</span
                                    ></b-button
                                  >
                                </b-card-header>
                                <b-collapse
                                  id="accordion-2"
                                  v-model="descontoAcrescimoAberto"
                                  accordion="my-accordion"
                                  role="tabpanel"
                                >
                                  <b-card-body>
                                    <b-row>
                                      <b-col>
                                        <label>Desconto</label>
                                        <b-input-group>
                                          <template #prepend>
                                            <b-input-group-text
                                              role="button"
                                              class="font-weight-bold"
                                              @click="setIsPercent('desconto')"
                                              >{{
                                                tipoDescontoValue === 2
                                                  ? "%"
                                                  : "$"
                                              }}</b-input-group-text
                                            >
                                          </template>
                                          <NumberInput
                                            label="desconto"
                                            :defaultValue="valueDiscount"
                                            @changeValue="setDesconto"
                                            :onEnter="saveDescontoAcrescimo"
                                            :disabled="
                                              valueExtraValue !== 0
                                                ? true
                                                : false
                                            "
                                          />
                                        </b-input-group>
                                        <small>Enter p/ adicionar valor</small>
                                      </b-col>
                                      <b-col>
                                        <label>Acréscimo</label>
                                        <b-input-group>
                                          <template #prepend>
                                            <b-input-group-text
                                              role="button"
                                              class="font-weight-bold"
                                              @click="setIsPercent('acrescimo')"
                                              >{{
                                                tipoAcrescimoValue === 2
                                                  ? "%"
                                                  : "$"
                                              }}</b-input-group-text
                                            >
                                          </template>
                                          <NumberInput
                                            label="acrescimo"
                                            :defaultValue="valueExtraValue"
                                            @changeValue="setAcrescimo"
                                            :disabled="
                                              valueDiscount !== 0 ? true : false
                                            "
                                            :onEnter="saveDescontoAcrescimo"
                                          />
                                        </b-input-group>
                                        <small>Enter p/ adicionar valor</small>
                                      </b-col>
                                      <b-col
                                        cols="auto"
                                        class="pdv-atacado-toggle-col"
                                      >
                                        <button
                                          type="button"
                                          :class="[
                                            'btn btn-sm pdv-atacado-toggle',
                                            modoAtacadoAtivo
                                              ? 'btn-success'
                                              : 'btn-light',
                                            {
                                              'pdv-atacado-toggle--active':
                                                modoAtacadoAtivo,
                                            },
                                          ]"
                                          :title="
                                            modoAtacadoAtivo
                                              ? 'Desativar preço de atacado (Ctrl + W)'
                                              : 'Ativar preço de atacado (Ctrl + W)'
                                          "
                                          aria-label="Ativar preço de atacado"
                                          :aria-pressed="modoAtacadoAtivo"
                                          v-b-tooltip.hover.top
                                          @click="toggleModoAtacado"
                                        >
                                          <TagOutline :size="20" />
                                        </button>
                                      </b-col>
                                    </b-row>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="mb-1">
                                <b-card-header
                                  header-tag="header"
                                  class="p-1"
                                  role="tab"
                                >
                                  <b-button
                                    block
                                    v-b-toggle.clienteTab
                                    variant="primary"
                                    >Cliente<span
                                      v-if="mostrarAtalhosEmTela"
                                      class="pdv-btn-atalho ml-1"
                                      >(Ctrl + C)</span
                                    ></b-button
                                  >
                                </b-card-header>
                                <b-collapse
                                  id="clienteTab"
                                  accordion="clienteAcordion"
                                  role="tabpanel"
                                >
                                  <b-card-body>
                                    <b-row
                                      class="mb-5"
                                      style="justify-content: space-between"
                                    >
                                      <div style="width: 49%">
                                        <button
                                          type="button"
                                          ref="add_buyer"
                                          class="btn btn-primary font-weight-bold"
                                          v-b-modal.modal-client
                                          style="font-size: 11px; width: 100%"
                                        >
                                          Adicionar cliente
                                        </button>
                                      </div>
                                      <div style="width: 49%">
                                        <button
                                          type="button"
                                          ref="add_buyer"
                                          class="btn btn-primary font-weight-bold"
                                          v-b-modal.modal-client-new
                                          style="font-size: 11px; width: 100%"
                                        >
                                          Não cadastrado
                                        </button>
                                      </div>
                                    </b-row>
                                    <b-row class="pb-5">
                                      <b-col>
                                        <div
                                          class="font-weight-bolder font-size-lg mb-3"
                                        >
                                          Nome Cliente
                                        </div>
                                        <div>
                                          {{ valueCliente?.nome ?? "" }}
                                        </div>
                                      </b-col>
                                      <b-col>
                                        <div
                                          class="font-weight-bolder font-size-lg mb-3"
                                        >
                                          CPF/CNPJ
                                        </div>
                                        <div>
                                          {{
                                            formatCpfCnpj(
                                              valueCliente?.cnpj_cpf ?? ""
                                            )
                                          }}
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <b-row
                                      v-if="
                                        valueCliente?.id_pessoa &&
                                        creditoClienteVouchers.length > 0
                                      "
                                      class="mb-5"
                                    >
                                      <b-col cols="12">
                                        <div class="credito-cliente-box">
                                          <div>
                                            <div class="font-weight-bolder">
                                              Vouchers disponíveis: R$
                                              {{
                                                numberToReal(
                                                  creditoClienteSaldo,
                                                  2
                                                )
                                              }}
                                            </div>
                                            <small class="text-muted">
                                              {{
                                                creditoClienteVouchers.length
                                              }}
                                              voucher(s) disponível(is).
                                            </small>
                                          </div>
                                          <button
                                            type="button"
                                            v-if="!creditoClienteAplicado"
                                            class="btn btn-sm btn-primary font-weight-bold"
                                            @click="
                                              solicitarUsoCreditoCliente(
                                                valueCliente
                                              )
                                            "
                                          >
                                            Escolher voucher
                                          </button>
                                          <button
                                            type="button"
                                            v-else
                                            class="btn btn-sm btn-secondary font-weight-bold border border-primary"
                                            @click="removerCreditoCliente"
                                          >
                                            Remover
                                          </button>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <b-row
                                      align-h="center"
                                      v-if="valueCliente?.nome"
                                    >
                                      <b-col cols="6">
                                        <button
                                          type="button"
                                          ref="add_buyer"
                                          class="btn btn-secondary font-weight-bold border border-primary"
                                          style="font-size: 11px"
                                          @click="removeCliente"
                                        >
                                          <div
                                            style="
                                              display: flex;
                                              align-items: center;
                                              gap: 4px;
                                            "
                                          >
                                            <p class="mb-0">Remover cliente</p>
                                            <TrashCanIcon :size="14" />
                                          </div>
                                        </button>
                                      </b-col>
                                    </b-row>
                                    <br />
                                    <b-row
                                      v-if="limiteCreditoAtigindo"
                                      align-h="center"
                                    >
                                      <b-col cols="12">
                                        <span
                                          class="label label-lg label-inline label-light-danger"
                                          >Limite de crédito atingido</span
                                        >
                                        <br />
                                        <br />
                                        <span
                                          ><strong
                                            >Limite: R$
                                            {{
                                              numberToReal(
                                                valorLimiteCredito,
                                                2
                                              )
                                            }}</strong
                                          ></span
                                        >
                                        /
                                        <span
                                          v-b-tooltip.righttop="
                                            'O limite de crédito considera contas a receber na situação (Em aberto)'
                                          "
                                          ><strong
                                            >Atingido: R$
                                            {{
                                              numberToReal(
                                                valorLimiteCreditoAtingido,
                                                2
                                              )
                                            }}</strong
                                          ></span
                                        >
                                      </b-col>
                                    </b-row>
                                    <b-row
                                      v-if="limiteCreditoAtual"
                                      align-h="center"
                                    >
                                      <b-col cols="12">
                                        <span
                                          class="label label-lg label-inline label-light-warning"
                                          >Limite de crédito</span
                                        >
                                        <br />
                                        <br />
                                        <span
                                          ><strong
                                            >Limite: R$
                                            {{
                                              numberToReal(
                                                valorLimiteCredito,
                                                2
                                              )
                                            }}</strong
                                          ></span
                                        >
                                        /
                                        <span
                                          v-b-tooltip.righttop="
                                            'O limite de crédito considera contas a receber na situação (Em aberto)'
                                          "
                                          ><strong
                                            >Atingido: R$
                                            {{
                                              numberToReal(
                                                valorLimiteCreditoAtingido,
                                                2
                                              )
                                            }}</strong
                                          ></span
                                        >
                                      </b-col>
                                    </b-row>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="mb-1">
                                <b-card-header
                                  header-tag="header"
                                  class="p-1"
                                  role="tab"
                                >
                                  <b-button
                                    block
                                    v-b-toggle.vendedorTab
                                    variant="primary"
                                    >Vendedor<span
                                      v-if="mostrarAtalhosEmTela"
                                      class="pdv-btn-atalho ml-1"
                                      >(Ctrl + V)</span
                                    ></b-button
                                  >
                                </b-card-header>
                                <b-collapse
                                  id="vendedorTab"
                                  accordion="clienteAcordion"
                                  role="tabpanel"
                                >
                                  <b-card-body>
                                    <b-row>
                                      <b-col>
                                        <b-form-group
                                          label=""
                                          label-for="vendedor"
                                        >
                                          <VueSelect
                                            :filterable="false"
                                            label="vendedor"
                                            v-model="venda.vendedor"
                                            class="busca-vendedor"
                                            ref="buscaVendedor"
                                            :options="vendedores"
                                            @open="onSearchVendedor"
                                            @search="onSearchVendedor"
                                          >
                                            <template slot="no-options">
                                              Informe o nome do vendedor
                                            </template>
                                            <template
                                              slot="option"
                                              slot-scope="option"
                                            >
                                              <div class="d-center">
                                                {{ option.nome }}
                                              </div>
                                            </template>
                                            <template
                                              slot="selected-option"
                                              slot-scope="option"
                                            >
                                              <div class="selected d-center">
                                                {{ option.nome }}
                                              </div>
                                            </template>
                                          </VueSelect>
                                        </b-form-group>
                                      </b-col>
                                    </b-row>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                              <b-card no-body class="mb-1">
                                <b-card-header
                                  header-tag="header"
                                  class="p-1"
                                  role="tab"
                                >
                                  <b-button
                                    block
                                    v-b-toggle.observationTab
                                    variant="primary"
                                    >Informações Adicionais<span
                                      v-if="mostrarAtalhosEmTela"
                                      class="pdv-btn-atalho ml-1"
                                      >(Ctrl + I)</span
                                    ></b-button
                                  >
                                </b-card-header>
                                <b-collapse
                                  id="observationTab"
                                  accordion="clienteAcordion"
                                  role="tabpanel"
                                >
                                  <b-card-body>
                                    <b-row>
                                      <b-col>
                                        <b-form-group
                                          label=""
                                          label-for="informacoesAdicionais"
                                        >
                                          <v-textarea
                                            full-width
                                            rows="4"
                                            v-model="venda.observation"
                                          ></v-textarea>
                                        </b-form-group>
                                      </b-col>
                                    </b-row>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="justify-content-center py-6 px-6 py-md-6 px-md-0">
                <div class="col-md-10">
                  <div class="d-flex flex-column text-md-right">
                    <span class="font-size-lg font-weight-bolder mb-1"
                      >SUBTOTAL</span
                    >
                    <span class="font-size-h2-plus font-weight-boldest mb-1"
                      >R$ {{ valorReal(valorTotal) }}</span
                    ><span
                      class="text-primary font-size-h5-plus font-weight-boldest mb-1"
                      v-if="store.productOfTradeCollection.length > 0"
                    >
                      Total de Itens:
                      {{
                        store.productOfTradeCollection.reduce(
                          (acc, produto) => acc + produto.quantity,
                          0
                        )
                      }}</span
                    >
                    <span
                      class="text-success font-size-h3"
                      v-if="descontoAplicado"
                      >Desconto:
                      {{
                        tipoDescontoValue === 1
                          ? `R$
                      ${valorReal(valueDiscount)}`
                          : `${valorReal(valueDiscount)}%`
                      }}</span
                    >
                    <span
                      class="text-success font-size-h3"
                      v-if="descontoPedidoAplicado"
                      >Desconto:
                      {{
                        tipoDescontoValue === 1
                          ? `R$
                      ${valorReal(descontoPedido)}`
                          : `${valorReal(descontoPedido)}%`
                      }}</span
                    >
                    <span
                      class="text-primary font-size-h4"
                      v-if="creditoClienteAplicado"
                    >
                      Crédito cliente: R$
                      {{ valorReal(creditoClienteValor) }}
                    </span>
                    <span
                      class="text-danger font-size-h3"
                      v-if="acrescimoAplicado"
                      >Acréscimo:
                      {{
                        tipoAcrescimoValue === 1
                          ? `R$
                      ${valorReal(valueExtraValue)}`
                          : `${valorReal(valueExtraValue)}%`
                      }}</span
                    >
                    <span class="font-size-h3 text-success" v-if="valorPago > 0"
                      >Valor Pago: R$ {{ valorReal(valorPago) }}</span
                    >
                    <span class="font-size-h3" v-if="troco > 0 && !valorPago"
                      >Troco: R$ {{ valorReal(troco) }}</span
                    >
                    <span
                      class="font-size-h3"
                      v-if="parseFloat(valorPago) - parseFloat(total) > 0"
                      >Troco: R$
                      {{
                        valorReal(parseFloat(valorPago) - parseFloat(total))
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="pdv-shortcuts-button-area">
              <button
                type="button"
                class="pdv-shortcuts-button"
                v-b-modal.modal-atalhos-pdv
              >
                Atalhos
              </button>
            </div>
          </b-col>
        </b-row>
        <div class="venda-footer">
          <b-dropdown
            id="dropdown-dropup"
            dropup
            text="MF"
            class="m-2"
            :disabled="isLoadingSubmit"
            v-if="this.store.pafNFCe"
          >
            <b-dropdown-text style="width: 240px; font-size: 12px">
              <b-button size="sm" v-b-modal.identificacaoPAFNFCe
                >Identificação do PAF-NFC-e</b-button
              >
            </b-dropdown-text>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-text>
              <p style="margin-left: 10px">Registros do PAF-NFC-e</p>
              <b-button size="sm" v-b-modal.estoqueTotal
                >Estoque total</b-button
              >
              <!-- <b-button  size="sm">Estoque parcial</b-button> -->
              <!-- <b-button  size="sm">Saídas identificadas</b-button> -->
            </b-dropdown-text>
          </b-dropdown>
          <button
            :disabled="isLoadingSubmit"
            style="margin-right: 5px"
            type="button"
            class="btn btn-light-success"
            @click="
              handleShowPagamentoModal({ transmitir: true, isSave: false })
            "
            v-if="total > 0"
          >
            F4 - Emitir NFC-e
          </button>
          <button
            :disabled="isLoadingSubmit"
            style="margin-right: 5px"
            type="button"
            class="btn btn-primary"
            @click="
              handleShowPagamentoModal({ transmitir: false, isSave: false })
            "
            v-if="total > 0 && !this.store.pafNFCe"
          >
            F8 - Finalizar Pré-Venda
          </button>
          <button
            :disabled="isLoadingSubmit"
            style="margin-right: 5px"
            type="button"
            class="btn btn-light-warning"
            @click="handleSalvarVenda(false)"
            v-if="total > 0"
          >
            (Ctrl + S) Salvar
          </button>
          <button
            :disabled="isLoadingSubmit"
            type="button"
            class="btn btn-light-danger"
            @click="handleSairDaVenda"
          >
            (Ctrl + A) - Cancelar
          </button>
        </div>
      </div>
    </b-form>

    <b-modal id="modal-atalhos-pdv" title="Atalhos do PDV" centered hide-footer>
      <div class="pdv-shortcuts-toggle">
        <span class="pdv-shortcuts-toggle__label">
          <i class="fas fa-keyboard mr-1"></i>
          Mostrar atalhos em tela
        </span>
        <span class="switch switch-icon">
          <label>
            <input
              type="checkbox"
              :checked="mostrarAtalhosEmTela"
              @change="toggleAtalhosEmTela"
            />
            <span></span>
          </label>
        </span>
      </div>
      <div class="pdv-shortcuts-list">
        <div class="pdv-shortcut-row pdv-shortcut-row-title">
          <span>Geral</span>
        </div>
        <div class="pdv-shortcut-row">
          <kbd>Ctrl + L</kbd>
          <span>Lista de preço</span>
        </div>
        <div class="pdv-shortcut-row">
          <kbd>Ctrl + O</kbd>
          <span>Importar orçamento</span>
        </div>
        <div class="pdv-shortcut-row">
          <kbd>Ctrl + R</kbd>
          <span>Receber conta</span>
        </div>
        <div class="pdv-shortcut-row">
          <kbd>Ctrl + P</kbd>
          <span>Importar pedido</span>
        </div>
        <div class="pdv-shortcut-row">
          <kbd>Ctrl + U</kbd>
          <span>Importar OS</span>
        </div>
        <div class="pdv-shortcut-row">
          <kbd>Ctrl + F</kbd>
          <span>Fechar caixa</span>
        </div>
        <div class="pdv-shortcut-row">
          <kbd>Ctrl + T</kbd>
          <span>Descontos/Acréscimos</span>
        </div>
        <div class="pdv-shortcut-row">
          <kbd>Ctrl + C</kbd>
          <span>Cliente</span>
        </div>
        <div class="pdv-shortcut-row">
          <kbd>Ctrl + V</kbd>
          <span>Vendedor</span>
        </div>
        <div class="pdv-shortcut-row">
          <kbd>Ctrl + I</kbd>
          <span>Informações adicionais</span>
        </div>
        <div class="pdv-shortcut-row">
          <kbd>F2</kbd>
          <span>Lançar produto</span>
        </div>
        <div class="pdv-shortcut-row">
          <kbd>F3</kbd>
          <span>Conversor</span>
        </div>
        <div class="pdv-shortcut-row">
          <kbd>F4</kbd>
          <span>Emitir NFC-e</span>
        </div>
        <div class="pdv-shortcut-row">
          <kbd>F8</kbd>
          <span>Finalizar pré-venda</span>
        </div>
        <div class="pdv-shortcut-row">
          <kbd>Ctrl + D</kbd>
          <span>Ajustar preço do último item</span>
        </div>
        <div class="pdv-shortcut-row">
          <kbd>Ctrl + W</kbd>
          <span>Ativar preço de atacado</span>
        </div>
        <div class="pdv-shortcut-row">
          <kbd>Ctrl + S</kbd>
          <span>Salvar venda</span>
        </div>
        <div class="pdv-shortcut-row">
          <kbd>Ctrl + A</kbd>
          <span>Cancelar venda</span>
        </div>
        <div class="pdv-shortcut-row pdv-shortcut-row-title">
          <span>Durante o pagamento</span>
        </div>
        <div
          class="pdv-shortcut-row"
          v-for="atalho in atalhosPagamento"
          :key="'modal-atalho-pagamento-' + atalho.tecla"
        >
          <kbd>{{ atalho.tecla }}</kbd>
          <span>{{ atalho.descricao }}</span>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-calendar" title="Ajustar vencimento" size="sm" centered>
      <div class="mx-auto">
        <b-calendar v-model="vencimentoSelected" locale="pt-BR"></b-calendar>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button @click="cancel()"> Cancelar </b-button>
        <b-button
          variant="primary"
          @click="salvarVencimento"
          ref="transmitir_nfe"
        >
          Salvar
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-ajuste-item"
      title="Ajuste no produto"
      size="sm"
      centered
      @shown="focusAjusteItemInput"
    >
      <div>
        <p class="font-weight-bolder mb-1">
          {{ ajusteItemModal.produto }}
        </p>
        <p class="text-muted mb-4">
          Unitário atual: R$
          {{ numberToReal(ajusteItemModal.precoAtual, "preco") }}
        </p>

        <b-form-group label="Operação">
          <div class="d-flex">
            <b-form-checkbox
              class="mr-4"
              :checked="ajusteItemModal.operacao === 'desconto'"
              @change="setOperacaoAjusteItem('desconto')"
            >
              Desconto
            </b-form-checkbox>
            <b-form-checkbox
              :checked="ajusteItemModal.operacao === 'acrescimo'"
              @change="setOperacaoAjusteItem('acrescimo')"
            >
              Acréscimo
            </b-form-checkbox>
          </div>
        </b-form-group>

        <b-form-group label="Tipo do valor">
          <b-form-radio-group
            v-model="ajusteItemModal.tipo"
            :options="tiposAjusteItem"
            buttons
            button-variant="outline-primary"
            size="sm"
          />
        </b-form-group>

        <b-form-group
          :label="
            ajusteItemModal.tipo === 2
              ? labelOperacaoAjusteItem + ' (%)'
              : labelOperacaoAjusteItem + ' (R$)'
          "
        >
          <b-input-group>
            <template #prepend>
              <b-input-group-text>
                {{ ajusteItemModal.tipo === 2 ? "%" : "R$" }}
              </b-input-group-text>
            </template>
            <b-form-input
              ref="ajusteItemInput"
              v-model="ajusteItemModal.valor"
              type="text"
              autocomplete="off"
              @keyup.enter="aplicarAjusteItem"
            />
          </b-input-group>
          <small class="text-muted">
            Novo unitário: R$
            {{ numberToReal(precoUnitarioComAjusteItem, "preco") }}
          </small>
        </b-form-group>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button @click="cancel()"> Cancelar </b-button>
        <b-button variant="primary" @click="aplicarAjusteItem">
          Aplicar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="identificacaoPAFNFCe" title="Identificação PAF-NFC-e" centered>
      <b-form class="form">
        <b-row align-h="center">
          <b-col>
            <strong> CNPJ: </strong> 49.050.590/0001-56 <br />
            <strong> Nome Fantasia: </strong> NUTS TECNOLOGIA<br />
            <strong> Endereço: </strong> R OSWALDO VALENTIM ZANDAVALLI, 431,
            CENTRO, CONCÓRDIA - SC <br />
            <strong> Telefone: </strong> 49 3550 0600 <br />
            <strong> Contato: </strong> JANIR DE ABREU<br />
            <strong> Nome Comercial: </strong> NUTS <br />
            <strong> Versão:</strong> 01.00<br />
            BANCO DE DADOS NA NUVEM<br />
            PAF-NFC-e NUVEM<br />
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          @click="
            () => {
              cancel();
            }
          "
        >
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="estoqueTotal" title="PAF NFCe - Estoque total" centered>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="primary"
          @click="gerarPAFEstoqueTotal"
          ref="gerarPAFEstoqueTotal"
          class="mr-5"
        >
          Gerar arquivo
        </b-button>
        <b-button
          @click="
            () => {
              cancel();
            }
          "
        >
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="listaPreco" title="Selecionar lista de preço" hide-footer>
      <b-form-group label="Lista de Preço">
        <VueSelect
          ref="pedido"
          :filterable="false"
          :options="listaDePrecos"
          v-model="selectedLista"
          @search="onSearchLista"
        >
          <template slot="no-options">Busque pela descrição</template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.descricao }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.descricao }}
            </div>
          </template>
        </VueSelect>
      </b-form-group>

      <div class="d-flex justify-content-between">
        <b-button
          variant="danger"
          @click="
            selectedLista = null;
            $bvModal.hide('listaPreco');
          "
        >
          Cancelar
        </b-button>
        <b-button variant="primary" @click="$bvModal.hide('listaPreco')">
          Aplicar
        </b-button>
      </div>
    </b-modal>

    <b-modal
      id="modal-calculo-quantidade"
      title="Calcular quantidade pelo valor"
      size="sm"
      centered
      @shown="handleOpenCalculoQuantidadeModal"
    >
      <b-form class="form" @submit.stop.prevent="salvarQuantidadeCalculada">
        <b-form-group
          label="Valor desejado R$"
          label-for="valorCalculoQuantidade"
        >
          <VMoney
            ref="valorCalculoQuantidade"
            class="form-control"
            id="valorCalculoQuantidade"
            name="valorCalculoQuantidade"
            v-model="valorCalculoQuantidade"
            v-bind="configMask"
          />
        </b-form-group>
        <div class="text-muted font-size-sm" v-if="produto">
          Preço unitário: R$
          {{ numberToReal(valorProdutoSelecionado, "preco") }}
        </div>
      </b-form>
      <template #modal-footer="{ cancel }">
        <b-button @click="cancel()"> Cancelar </b-button>
        <b-button variant="primary" @click="salvarQuantidadeCalculada">
          Salvar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="importarPedido" title="Importar Pedido" centered>
      <b-form class="form">
        <b-row align-h="center">
          <b-col>
            <b-form-group
              :key="keyToReRender"
              label="Selecione o(s) pedido(s)"
              label-for="pedido"
            >
              <VueSelect
                multiple
                ref="pedido"
                class="vs-pedido-clean"
                :filterable="false"
                :options="pedidosToImport"
                v-model="selectedPedidos"
                @search="onSearchPedido"
                :close-on-select="false"
              >
                <template slot="no-options"
                  >Busque pelo número do pedido</template
                >
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.numero }} - {{ option.cliente }}
                  </div>
                </template>
                <template slot="selected-option">
                  <span style="display: none"></span>
                </template>
              </VueSelect>
            </b-form-group>

            <div v-if="selectedPedidos && selectedPedidos.length > 0">
              <p class="mb-1" style="font-size: 0.85rem; color: #6c757d">
                {{ selectedPedidos.length }} pedido(s) selecionado(s) para
                importar:
              </p>
              <ul class="list-group">
                <li
                  v-for="(pedido, index) in selectedPedidos"
                  :key="pedido.id_pedido"
                  class="list-group-item d-flex justify-content-between align-items-center py-2 px-3"
                  style="font-size: 0.9rem"
                >
                  <span>
                    <strong>#{{ pedido.numero }}</strong> — {{ pedido.cliente }}
                  </span>
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    style="padding: 0.1rem 0.4rem; font-size: 0.75rem"
                    @click="
                      selectedPedidos = selectedPedidos.filter(
                        (_, i) => i !== index
                      )
                    "
                  >
                    ✕
                  </b-button>
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="primary"
          @click="importarPedido"
          ref="importar_pedido"
        >
          Importar
        </b-button>
        <b-button
          @click="
            () => {
              cancel();
              selectedPedidos = null;
            }
          "
        >
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-pagamento" title="Ajustar pagamento" size="sm" centered>
      <div class="mx-auto">
        <b-form class="form" @submit.stop.prevent="salvarPagamento">
          <VMoney
            @input="changePagamentoEdited"
            class="form-control"
            id="valorPagamento"
            name="valorPagamento"
            v-model="pagamentoEditado"
            v-bind="configMask"
          />
        </b-form>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button @click="cancel()"> Cancelar </b-button>
        <b-button
          variant="primary"
          @click="salvarPagamento"
          ref="transmitir_nfe"
        >
          Salvar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-client-new" title="Adicionar cliente" size="md" centered>
      <b-form-group id="name" label-for="name" label="Nome">
        <b-form-input v-model="newBuyer" />
      </b-form-group>
      <b-form-group id="cnpj_cpf" label-for="cnpj_cpf" label="CPF/CNPJ">
        <Input
          ref="newcpfcnpj"
          id="newcpfcnpj"
          :mask="['###.###.###-##', '##.###.###/####-##']"
          labelBold
          v-model="newBuyerCnpjCpf"
        />
      </b-form-group>
      <template #modal-footer="{ ok, cancel }">
        <b-button @click="cancel()"> Cancelar </b-button>
        <b-button variant="primary" @click="addBuyer" ref="transmitir_nfe">
          Salvar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-client" title="Adicionar cliente" size="md" centered>
      <b-form-group id="name" label-for="name" label="Nome:">
        <VueSelect
          ref="buscarCliente"
          :filterable="false"
          @input="setCliente"
          v-model="selectedCliente.nome"
          :options="clientes"
          @search="onSearchCliente"
        >
          <template slot="no-options"> Informe o nome do cliente </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">{{ option.codigo }} - {{ option.nome }}</div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.label }}
            </div>
          </template>
        </VueSelect>
      </b-form-group>
      <b-form-group id="cnpj_cpf" label-for="cnpj_cpf" label="CPF/CNPJ">
        <Input
          ref="newcpfcnpj"
          id="newcpfcnpj"
          :mask="['###.###.###-##', '##.###.###/####-##']"
          labelBold
          :value="selectedCliente?.cnpj_cpf ?? ''"
        />
      </b-form-group>
      <template #modal-footer="{ ok, cancel }">
        <b-button @click="cancel()"> Cancelar </b-button>
        <b-button variant="primary" @click="saveCliente" ref="salvar-cliente">
          Salvar
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-pos-venda"
      :title="modalTitle"
      size="md"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-row class="text-center" v-if="posStep === 0">
        <b-col class="mt-5">
          <h3>Aguardando pagamento</h3>
        </b-col>
      </b-row>
      <b-row class="text-center" v-if="posStep === 1">
        <b-col cols="12">
          <h3>Selecione o equipamento para finalizar a transação</h3>
        </b-col>
        <b-col md="12">
          <b-form-group>
            <select
              name="equipamento"
              id="equipamento"
              v-model="equipamentosSelecionado"
              class="form-control"
            >
              <option
                v-for="(e, index) in equipamentosPos"
                :value="e"
                :key="'equipamento' + index"
                @input="setEquipamento"
              >
                {{ e.descricao }} - {{ e.serial_pos }}
              </option>
            </select>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-button size="sm" variant="primary" @click="solicitarPagamentoPos">
            Solicitar pagamento
          </b-button>
        </b-col>
      </b-row>
      <b-row class="text-center" v-if="posStep === 2">
        <b-col>
          <h3>Atualizando dados da {{ isNfce ? "NFCe" : "Pré-venda" }}</h3>
        </b-col>
      </b-row>
      <b-row class="text-center" v-if="posStep === 3">
        <b-col>
          <h3>Imprimindo {{ isNfce ? "NFCe" : "Pré-venda" }}...</h3>
        </b-col>
      </b-row>
      <b-row class="text-center" v-if="posStep === 5">
        <b-col>
          <h3>Salvando a venda...</h3>
        </b-col>
      </b-row>
      <b-row class="text-center" v-if="posStep === 6">
        <b-col>
          <h3>Comunicando com TEFWeb...</h3>
        </b-col>
        <b-col md="12">
          <b-button size="sm" variant="primary" @click="cancelarPagamentoPos">
            Cancelar solicitação
          </b-button>
        </b-col>
      </b-row>
      <b-row class="text-center mt-5 mb-5" v-if="!isLoadingPosData">
        <b-col>
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel, hide }">
        <div></div>
      </template>
    </b-modal>

    <b-modal
      id="modal-pos-cartao"
      title="Informação de dados do Cartão"
      size="md"
      centered
    >
      <b-row>
        <b-col>
          <b-form-group
            label-for="Administradora"
            label="Administradora"
            class="mr-5"
          >
            <VueSelect
              label="bandeira_"
              :filterable="false"
              v-model="selectedAdmnistradora"
              :options="administradoras"
              @search="onSearchAdmin"
            >
              <template slot="no-options"> Selecione a admnistradora </template>
              <template slot="option" slot-scope="option">
                <div class="d-center">
                  {{ option.nome }}
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                  {{ option.nome }}
                </div>
              </template>
            </VueSelect>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label-for="Bandeira do cartão"
            label="Bandeira do cartão"
            class="mr-5"
          >
            <VueSelect
              label="bandeira_"
              :filterable="false"
              v-model="selectedBandeira"
              :options="bandeiras"
            >
              <template slot="no-options"> Selecione a bandeira </template>
              <template slot="option" slot-scope="option">
                <div class="d-center">
                  {{ option.descricao }}
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                  {{ option.descricao }}
                </div>
              </template>
            </VueSelect>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label-for="Código de transação (NSU)"
            label="Código de transação (NSU)"
            class="mr-5"
          >
            <b-form-input
              v-model="codigoNsu"
              id="nsu"
              autocomplete="off"
              maxLength="20"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="secondary" @click="cancel()">
          Cancelar
        </b-button>
        <b-button
          size="sm"
          variant="secondary"
          @click="
            () => {
              ok();
              handleSaveCardInfo();
            }
          "
        >
          Salvar
        </b-button>
      </template>
    </b-modal>

    <b-modal
      @shown="handleOpenModal"
      @show="isPagamentoModalOpen = true"
      @hidden="handleClosePagamentoModal"
      id="modal-forma-pagamento"
      title="Defina a forma de pagamento"
      size="lg"
      modal-class="pdv-payment-modal"
      body-class="pdv-payment-modal-body"
      static
      centered
    >
      <b-row class="pdv-payment-form-row align-items-end">
        <b-col class="busca" col md="5">
          <div class="font-weight-bolder font-size-lg mb-3">
            Forma de Pagamento
          </div>
          <VueSelect
            label="descricao"
            v-model="pagamento"
            class="busca-cliente"
            ref="buscaPagamentos"
            :options="pagamentosModalOptions || pagamentos"
            @input="changePagamentos"
          >
          </VueSelect>
        </b-col>
        <b-col md="4">
          <div class="font-weight-bolder font-size-lg mb-3" ref="teste2">
            Valor
          </div>
          <Money
            ref="valorPagamentoModal"
            id="valorPagamentoModal"
            labelBold
            inputClass="form-control input"
            :onEnter="adicionarPagamento"
            @click.native="selecionarValorPagamentoModal"
            v-model="valorPgto"
          />
        </b-col>
        <b-col md="3">
          <b-button
            size="sm"
            variant="primary"
            class="pdv-payment-add-button"
            @click="adicionarPagamento"
          >
            (Enter) Adicionar
          </b-button>
        </b-col>
      </b-row>
      <div class="pdv-payment-shortcuts mt-3">
        <button
          type="button"
          class="pdv-payment-shortcuts__item"
          v-for="atalho in atalhosPagamento"
          :key="'modal-pagamento-' + atalho.tecla"
          @click="adicionarPagamentoPorAtalho(atalho.tecla.toLowerCase())"
        >
          <strong>{{ atalho.tecla }}</strong>
          <span>{{ atalho.descricao }}</span>
        </button>
      </div>
      <div class="pdv-payment-list-scroll" v-if="listaPagamentos.length > 0">
        <b-row class="form-group mb-0">
          <b-col class="busca">
            <b-row
              v-for="(pagamento, key) in listaPagamentos"
              :key="'pagamento' + key"
            >
              <div class="pdv-payment-item-header">
                <p class="font-weight-bolder font-size-lg mb-0">
                  {{ pagamento.descricao }}
                </p>
                <a
                  v-b-tooltip="'Remover pagamento'"
                  href="javascript:"
                  @click="removePagamento(key)"
                  class="remove-pgto"
                >
                  <Close />
                </a>
              </div>
              <div style="width: 100%">
                <TableApp
                  item="pagamento"
                  subTitulo=""
                  :data="pagamento.range"
                  :fields="fields"
                  classFilterColumn="valor"
                  ref="pagamentoTable"
                  v-if="pagamento !== null && pagamento?.descricao !== 'Nenhum'"
                >
                  <template slot="customRow" scope="props">
                    <span
                      slot="nome"
                      class="pl-0 pt-8"
                      v-if="props.field == 'id'"
                    >
                      <div class="d-flex align-items-center">
                        <div class="font-weight-bold text-muted">
                          {{ props.rowData.originalIndex + 1 }}
                        </div>
                      </div>
                    </span>
                    <span
                      slot="nome"
                      class="pl-0 pt-8"
                      v-if="props.field == 'valor'"
                    >
                      <div class="d-flex align-items-center">
                        <div
                          v-b-modal="
                            isPagamentoCreditoCliente(pagamento)
                              ? null
                              : 'modal-pagamento'
                          "
                          @click="
                            changePagamento(props.rowData.originalIndex, key)
                          "
                          :class="[
                            'font-weight-bold text-muted',
                            isPagamentoCreditoCliente(pagamento)
                              ? ''
                              : 'cursor-pointer',
                          ]"
                        >
                          {{ numberToReal(props.rowData.value) }}
                        </div>
                      </div>
                    </span>
                    <span
                      slot="quantidade"
                      class="pl-0 pt-8"
                      v-if="props.field == 'vencimento'"
                    >
                      <div class="d-flex align-items-center">
                        <div
                          v-b-modal="
                            isPagamentoCreditoCliente(pagamento)
                              ? null
                              : 'modal-calendar'
                          "
                          :class="[
                            'font-weight-bold text-muted',
                            isPagamentoCreditoCliente(pagamento)
                              ? ''
                              : 'cursor-pointer',
                          ]"
                          @click="
                            selectVencimento(
                              props.rowData.originalIndex,
                              props.rowData.date,
                              key
                            )
                          "
                        >
                          {{ props.rowData.date | moment("DD/MM/YYYY") }}
                        </div>
                      </div>
                    </span>
                  </template>
                </TableApp>
              </div>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <b-row class="pdv-payment-summary border-top">
        <div class="col-md-10">
          <div class="d-flex justify-content-center flex-column mt-5">
            <span class="font-size-lg font-weight-bolder mb-1">SUBTOTAL</span>
            <span class="font-size-h2-plus font-weight-boldest mb-1"
              >R$ {{ valorReal(valorTotal) }}</span
            >
            <span
              class="text-primary font-size-h5-plus font-weight-boldest mb-1"
              v-if="store.productOfTradeCollection.length > 0"
            >
              Total de Itens:
              {{
                store.productOfTradeCollection.reduce(
                  (acc, produto) => acc + produto.quantity,
                  0
                )
              }}</span
            >
            <span class="text-success font-size-h3" v-if="descontoAplicado"
              >Desconto:
              {{
                tipoDescontoValue === 1
                  ? `R$
              ${valorReal(valueDiscount)}`
                  : `${valorReal(valueDiscount)}%`
              }}</span
            >
            <span class="text-danger font-size-h3" v-if="acrescimoAplicado"
              >Acréscimo:
              {{
                tipoAcrescimoValue === 1
                  ? `R$
              ${valorReal(valueExtraValue)}`
                  : `${valorReal(valueExtraValue)}%`
              }}</span
            >
            <span class="font-size-h3 text-success" v-if="valorPago > 0"
              >Valor Pago: R$ {{ valorReal(valorPago) }}</span
            >
            <span class="font-size-h3" v-if="troco > 0 && !valorPago"
              >Troco: R$ {{ valorReal(troco) }}</span
            >
            <span
              class="font-size-h3"
              v-if="parseFloat(valorPago) - parseFloat(total) > 0"
              >Troco: R$
              {{ valorReal(parseFloat(valorPago) - parseFloat(total)) }}</span
            >
          </div>
        </div>
        <div>
          <input
            style="
              caret-color: transparent;
              margin-top: -20px;
              position: absolute;
            "
            ref="finishModal"
            @keypress.enter.prevent="
              () => {
                fromPagamentoModal = true;
                justSave
                  ? handleSalvarVenda(false)
                  : handleFinalizar(transmitir);
              }
            "
          />
        </div>
      </b-row>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="secondary" @click="cancel()">
          Cancelar
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="
            () => {
              fromPagamentoModal = true;
              justSave ? handleSalvarVenda(false) : handleFinalizar(transmitir);
            }
          "
        >
          (F5) Finalizar
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="caixa-modal"
      title=""
      size="md"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <template #modal-header="{ ok, cancel }">
        <h4 class="text-dark">Abertura de caixa</h4>
      </template>
      <b-row>
        <b-col class="mt-5">
          <b-form-group label-for="caixaValorAbertura" label="Valor Caixa R$">
            <VMoney
              class="form-control"
              id="caixaValorAbertura"
              name="caixaValorAbertura"
              v-model="caixaValorAbertura"
              v-bind="configMask"
            />
          </b-form-group>
        </b-col>
        <b-col class="mt-5">
          <b-form-group
            label-for="caixaImpressaoComprovante"
            label="Imprimir comprovante"
          >
            <span class="switch switch-icon">
              <label v-b-tooltip.hover.right="'Imprimir comprovante?'">
                <input type="checkbox" v-model="caixaImpressaoComprovante" />
                <span></span>
              </label>
            </span>
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="primary"
          @click="
            () => {
              ok();
              abrirCaixa();
            }
          "
          ref="salvar-cliente"
        >
          Salvar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="importarOS" title="Importar OS" centered>
      <b-form class="form">
        <b-row align-h="center">
          <b-col>
            <b-form-group
              :key="keyToReRender"
              label="Selecione a(s) OS"
              label-for="os"
            >
              <VueSelect
                multiple
                ref="os"
                class="vs-pedido-clean"
                :filterable="false"
                :options="osToImport"
                v-model="selectedOS"
                @search="onSearchOS"
                :close-on-select="false"
              >
                <template slot="no-options"> Informe a OS</template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.numero }} - {{ option.cliente }}
                  </div>
                </template>
                <template slot="selected-option">
                  <span style="display: none"></span>
                </template>
              </VueSelect>
            </b-form-group>

            <div v-if="selectedOS && selectedOS.length > 0">
              <p class="mb-1" style="font-size: 0.85rem; color: #6c757d">
                {{ selectedOS.length }} OS selecionada(s) para importar:
              </p>
              <ul class="list-group">
                <li
                  v-for="(os, index) in selectedOS"
                  :key="os.id_ordem_servico"
                  class="list-group-item d-flex justify-content-between align-items-center py-2 px-3"
                  style="font-size: 0.9rem"
                >
                  <span>
                    <strong>#{{ os.numero }}</strong> — {{ os.cliente }}
                  </span>
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    style="padding: 0.1rem 0.4rem; font-size: 0.75rem"
                    @click="
                      selectedOS = selectedOS.filter((_, i) => i !== index)
                    "
                  >
                    ✕
                  </b-button>
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer="{ ok, cancel }">
        <b-button variant="primary" @click="importarOS" ref="importar_os">
          Importar
        </b-button>
        <b-button
          @click="
            () => {
              cancel();
              selectedOS = null;
            }
          "
        >
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="importarOrcamento" title="Importar Orçamento" centered>
      <b-form class="form">
        <b-row align-h="center">
          <b-col>
            <b-form-group
              :key="keyToReRender"
              label="Selecione o(s) orçamento(s)"
              label-for="orcamento"
            >
              <VueSelect
                multiple
                ref="orcamento"
                class="vs-pedido-clean"
                :filterable="false"
                :options="orcamentosToImport"
                v-model="selectedOcamentos"
                @search="onSearchOrcamento"
                :close-on-select="false"
              >
                <template slot="no-options">Informe o orçamento</template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.numero }} - {{ option.cliente }}
                  </div>
                </template>
                <template slot="selected-option">
                  <span style="display: none"></span>
                </template>
              </VueSelect>
            </b-form-group>

            <div v-if="selectedOcamentos && selectedOcamentos.length > 0">
              <p class="mb-1" style="font-size: 0.85rem; color: #6c757d">
                {{ selectedOcamentos.length }} orçamento(s) selecionado(s) para
                importar:
              </p>
              <ul class="list-group">
                <li
                  v-for="(orc, index) in selectedOcamentos"
                  :key="orc.id_orcamento"
                  class="list-group-item d-flex justify-content-between align-items-center py-2 px-3"
                  style="font-size: 0.9rem"
                >
                  <span>
                    <strong>#{{ orc.numero }}</strong> — {{ orc.cliente }}
                  </span>
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    style="padding: 0.1rem 0.4rem; font-size: 0.75rem"
                    @click="
                      selectedOcamentos = selectedOcamentos.filter(
                        (_, i) => i !== index
                      )
                    "
                  >
                    ✕
                  </b-button>
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="primary"
          @click="importarOrcamento"
          ref="importar_orcamento"
        >
          Importar
        </b-button>
        <b-button
          @click="
            () => {
              cancel();
              selectedOcamentos = null;
            }
          "
        >
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <VariacaoProdutoModal
      :addProduto="() => adicionarProduto()"
      :produto="produto"
      :preco="formatNumberToFloat(price)"
      @onAddProduto="onAddProdutoFromVariacao"
    />

    <LoteProdutoModal
      :addProduto="() => adicionarProduto()"
      :produto="produto"
      :preco="formatNumberToFloat(price)"
      :compra="false"
      :atualizarLotes="atualizarLotes"
      @onAddProduto="onAddProdutoFromLote"
    />

    <RetornavelProdutoModal ref="retornavelProdutoModal" />
    <EmbalagemProdutoModal ref="embalagemProdutoModal" />

    <b-modal
      id="modal-produto-fiscal-pdv"
      v-model="produtoFiscalModalOpen"
      title="Editar dados fiscais do produto"
      size="xl"
      centered
      modal-class="pdv-produto-fiscal-modal"
      body-class="pdv-produto-fiscal-body"
      @hidden="closeModalProdutoFiscalPDV"
    >
      <b-row>
        <b-col md="4">
          <b-form-group label="Perfil Tributário">
            <VueSelect
              placeholder="Digite o nome para pesquisar"
              label="descricao"
              :filterable="false"
              :options="perfisTributariosPDV"
              v-model="produtoFiscalForm.perfil_tributario"
              @input="setPerfilTributarioPDV"
              @open="onSearchPerfilTributarioPDV"
              @search="onSearchPerfilTributarioPDV"
              :clearable="true"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3">
          <b-form-group label="CST/CSOSN não contribuinte">
            <VueSelect
              placeholder="Digite o código para pesquisar"
              label="codigo"
              :options="cstcsosnsPDV"
              v-model="produtoFiscalForm.cst_csosn"
              :clearable="true"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="CST/CSOSN contribuinte">
            <VueSelect
              placeholder="Digite o código para pesquisar"
              label="codigo"
              :options="cstcsosnsPDV"
              v-model="produtoFiscalForm.cst_csosn_contribuinte"
              :clearable="true"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="CFOP NFe">
            <VueSelect
              placeholder="Digite o código para pesquisar"
              label="codigo"
              :filterable="false"
              :options="cfopsPDV"
              v-model="produtoFiscalForm.cfop"
              @search="onSearchCFOPPDV"
              :clearable="true"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="CFOP NFCe">
            <VueSelect
              placeholder="Digite o código para pesquisar"
              label="codigo"
              :filterable="false"
              :options="cfopsNfcePDV"
              v-model="produtoFiscalForm.cfop_nfce"
              @search="onSearchCFOPNfcePDV"
              :clearable="true"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group label="CEST">
            <VueSelect
              placeholder="Digite o código para pesquisar"
              label="codigo"
              :filterable="false"
              :options="cestsPDV"
              v-model="produtoFiscalForm.cest"
              @search="onSearchCESTPDV"
              :clearable="true"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="NCM">
            <VueSelect
              placeholder="Digite o código para pesquisar"
              label="codigo"
              :filterable="false"
              :options="ncmsPDV"
              v-model="produtoFiscalForm.ncm"
              @search="onSearchNCMPDV"
              :clearable="true"
            >
              <template slot="no-options">
                Informe o código do NCM
              </template>
              <template slot="option" slot-scope="option">
                <div class="d-center">
                  {{ option.codigo + " - " + option.descricao }}
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                  {{ option.codigo }}
                </div>
              </template>
            </VueSelect>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="Exceção Fiscal">
            <b-form-input v-model="produtoFiscalForm.excecaoFiscal" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4">
          <b-form-group label="CENQ">
            <VueSelect
              placeholder="Digite o código para pesquisar"
              label="codigo"
              :filterable="false"
              :options="cenqsPDV"
              v-model="produtoFiscalForm.cenq"
              @search="onSearchCENQPDV"
              :clearable="true"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="CST IPI">
            <VueSelect
              placeholder="Digite o código para pesquisar"
              label="codigo"
              :filterable="false"
              :options="cstipisPDV"
              v-model="produtoFiscalForm.cst_ipi"
              @search="onSearchCSTIPIPDV"
              :clearable="true"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="CST PIS">
            <VueSelect
              placeholder="Digite o código para pesquisar"
              label="codigo"
              :filterable="false"
              :options="cstspisPDV"
              v-model="produtoFiscalForm.cst_pis"
              @search="onSearchCSTPISPDV"
              :clearable="true"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3">
          <b-form-group label="CST COFINS">
            <VueSelect
              placeholder="Digite o código para pesquisar"
              label="codigo"
              :filterable="false"
              :options="cstscofinsPDV"
              v-model="produtoFiscalForm.cst_cofins"
              @search="onSearchCSTCOFINSPDV"
              :clearable="true"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Tributação">
            <VueSelect
              label="descricao"
              :options="tributacoesPDV"
              v-model="produtoFiscalForm.tributacao"
              :clearable="true"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Tributação ST">
            <VueSelect
              label="descricao"
              :options="tributacoesPDV"
              v-model="produtoFiscalForm.tributacao_s_t"
              :clearable="true"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="FCP">
            <VueSelect
              label="descricao"
              :options="tributacoesPDV"
              v-model="produtoFiscalForm.fcp"
              :clearable="true"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="2">
          <b-form-group label="% IPI">
            <VMoney
              class="form-control"
              v-model="produtoFiscalForm.ipi"
              v-bind="configMask"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="% PIS">
            <VMoney
              class="form-control"
              v-model="produtoFiscalForm.pis"
              v-bind="configMask"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="% COFINS">
            <VMoney
              class="form-control"
              v-model="produtoFiscalForm.cofins"
              v-bind="configMask"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="% MVA">
            <VMoney
              class="form-control"
              v-model="produtoFiscalForm.mva"
              v-bind="configMask"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Código Benefício">
            <b-form-input
              v-model="produtoFiscalForm.codigo_beneficio"
              maxlength="20"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ cancel }">
        <b-button @click="cancel()">Cancelar</b-button>
        <b-button
          variant="primary"
          :disabled="isSavingProdutoFiscalPDV"
          @click="salvarProdutoFiscalPDV"
        >
          Salvar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { watch } from "vue";
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "vue-loading-overlay/dist/vue-loading.css";
import { REMOVE_BODY_CLASSNAME } from "@/core/services/store/htmlclass.module.js";
import { SET_MOSTRAR_ATALHOS_PDV } from "@/core/services/store/auth.module.js";
import {
  MONEY as settingMoney,
  priceOptions,
  quantityOptions,
} from "@/modules/Application";
import _ from "lodash";
import { CardBusca, CardItensVenda } from "../../Pdv/components/Cards";
import { notificationStore } from "@/notificationStore";
import PdvVendaProduto from "../../Pdv/pages/PdvVendaProduto";
import FormatMixin from "../../Application/mixins/FormatMixin";
import InstallmentsMixin from "../../Application/mixins/InstallmentsMixin";
import EmitenteMixin from "../../Application/mixins/EmitenteMixin";
import ValidacaoMixin from "../../Application/mixins/ValidacaoMixin";
import PessoaMixin from "@/modules/Application/mixins/PessoaMixin";
import PagamentosMixin from "../../Pdv/mixins/PagamentosMixin";
import ConfiguracaoMixin from "../../Pdv/mixins/ConfiguracaoMixin";
import balancaService from "@/core/services/balanca.service";
import balancaTerminalService from "@/core/services/balanca-terminal.service";
import Money, { Select } from "../../Pdv/components/Form";
import PdvData from "../../Pdv/pages/PdvData";
import { Input } from "@/components/Form";
import TableApp from "@/components/Table/Table3.vue";
import Close from "vue-material-design-icons/Close";
import NumberInput from "../../../components/Form/NumberInput.vue";
import swal from "sweetalert";
import { TECLAS } from "../../Pdv/enums/Documento";
import { store } from "../storeVenda";
import { Money as VMoney } from "v-money";
import { onboardStore } from "../../../onboardStore";
import { adminPermissionStore } from "@/adminPermissionStore";
import { SistemaMixin } from "@/modules/Application";
import FilterOutline from "vue-material-design-icons/Filter";
import Fullscreen from "vue-material-design-icons/Fullscreen.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import DotsHorizontal from "vue-material-design-icons/DotsHorizontal.vue";
import Plus from "vue-material-design-icons/PlusThick.vue";
import CalculatorVariantOutline from "vue-material-design-icons/CalculatorVariantOutline.vue";
import ScaleBathroom from "vue-material-design-icons/ScaleBathroom.vue";
import VariacaoProdutoModal from "@/components/VariacaoProdutoModal";
import InformationOutline from "vue-material-design-icons/InformationOutline.vue";
import LoteProdutoModal from "@/components/LoteProdutoModal";
import CloseCircleOutline from "vue-material-design-icons/CloseCircleOutline.vue";
import TagOutline from "vue-material-design-icons/TagOutline.vue";
import RetornavelProdutoModal from "@/components/RetornavelProdutoModal.vue";
import EmbalagemProdutoModal from "@/components/EmbalagemProdutoModal.vue";
import RecebimentoParcialModal from "@/modules/ContaReceber/components/RecebimentoParcialModal.vue";
import {
  atualizarVasilhameDoItem,
  dividirItemRetornavel,
  produtoExigeRetorno,
} from "@/modules/Application/Retornavel";

const LS_KEY = "nuts.filtrosOrdenacao.v1";
const CONDICIONAL_PDV_IMPORT_KEY_PREFIX =
  "nuts.condicionalMercadoria.pdvImport.";

export default {
  name: "app-venda",
  props: {
    url: {
      type: String,
    },
    nfe: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      store,
      sangria_suprimento_comprovante: true,
      isSavingSangriaSuprimento: false,
      caixaOperacao: null,
      pedidos: [],
      os: [],
      selectedPedidos: null,
      selectedLista: null,
      pedidosToImport: [],
      listaDePrecos: [],
      keyToRender: 0,
      caixaValorOperacao: null,
      descricaoOperacao: null,
      fromPagamentoModal: false,
      isPagamentoModalOpen: false,
      caixaImpressaoComprovante: false,
      caixaValorAbertura: null,
      caixaAberturaHorario: null,
      isCaixaFechadoManual: false,
      caixa: null,
      caixaInfo: {
        dados_abertura: {
          valor_abertura: 0,
        },
        pagamentos: [],
        pagamentos_usados: [],
        sangria: 0,
        suprimento: 0,
        total: 0,
        total_da_gaveta: 0,
        total_venda_na_gaveta: 0,
        total_venda_nao_gaveta: 0,
        total_vendas_canceladas: 0,
        total_contas_recebidas: 0,
      },
      isFullScreen: false,
      onboardStore,
      quantityOptions,
      priceOptions,
      windowWidth: window.innerWidth,
      isNfce: false,
      venda: {},
      paymentCardListIndex: 0,
      notificationStore,
      posStep: 0,
      isLoadingPosData: false,
      formCartaoInfo: {
        administradora: { cnpj_cpf: null },
        bandeira: null,
        autorizacao: null,
      },
      nota: {
        id: null,
        data: null,
      },
      teclasEnum: TECLAS,
      selectedCliente: {},
      quantity: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        precision: 2,
        masked: true,
      },
      vencimentoSelected: null,
      selectedPagamento: {
        pagamento: 0,
        parcelaIndex: 0,
      },
      codigoNsu: null,
      selectedBandeira: null,
      selectedAdmnistradora: null,
      newBuyer: null,
      newBuyerCnpjCpf: null,
      indexVencimento: 0,
      acrescimoAplicado: false,
      descontoAplicado: false,
      pagamentoEditado: 0,
      configMask: settingMoney,
      quantidade: 1,
      price: 1.0,
      produtos: [],
      ultimoProduto: {},
      produto: null,
      desconto: 0,
      acrescimo: 0,
      discount: 0,
      valueCliente: {},
      creditoClienteSaldo: 0,
      creditoClienteValor: 0,
      creditoClienteAplicado: false,
      creditoClienteFormaPagamento: null,
      creditoClienteVouchers: [],
      creditoClienteVoucherSelecionado: null,
      paymentsCartao: [],
      bandeiras: [],
      administradoras: [],
      clientes: [],
      pagamentos: [],
      pagamento: {},
      valorPagoVenda: 0,
      valorTotal: "0",
      listaPagamentos: [],
      receberContaBusca: "",
      receberContaLoading: false,
      receberContaResultados: [],
      receberContaSelecionadas: [],
      receberContaFormaPagamento: null,
      isRecebendoContaPdv: false,
      isLoadingRecebimentoParcialPdv: false,
      receberContaBancos: [{ id_banco: 99999, nome: "Movimento Caixa" }],
      receberContaMeiosPagamentoParcial: [],
      receberContaFields: [
        { key: "selecionar", label: "", thStyle: { width: "40px" } },
        { key: "cliente", label: "Cliente" },
        { key: "documento", label: "Doc." },
        { key: "historico", label: "Descrição" },
        { key: "data_vencimento", label: "Vencimento" },
        { key: "valor_receber", label: "Valor" },
      ],
      pagamentoImportacaoBloqueado: false,
      produtosSnapshotAposImport: null,
      listaFormaPagamentos: [],
      pagamentosEditados: [],
      listaMeiosPagamento: [],
      solicitarDadosCartao: false,
      valueMeioPagamento: null,
      pagamentoNoCartao: false,
      atalhoPagamentoSelecionado: null,
      atalhoPagamentoPendente: null,
      pagamentosModalOptions: null,
      atalhosPagamento: [
        { tecla: "F1", descricao: "C. Débito" },
        { tecla: "F2", descricao: "C. Crédito" },
        { tecla: "F3", descricao: "Pix" },
        { tecla: "F4", descricao: "À vista" },
      ],
      parcela: null,
      operacao: "",
      valorPgto: 0,
      tipos: [
        {
          value: 1,
          text: "Valor R$",
        },
        {
          value: 2,
          text: "Percentual",
        },
      ],
      isPercent: false,
      tipoAcrescimo: null,
      tipoDescontoValue: 1,
      tipoAcrescimoValue: 1,
      modoAtacadoAtivo: false,
      descontoAcrescimoAberto: false,
      percentDiscount: 0,
      valueDiscount: 0,
      integracaoPos: false,
      equipamentosPos: [],
      equipamentosSelecionado: {},
      valueExtraValue: 0,
      percentExtraValue: 0,
      statusVenda: 1,
      typeFilter: 3,
      id: null,
      fields: [
        {
          label: "",
          field: "id",
          slot: true,
          width: "10%",
          sortable: false,
        },
        {
          label: "Valor R$",
          field: "valor",
          slot: true,
          width: "45%",
          sortable: false,
        },
        {
          label: "Vencimento",
          field: "vencimento",
          slot: true,
          sortable: false,
          width: "45%",
        },
      ],
      isLoadingSubmit: false,
      listaStatus: [
        {
          id: 1,
          descricao: "Editando",
        },
        {
          id: 7,
          descricao: "Finalizada (Movimenta estoque)",
        },
      ],
      statusSelecionado: null,
      configuracaoPadraoPdvWeb: null,
      seriePadraoPdvWeb: null,
      idConfiguracaoPadraoPdvWeb: null,
      informacoesComplementares: null,
      utilizarSempreReferencia: false,
      vendedores: [],
      filterable: false,
      transmitir: false,
      justSave: false,
      solicitadoPagamentoPos: false,
      limiteCreditoAtigindo: false,
      limiteCreditoAtual: false,
      valorLimiteCredito: 0,
      valorLimiteCreditoAtingido: 0,
      osToImport: null,
      selectedOS: null,
      orcamentosToImport: [],
      selectedOcamentos: null,
      orcamentos: [],
      searchCodeBar: null,
      idPessoaLista: null,
      atualizarLotes: 0,
      descontoPedido: 0,
      descontoPedidoAplicado: false,
      discountPedidoImportado: 0,
      keyToReRender: 0,
      valorCalculoQuantidade: 0,
      sortField: "descricao", // 'preco' | 'descricao'
      sortDir: "ASC",
      isSavingShortcut: false,
      descontoItemPedido: false,
      tiposAjusteItem: [
        {
          text: "%",
          value: 2,
        },
        {
          text: "R$",
          value: 1,
        },
      ],
      ajusteItemModal: {
        index: null,
        produto: "",
        operacao: "desconto",
        tipo: 2,
        valor: "",
        precoBase: 0,
        precoOriginal: 0,
        precoAtual: 0,
      },
      vendaImportadaCondicional: false,
      produtoFiscalModalOpen: false,
      produtoFiscalForm: {},
      perfisTributariosPDV: [],
      cstcsosnsPDV: [],
      cfopsPDV: [],
      cfopsNfcePDV: [],
      cestsPDV: [],
      ncmsPDV: [],
      cenqsPDV: [],
      cstipisPDV: [],
      cstspisPDV: [],
      cstscofinsPDV: [],
      tributacoesPDV: [],
      isSavingProdutoFiscalPDV: false,
    };
  },
  mixins: [
    FormatMixin,
    PagamentosMixin,
    InstallmentsMixin,
    ConfiguracaoMixin,
    PessoaMixin,
    EmitenteMixin,
    ValidacaoMixin,
    SistemaMixin,
  ],
  components: {
    CardBusca,
    CardItensVenda,
    Money,
    VMoney,
    Select,
    VueSelect,
    Input,
    Close,
    TableApp,
    NumberInput,
    FilterOutline,
    Fullscreen,
    TrashCanIcon,
    Plus,
    CalculatorVariantOutline,
    ScaleBathroom,
    DotsHorizontal,
    VariacaoProdutoModal,
    RecebimentoParcialModal,
    InformationOutline,
    Keypress: () => import("vue-keypress"),
    LoteProdutoModal,
    CloseCircleOutline,
    TagOutline,
    RetornavelProdutoModal,
    EmbalagemProdutoModal,
  },
  watch: {
    "venda.observation"(newValue) {},
    pagamentos: {
      handler(listaPagamentos) {
        if (listaPagamentos.length === 0) return;
        this.pagamento = this.pagamentos.find(
          (pagamento) =>
            pagamento.descricao === "À vista" ||
            pagamento.descricao === "A vista"
        );
      },
      deep: true,
    },
    paymentCardListIndex: {
      handler(index) {
        if (index === 0) return;
        if (this.solicitarDadosCartao && index !== this.paymentsCartao.length) {
          this.$bvModal.hide("modal-pos-cartao");
          return;
        }
        this.handlePosPagamento();
      },
    },
    "notificationStore.lastPosNotification": {
      handler(value) {
        if (!_.isEmpty(value)) {
          this.handlePosPagamento();
        }
      },
      deep: true,
    },
    nfe(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.aplicarVendaEdicao(newValue);
      }
    },
    cliente(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.valueCliente = newValue;
      }
    },
    pagamentosVenda(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listaPagamentos = newValue;
      }
    },
    total(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.valorTotal = newValue;
        this.checkValorPago();
      }
    },
    quantidade(newValue, oldValue) {
      if (oldValue !== newValue && this.produto) {
        // Se newValue for número, usa direto; se for string, faz o replace
        let valueFormatted =
          typeof newValue === "number"
            ? newValue.toString()
            : newValue.replaceAll(".", "").replace(",", ".");

        const atacadoHabilitado = this.produto.atacado_pdv_habilitado;
        const usaEmbalagem = Boolean(this.produto.embalagem_selecionada);
        const isAtacado =
          !usaEmbalagem &&
          this.produtoAtendeRegraAtacado(
            this.produto,
            valueFormatted,
            atacadoHabilitado
          );
        const precoListaCliente = parseFloat(
          this.produto?.preco_lista_cliente ?? 0
        );
        const precoNormal = this.getPrecoNormalProdutoPdv(this.produto);
        const precoAplicado = usaEmbalagem
          ? Number(this.produto.embalagem_selecionada.preco) || 0
          : precoListaCliente > 0
            ? precoListaCliente
            : isAtacado
            ? parseFloat(this.produto.preco_atacado)
            : precoNormal;

        this.price = this.valorReal(
          this.roundTo2Digits(precoAplicado, this.priceOptions.precision),
          true
        );

        const total = parseFloat(valueFormatted) * this.valorUS(this.price);
        this.produto.total = total;
        this.produto.tipo_atacado = isAtacado && precoListaCliente <= 0;
        this.produto.quantidade = newValue;
      }
    },
    valorPago(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.valorPagoVenda = newValue;
        this.checkValorPago();
      }
    },
    formasPagamento(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listaFormaPagamentos = newValue;
      }
    },
    discount(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.valueDiscount = newValue;
      }
    },
    extraValue(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.valueExtraValue = newValue;
      }
    },
    qtyPrec: "applyPrecisions",
    pricePrec: "applyPrecisions",
  },
  async mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }

    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }

    setTimeout(() => {
      this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    }, 2000);
    this.applyPrecisions();
    this.getPagamentos();
    this.getMeiosPagamento();
    await this.carregarConfiguracaoPadraoPdvWeb(true);
    await this.novaVenda();
    if (this.$route.params.id) {
      // A venda pode ter sido carregada enquanto novaVenda() ainda inicializava
      // o formulário. Reaplica o valor atual para não perder os produtos nesse caso.
      this.aplicarVendaEdicao(this.nfe);
    }
    this.$nextTick(() => this.registrarLeitorProduto());
    this.aplicarImportacaoCondicionalPdv();
    this.restorePrefs();
    // Observa mudanças e salva (leve debounce pra evitar gravações em excesso)
    this.$watch(
      () => ({
        typeFilter: this.typeFilter,
        sortField: this.sortField,
        sortDir: this.sortDir,
      }),
      this.persistPrefsDebounced,
      { deep: true }
    );
    this.__onKey = async (e) => {
      const key = (e.key || "").toLowerCase();
      const hasCombo = e.ctrlKey || e.metaKey; // Ctrl (Win/Linux) ou Cmd (Mac)

      // Evita repetição segurando a tecla
      if (e.repeat) return;

      if (key === "f5" && !this.canUsePagamentoShortcuts()) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        return;
      }

      const canUsePagamentoShortcuts = this.canUsePagamentoShortcuts();

      if (
        canUsePagamentoShortcuts &&
        this.pagamentosModalOptions &&
        ["arrowup", "arrowdown", "enter", "escape"].includes(key)
      ) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        this.handleCreditoDropdownKey(key);
        return;
      }

      if (
        canUsePagamentoShortcuts &&
        ["f1", "f2", "f3", "f4", "f5"].includes(key)
      ) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        this.adicionarPagamentoPorAtalho(key);
        return;
      }

      if (
        canUsePagamentoShortcuts &&
        key === "enter" &&
        !this.pagamentosModalOptions &&
        document.activeElement?.id !== "valorPagamentoModal" &&
        this.listaPagamentos.length > 0 &&
        parseFloat(this.valorPago) >= parseFloat(this.total)
      ) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        this.confirmarPagamentoModal();
        return;
      }

      // (opcional) ignore atalhos enquanto digitando:
      const tag =
        (document.activeElement && document.activeElement.tagName) || "";
      const typing = ["INPUT", "TEXTAREA", "SELECT"].includes(tag);

      // ── Atalhos gerais do PDV (Ctrl/Cmd + letra) ─────────────────────
      // Bloqueados enquanto há modal/sidebar aberto ou foco em campo editável.
      // preventDefault() evita o comportamento padrão do navegador
      // (ex.: Ctrl+F buscar, Ctrl+P imprimir, Ctrl+O abrir).
      if (hasCombo && !typing && !this._algumModalAberto()) {
        switch (key) {
          case "l": // Lista de preço
            e.preventDefault();
            this.$bvModal.show("listaPreco");
            return;
          case "o": // Importar Orçamento
            e.preventDefault();
            this.buscarOrcamentos();
            return;
          case "r": // Receber conta
            e.preventDefault();
            this.abrirModalReceberContaPdv();
            return;
          case "p": // Importar Pedido
            e.preventDefault();
            this.buscarPedidos();
            return;
          case "u": // Importar OS
            e.preventDefault();
            this.buscarOS();
            return;
          case "f": // Fechar caixa
            e.preventDefault();
            this.fecharCaixa();
            return;
          case "t": // Descontos/Acréscimos
            e.preventDefault();
            this.$root.$emit("bv::toggle::collapse", "accordion-2");
            return;
          case "c": // Cliente
            e.preventDefault();
            this.$root.$emit("bv::toggle::collapse", "clienteTab");
            return;
          case "v": // Vendedor
            e.preventDefault();
            this.$root.$emit("bv::toggle::collapse", "vendedorTab");
            return;
          case "i": // Informações Adicionais
            e.preventDefault();
            this.$root.$emit("bv::toggle::collapse", "observationTab");
            return;
        }
      }
      // Ctrl/Cmd + P
      if (hasCombo && key === "w") {
        e.preventDefault();
        if (!this.isPagamentoModalOpen) {
          this.toggleModoAtacado();
          this.descontoAcrescimoAberto = true;
        }
        return;
      }

      // Ctrl/Cmd + A
      if (hasCombo && key === "a" && !typing) {
        e.preventDefault();
        this.handleSairDaVenda();
        return;
      }

      // Ctrl/Cmd + D
      if (hasCombo && key === "d") {
        e.preventDefault();
        this.abrirModalAjusteUltimoProduto();
        return;
      }

      // Ctrl/Cmd + S (com lock)
      if (hasCombo && key === "s") {
        e.preventDefault(); // bloqueia "Salvar página" do navegador

        // Se já está salvando (via botão ou atalho), não dispara de novo
        if (this.isSavingShortcut || this.isLoadingSubmit) return;

        try {
          this.isSavingShortcut = true;
          // Se seu handleSalvarVenda já controla isLoadingSubmit internamente, ótimo.
          await this.handleSalvarVenda(false); // deve retornar Promise
        } finally {
          this.isSavingShortcut = false;
        }
      }
    };

    window.addEventListener("keydown", this.__onKey, { capture: true });

    // Watch reactivo do Vue 3 (necessário pois store é reactive() do Vue 3 — Options API
    // watch não detecta mutações internas no proxy de forma confiável no Vue 2.7).
    // Quando produtos são adicionados/removidos/editados após um import com pagamento
    // automático, limpa o pagamento para forçar o usuário a informar manualmente.
    this.__unwatchProdutos = watch(
      () => this.store.productOfTradeCollection,
      () => {
        if (this.produtosSnapshotAposImport === null) return;
        const current = this._signatureProdutos(
          this.store.productOfTradeCollection
        );
        if (current !== this.produtosSnapshotAposImport) {
          this.venda.paymentModeCollection = [];
          this.listaPagamentos = [];
          this.produtosSnapshotAposImport = null;
        }
      },
      { deep: true }
    );
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.__onKey, { capture: true });
    this.removerLeitorProduto();
    this.desconectarBalanca();
    if (this.__valorPagamentoInput) {
      this.__valorPagamentoInput.removeEventListener(
        "focus",
        this.selecionarValorPagamentoModal
      );
    }
    if (this.__unwatchProdutos) this.__unwatchProdutos();
  },
  async created() {
    this.setLoading(true);
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.nota.id = parseInt(this.$route.params.id);
    }
    const [configuracaoAtual, configuracoesGeraisResponse] = await Promise.all([
      this.carregarConfiguracaoPadraoPdvWeb(),
      this.$http.post("/configuracoesgerais/find"),
    ]);
    const configuracoesGerais = configuracoesGeraisResponse.data?.[0] ?? {};
    this.solicitarDadosCartao = configuracaoAtual?.solicitarDadosCartao;
    if (configuracoesGerais?.solicita_senha_adm !== undefined) {
      adminPermissionStore.requestPermission = this.normalizarBooleanConfig(
        this.currentUser?.admin
      )
        ? false
        : this.normalizarBooleanConfig(configuracoesGerais.solicita_senha_adm);
    }

    if (!configuracaoAtual) {
      swal({
        title:
          "Verificamos que você ainda não realizou a configuração do ambiente",
        text: "Você foi redirecionado para o módulo de configuração",
        icon: "info",
        buttons: {
          confirm: {
            text: "Ok",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "ok") {
          swal.close();
          swal.stopLoading();
          return;
        }
        swal.close();
        swal.stopLoading();
      });
      this.$router.push({ name: "configuracoesNovo" });
    }
    if (typeof configuracoesGerais?.verifica_estoque === "boolean") {
      this.store.verificaEstoque = configuracoesGerais.verifica_estoque;
      this.store.desconsiderarEstoqueCondicional = this.normalizarBooleanConfig(
        configuracoesGerais.desconsiderar_estoque_condicional
      );
    }
    if (configuracoesGerais?.abertura_caixa !== undefined) {
      this.store.aberturaCaixa = Boolean(
        Number(configuracoesGerais.abertura_caixa)
      );
    }
    if (configuracoesGerais?.fechamento_as_cegas !== undefined) {
      this.store.fechamentoAsCegas = Boolean(
        Number(configuracoesGerais.fechamento_as_cegas)
      );
    }
    this.store.ordenarItemAdicionadoPorUltimoPDV = Boolean(
      Number(configuracoesGerais.ordenar_item_adicionado_por_ultimo_pdv ?? 0)
    );
    this.utilizarSempreReferencia = this.normalizarBooleanConfig(
      configuracoesGerais.utilizar_sempre_referencia
    );
    this.serie = configuracaoAtual.serie;
    this.informacoesComplementares =
      configuracaoAtual.informacoesComplementares;
    if (!this.vendaImportadaCondicional) {
      this.venda.observation = !this.nfe?.observation
        ? this.informacoesComplementares
        : this.nfe.observation;
    }
    if (this.store.aberturaCaixa) {
      const { data: caixaData } = await this.$http.post("/caixa/get-caixa");
      if (!caixaData.caixa_aberto) {
        this.$bvModal.show("caixa-modal");
      } else {
        const momentData = this.$moment(caixaData.dados_caixa.data_abertura);
        const dataFormatted = momentData.format("HH:mm [de] DD/MM/YY");
        this.caixaAberturaHorario = dataFormatted;
        try {
          const { data: caixaMovimentacaoData } = await this.$http.post(
            "/caixa/movimentacao"
          );
          this.caixaInfo = caixaMovimentacaoData;
        } catch (error) {
          console.log(error);
        }
      }
    }
    await this.getIntegracaoPos();
    await this.carregarConfigBalanca();
    this.setLoading(false);
  },
  methods: {
    ...mapActions(["setLoading"]),
    aplicarVendaEdicao(venda) {
      if (!venda) return;

      this.venda = venda;
      this.venda.observation = venda.observation
        ? venda.observation
        : this.informacoesComplementares;
      this.store.productOfTradeCollection =
        venda.productOfTradeCollection ?? [];
      this.listaPagamentos = venda.paymentModeCollection ?? [];
      this.valueCliente = venda.buyer ?? {};
      this.valueDiscount = this.valorReal(venda.discount ?? 0);
      this.valueExtraValue = this.valorReal(venda.extraValue ?? 0);
      this.statusVenda = venda.status;
      this.tipoDescontoValue = venda.tipoDescontoValue;
      this.tipoAcrescimoValue = venda.tipoAcrescimoValue;
      this.isPercent = venda.isPercent;
      this.tipoAcrescimo = venda.tipoAcrescimo;
      this.statusSelecionado = venda.statusSelecionado;
      this.venda.vendedor = venda.vendedor;
    },
    normalizarBooleanConfig(value) {
      if (typeof value === "boolean") return value;
      if (typeof value === "number") return value === 1;
      return ["1", "true", "sim", "s"].includes(
        String(value ?? "")
          .trim()
          .toLowerCase()
      );
    },
    criarEstadoLeitorProduto() {
      return {
        value: "",
        startedAt: 0,
        lastAt: 0,
        intervals: [],
        keyCount: 0,
      };
    },
    registrarLeitorProduto() {
      const input = this.$refs.buscarProduto?.$el?.querySelector("input");
      if (!input || input === this._produtoLeitorInput) return;

      this.removerLeitorProduto();
      this._produtoLeitorInput = input;
      this._produtoLeitorState = this.criarEstadoLeitorProduto();
      this._onProdutoLeitorKeydown = (event) =>
        this.registrarTeclaLeitorProduto(event);
      input.addEventListener("keydown", this._onProdutoLeitorKeydown);
    },
    removerLeitorProduto() {
      if (this._produtoLeitorInput && this._onProdutoLeitorKeydown) {
        this._produtoLeitorInput.removeEventListener(
          "keydown",
          this._onProdutoLeitorKeydown
        );
      }
      this._produtoLeitorInput = null;
      this._onProdutoLeitorKeydown = null;
      this._produtoLeitorState = this.criarEstadoLeitorProduto();
    },
    registrarTeclaLeitorProduto(event) {
      const key = event?.key || "";

      if (event?.ctrlKey || event?.metaKey || event?.altKey) return;

      if (["Backspace", "Delete", "Escape"].includes(key)) {
        this._produtoLeitorState = this.criarEstadoLeitorProduto();
        return;
      }

      if (key === "Enter") return;

      if (!/^\d$/.test(key)) {
        this._produtoLeitorState = this.criarEstadoLeitorProduto();
        return;
      }

      const now = Date.now();
      const state = this._produtoLeitorState || this.criarEstadoLeitorProduto();
      const tempoDesdeUltima = state.lastAt ? now - state.lastAt : 0;

      if (!state.startedAt || tempoDesdeUltima > 250) {
        this._produtoLeitorState = {
          value: key,
          startedAt: now,
          lastAt: now,
          intervals: [],
          keyCount: 1,
        };
        return;
      }

      state.value += key;
      state.intervals.push(tempoDesdeUltima);
      state.lastAt = now;
      state.keyCount += 1;
      this._produtoLeitorState = state;
    },
    entradaProdutoFoiLeitorReferencia(busca) {
      const termo = String(busca || "").trim();
      if (!this.utilizarSempreReferencia) return false;
      if (!/^\d{2,}$/.test(termo)) return false;

      const state = this._produtoLeitorState;
      if (!state || state.value !== termo || state.keyCount !== termo.length) {
        return false;
      }

      if (!state.intervals.length || Date.now() - state.lastAt > 1000) {
        return false;
      }

      const totalIntervalos = state.intervals.reduce(
        (acc, intervalo) => acc + intervalo,
        0
      );
      const mediaIntervalos = totalIntervalos / state.intervals.length;
      const maiorIntervalo = Math.max(...state.intervals);

      return mediaIntervalos <= 60 && maiorIntervalo <= 90;
    },
    produtoComReferenciaExataUnica(produtos, busca) {
      const termo = String(busca || "").trim();
      const produtosComReferencia = (produtos || []).filter(
        (produto) => String(produto?.referencia ?? "").trim() === termo
      );

      return produtosComReferencia.length === 1
        ? produtosComReferencia[0]
        : null;
    },
    async carregarConfiguracaoPadraoPdvWeb(force = false) {
      if (this.configuracaoPadraoPdvWeb && !force) {
        this.serie = this.seriePadraoPdvWeb;
        return this.configuracaoPadraoPdvWeb;
      }

      const { data } = await this.$http.post("/configuracoes/current-config", {
        modelo: 65,
        padrao_pdv_web: true,
      });
      const config = Array.isArray(data) ? data[0] : data;

      if (!config) {
        this.$toast.warning("Configuração padrão do PDV Web não encontrada.");
        return null;
      }

      this.configuracaoPadraoPdvWeb = config;
      this.seriePadraoPdvWeb = config.serie;
      this.idConfiguracaoPadraoPdvWeb =
        config.id_configuracao || config.id || null;
      this.serie = config.serie;
      this.informacoesComplementares =
        config.informacoesComplementares ?? null;

      console.log("[PDV_WEB_CONFIG_PADRAO_CARREGADA]", {
        id_configuracao: this.idConfiguracaoPadraoPdvWeb,
        serie: this.seriePadraoPdvWeb,
        padrao_pdv_web: config.padrao_pdv_web,
      });

      console.log("[PDV_WEB_CONFIG_LOAD]", {
        id_configuracao: this.idConfiguracaoPadraoPdvWeb,
        serie: this.seriePadraoPdvWeb,
      });

      return config;
    },
    async garantirConfiguracaoPdvWeb() {
      const config = await this.carregarConfiguracaoPadraoPdvWeb();

      if (!config) {
        throw new Error("Configuração padrão do PDV Web não encontrada.");
      }

      this.serie = config.serie;

      console.log("[PDV_WEB_ANTES_EMITIR]", {
        serie: this.serie,
        idConfiguracaoPadraoPdvWeb: this.idConfiguracaoPadraoPdvWeb,
      });

      return config;
    },
    async resetarVendaMantendoConfiguracao() {
      console.log("[PDV_WEB_ANTES_RESET]", {
        serie: this.serie,
        seriePadraoPdvWeb: this.seriePadraoPdvWeb,
        idConfiguracaoPadraoPdvWeb: this.idConfiguracaoPadraoPdvWeb,
      });

      const config = await this.carregarConfiguracaoPadraoPdvWeb();
      this.serie = config?.serie ?? this.seriePadraoPdvWeb ?? this.serie;

      console.log("[PDV_WEB_DEPOIS_RESET]", {
        serie: this.serie,
        seriePadraoPdvWeb: this.seriePadraoPdvWeb,
        idConfiguracaoPadraoPdvWeb: this.idConfiguracaoPadraoPdvWeb,
      });

      return config;
    },
    setSort(field, dir) {
      this.sortField = field;
      this.sortDir = dir;
    },
    persistPrefs() {
      try {
        const payload = {
          typeFilter: this.typeFilter,
          sortField: this.sortField,
          sortDir: this.sortDir,
        };
        localStorage.setItem(LS_KEY, JSON.stringify(payload));
      } catch (e) {
        // opcional: enviar para log
        // console.warn('Falha ao salvar preferências:', e);
      }
    },

    // Debounce simples (~200ms)
    persistPrefsDebounced: (function () {
      let t = null;
      return function () {
        clearTimeout(t);
        t = setTimeout(() => this.persistPrefs(), 200);
      };
    })(),

    restorePrefs() {
      try {
        const raw = localStorage.getItem(LS_KEY);
        if (!raw) return;
        const data = JSON.parse(raw);
        if (data && typeof data === "object") {
          if ([1, 2, 3].includes(data.typeFilter))
            this.typeFilter = data.typeFilter;
          if (["preco", "descricao"].includes(data.sortField))
            this.sortField = data.sortField;
          if (["ASC", "DESC"].includes(data.sortDir))
            this.sortDir = data.sortDir;
        }
      } catch (e) {
        // console.warn('Falha ao restaurar preferências:', e);
      }
    },

    resetPrefs() {
      try {
        localStorage.removeItem(LS_KEY);
      } catch (e) {
        console.log(e);
      }
      // valores padrão
      this.typeFilter = 1;
      this.sortField = "descricao";
      this.sortDir = "ASC";
    },

    /**
     * Alterna a exibição dos atalhos (Ctrl + X) entre parênteses nos botões
     * do PDV. Atualiza o estado local imediatamente (otimista) e persiste
     * a preferência no banco, atrelada ao usuário logado.
     */
    async toggleAtalhosEmTela() {
      const novoValor = !this.mostrarAtalhosEmTela;
      // Atualização otimista no store (já reflete na tela)
      this.$store.commit(SET_MOSTRAR_ATALHOS_PDV, novoValor);

      try {
        await this.$http.post("/usuario/preferencias/atalhos-pdv", {
          mostrar_atalhos_pdv: novoValor,
        });
      } catch (e) {
        // Em caso de erro, reverte o estado local e avisa o usuário
        this.$store.commit(SET_MOSTRAR_ATALHOS_PDV, !novoValor);
        this.$toast?.error?.(
          "Não foi possível salvar a preferência de atalhos."
        );
      }
    },
    aplicarImportacaoCondicionalPdv() {
      const token = this.$route.query.condicionalImport;

      if (!token) {
        return;
      }

      const storageKey = `${CONDICIONAL_PDV_IMPORT_KEY_PREFIX}${token}`;
      const raw = localStorage.getItem(storageKey);

      if (!raw) {
        this.$toast.warning(
          "Não foi possível carregar a venda da condicional."
        );
        return;
      }

      try {
        const importacao = JSON.parse(raw);
        const produtos = (importacao.productOfTradeCollection || []).map(
          (item) => this.normalizarProdutoCondicionalPdv(item)
        );
        const buyer = importacao.buyer || importacao.cliente || {};

        this.venda = {
          ...this.venda,
          buyer,
          vendedor: importacao.vendedor || this.venda.vendedor || null,
          observation: importacao.observacao || this.venda.observation,
          origem_condicional: importacao.origem_condicional || null,
          productOfTradeCollection: produtos,
        };
        this.valueCliente = { ...buyer };
        this.selectedCliente = buyer?.id_pessoa ? { ...buyer } : {};
        this.idPessoaLista = buyer?.id_pessoa || null;
        this.store.productOfTradeCollection = produtos;
        this.valorTotal = produtos.reduce(
          (total, item) => total + Number(item.totalPrice || 0),
          0
        );
        this.vendaImportadaCondicional = true;

        this.$toast.success(
          `Condicional #${importacao.numero_condicional} carregada no PDV.`
        );
      } catch (error) {
        this.$toast.error("Erro ao carregar a venda da condicional.");
      } finally {
        localStorage.removeItem(storageKey);
      }
    },
    normalizarProdutoCondicionalPdv(item) {
      const product = item.product || {};
      const price = Number(item.price || product.preco || 0);
      const quantity = Number(item.quantity || 0);
      const origemCondicional =
        item.origem_condicional || product.origem_condicional || null;
      const idCondicionalItem =
        item.id_condicional_mercadoria_item ||
        product.id_condicional_mercadoria_item ||
        origemCondicional?.id_condicional_mercadoria_item ||
        null;

      return {
        ...item,
        id_condicional_mercadoria_item: idCondicionalItem,
        origem_condicional: origemCondicional,
        active: item.active !== false,
        discount: Number(item.discount || 0),
        price,
        quantity,
        totalPrice: Number(item.totalPrice || price * quantity),
        product: {
          ...product,
          id_condicional_mercadoria_item: idCondicionalItem,
          origem_condicional: origemCondicional,
          preco: product.preco ?? price,
        },
      };
    },
    abrirModalReceberContaPdv() {
      if (!this.receberContaFormaPagamento) {
        this.receberContaFormaPagamento =
          this.listaMeiosPagamento.find(
            (meio) =>
              meio.descricao === "À vista" ||
              meio.descricao === "A vista" ||
              meio.descricao === "Dinheiro"
          ) ||
          this.listaMeiosPagamento[0] ||
          null;
      }

      this.$bvModal.show("modal-receber-conta-pdv");
      this.$nextTick(() => {
        const input = document.getElementById("receberContaBusca");
        if (input) input.focus();
      });
    },
    buscarContasReceberPdv: _.debounce(async function () {
      const search = this.receberContaBusca.trim();

      if (search.length < 3) {
        this.receberContaResultados = [];
        this.receberContaSelecionadas = [];
        return;
      }

      this.receberContaLoading = true;
      try {
        const { data } = await this.$http.post("/contareceber/pdv/buscar", {
          search,
          limit: 100,
        });
        this.receberContaResultados = data?.data || [];
        this.receberContaSelecionadas = this.receberContaSelecionadas.filter(
          (contaSelecionada) =>
            this.receberContaResultados.some(
              (conta) => conta.id === contaSelecionada.id
            )
        );
      } catch (error) {
        const message =
          error?.response?.data?.msg || "Erro ao buscar contas a receber.";
        this.$toast.error(message);
      }
      this.receberContaLoading = false;
    }, 350),
    resetReceberContaPdv() {
      if (this.isRecebendoContaPdv) return;

      this.receberContaBusca = "";
      this.receberContaLoading = false;
      this.receberContaResultados = [];
      this.receberContaSelecionadas = [];
      this.receberContaFormaPagamento = null;
    },
    getValorContaReceberPdv(conta) {
      const valorTotal = parseFloat(conta?.valor_total || 0);
      if (valorTotal > 0) return valorTotal;

      return parseFloat(conta?.valor || 0);
    },
    getContaReceberSituacaoTexto(conta) {
      if (!conta?.data_vencimento) return "Aberta";

      const hoje = this.$moment().startOf("day");
      const vencimento = this.$moment(conta.data_vencimento).startOf("day");

      if (vencimento.isBefore(hoje)) return "Vencida";
      if (vencimento.isSame(hoje)) return "Hoje";
      return "A vencer";
    },
    getContaReceberSituacaoVariant(conta) {
      const situacao = this.getContaReceberSituacaoTexto(conta);
      if (situacao === "Vencida") return "danger";
      if (situacao === "Hoje") return "warning";
      return "success";
    },
    isContaReceberSelecionada(id) {
      return this.receberContaSelecionadas.some((conta) => conta.id === id);
    },
    toggleContaReceberPdv(conta) {
      if (this.isContaReceberSelecionada(conta.id)) {
        this.receberContaSelecionadas = this.receberContaSelecionadas.filter(
          (contaSelecionada) => contaSelecionada.id !== conta.id
        );
        return;
      }

      this.receberContaSelecionadas = [...this.receberContaSelecionadas, conta];
    },
    async abrirModalReceberContaParcialPdv() {
      if (this.receberContaSelecionadas.length !== 1) {
        this.$toast.error(
          "Selecione uma conta para realizar o recebimento parcial."
        );
        return;
      }

      this.isLoadingRecebimentoParcialPdv = true;
      try {
        if (this.receberContaBancos.length === 1) {
          const bancos = await this.getBancosByEmpresa();
          const idsExistentes = new Set(
            this.receberContaBancos.map((banco) => banco.id_banco)
          );
          this.receberContaBancos.push(
            ...bancos.filter((banco) => !idsExistentes.has(banco.id_banco))
          );
        }
        if (!this.receberContaMeiosPagamentoParcial.length) {
          await this.getMeiosPagamento();
        }

        this.$bvModal.show("modal-receber-conta-parcial-pdv");
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.msg ||
            "Não foi possível carregar os dados do recebimento parcial."
        );
      } finally {
        this.isLoadingRecebimentoParcialPdv = false;
      }
    },
    async handleRecebimentoParcialPdv(resultado) {
      try {
        await this.loadCaixaInfo();
      } catch (error) {
        const message =
          error?.response?.data?.msg || "Não foi possível atualizar o caixa.";
        this.$toast.warning(message);
      }

      if (resultado?.url_recibo) {
        this.imprimir(resultado.url_recibo);
      }
      this.$toast.success("Recebimento parcial realizado com sucesso!");
      this.$bvModal.hide("modal-receber-conta-pdv");
      this.resetReceberContaPdv();
    },
    async receberContaPdv() {
      if (!this.canReceberContaPdv) return;

      this.isRecebendoContaPdv = true;
      this.addLoadingToButton("receberContaPdv");
      try {
        const { data } = await this.$http.post("/contareceber/pdv/receber", {
          id_meio_pagamento: this.receberContaFormaPagamento.id,
          contas_receber: this.receberContaSelecionadas.map(
            (conta) => conta.id
          ),
        });

        try {
          await this.loadCaixaInfo();
        } catch (error) {
          const message =
            error?.response?.data?.msg || "Não foi possível atualizar o caixa.";
          this.$toast.warning(message);
        }
        if (data?.data?.url_recibo) {
          this.imprimir(data.data.url_recibo);
        }
        this.$toast.success("Contas recebidas com sucesso!");
        this.isRecebendoContaPdv = false;
        this.$bvModal.hide("modal-receber-conta-pdv");
        this.resetReceberContaPdv();
      } catch (error) {
        const message =
          error?.response?.data?.msg || "Erro ao receber contas no PDV.";
        this.$toast.error(message);
      }
      this.removeLoadingToButton("receberContaPdv");
      this.isRecebendoContaPdv = false;
    },
    handleOpenModal() {
      this.isPagamentoModalOpen = true;
      this.pagamentosModalOptions = null;
      this.$nextTick(() => {
        const input = this.getValorPagamentoModalInput();
        if (!input) return;
        input.focus();
        input.select();
        if (this.__valorPagamentoInput !== input) {
          if (this.__valorPagamentoInput) {
            this.__valorPagamentoInput.removeEventListener(
              "focus",
              this.selecionarValorPagamentoModal
            );
          }
          input.addEventListener("focus", this.selecionarValorPagamentoModal);
          this.__valorPagamentoInput = input;
        }
      });
    },
    handleClosePagamentoModal() {
      this.isPagamentoModalOpen = false;
      this.atalhoPagamentoSelecionado = null;
      this.atalhoPagamentoPendente = null;
      this.pagamentosModalOptions = null;
      if (this.__valorPagamentoInput) {
        this.__valorPagamentoInput.removeEventListener(
          "focus",
          this.selecionarValorPagamentoModal
        );
        this.__valorPagamentoInput = null;
      }
    },
    confirmarPagamentoModal() {
      if (!this.canUsePagamentoShortcuts()) return;
      this.fromPagamentoModal = true;
      this.justSave
        ? this.handleSalvarVenda(false)
        : this.handleFinalizar(this.transmitir);
    },
    isVendaEmProcessamento() {
      const modalPosVenda = document.getElementById("modal-pos-venda");
      return (
        this.posStep > 0 ||
        this.isLoadingSubmit ||
        this.isLoadingPosData ||
        modalPosVenda?.classList.contains("show")
      );
    },
    isModalFormaPagamentoVisivel() {
      const modal = document.getElementById("modal-forma-pagamento");
      return (
        this.isPagamentoModalOpen &&
        !!modal &&
        modal.classList.contains("show") &&
        modal.getAttribute("aria-hidden") !== "true"
      );
    },
    canUsePagamentoShortcuts() {
      return (
        this.isModalFormaPagamentoVisivel() && !this.isVendaEmProcessamento()
      );
    },
    /**
     * Indica se há algum modal/sidebar aberto na tela.
     * O bootstrap-vue adiciona a classe "modal-open" ao <body> quando um modal
     * está visível. Usado para bloquear os atalhos gerais (Ctrl+L/O/R/...) e
     * evitar abrir modal sobre modal.
     */
    _algumModalAberto() {
      return document.body && document.body.classList.contains("modal-open");
    },
    getValorPagamentoModalInput() {
      return this.$refs.valorPagamentoModal?.$el?.querySelector("input");
    },
    selecionarValorPagamentoModal() {
      this.$nextTick(() => {
        const input = this.getValorPagamentoModalInput();
        if (input) input.select();
      });
    },
    normalizarDescricaoPagamento(descricao) {
      return String(descricao || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
    },
    buscarPagamentoPorAtalho(atalho) {
      const pagamentos = this.pagamentos || [];
      const normalizar = (pagamento) =>
        this.normalizarDescricaoPagamento(pagamento?.descricao);

      const regras = {
        f1: [(pagamento) => normalizar(pagamento).includes("debito")],
        f2: [
          (pagamento) => {
            const descricao = normalizar(pagamento);
            return (
              descricao.includes("cartao") && descricao.includes("credito")
            );
          },
        ],
        f3: [(pagamento) => normalizar(pagamento).includes("pix")],
        f4: [
          (pagamento) => ["a vista", "avista"].includes(normalizar(pagamento)),
          (pagamento) => normalizar(pagamento).includes("dinheiro"),
        ],
      };

      return (regras[atalho] || []).reduce(
        (encontrado, regra) => encontrado || pagamentos.find(regra),
        null
      );
    },
    isPagamentoCredito(pagamento) {
      const descricao = this.normalizarDescricaoPagamento(pagamento?.descricao);
      return descricao.includes("cartao") && descricao.includes("credito");
    },
    async getMeiosPagamento() {
      const { data } = await this.$http.post("/financeiro/meios-pagamento");
      this.receberContaMeiosPagamentoParcial = data;
      const permitidos = [
        "dinheiro",
        "pix",
        "cartao debito",
        "cartão débito",
        "cartao de debito",
        "cartão de débito",
        "cartao credito",
        "cartão crédito",
        "cartao de credito",
        "cartão de crédito",
      ];
      this.listaMeiosPagamento = data.filter((meio) => {
        const desc = (meio.descricao || "")
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        return permitidos.some((p) =>
          desc.includes(p.normalize("NFD").replace(/[\u0300-\u036f]/g, ""))
        );
      });
    },
    getPagamentosCredito() {
      return (this.pagamentos || []).filter((pagamento) =>
        this.isPagamentoCredito(pagamento)
      );
    },
    handleCreditoDropdownKey(key) {
      if (!this.canUsePagamentoShortcuts()) return;
      const select = this.$refs.buscaPagamentos;
      if (!select) return;

      select.open = true;

      if (key === "escape") {
        select.open = false;
        this.pagamentosModalOptions = null;
        this.selecionarValorPagamentoModal();
        return;
      }

      if (key === "arrowdown") {
        if (typeof select.typeAheadDown === "function") {
          select.typeAheadDown();
        } else if (select.filteredOptions?.length) {
          select.typeAheadPointer = Math.min(
            select.typeAheadPointer + 1,
            select.filteredOptions.length - 1
          );
        }
        this.focarListaCreditoPagamento();
        return;
      }

      if (key === "arrowup") {
        if (typeof select.typeAheadUp === "function") {
          select.typeAheadUp();
        } else {
          select.typeAheadPointer = Math.max(select.typeAheadPointer - 1, 0);
        }
        this.focarListaCreditoPagamento();
        return;
      }

      if (key === "enter") {
        if (select.typeAheadPointer < 0 && select.filteredOptions?.length) {
          select.typeAheadPointer = 0;
        }
        if (typeof select.typeAheadSelect === "function") {
          select.typeAheadSelect();
        } else {
          const option = select.filteredOptions?.[select.typeAheadPointer];
          if (option && typeof select.select === "function")
            select.select(option);
        }
      }
    },
    focarListaCreditoPagamento() {
      this.$nextTick(() => {
        const select = this.$refs.buscaPagamentos;
        if (!select) return;

        select.open = true;
        if (select.typeAheadPointer < 0 && select.filteredOptions?.length) {
          select.typeAheadPointer = 0;
        }

        const input =
          select.searchEl || select.$el?.querySelector(".vs__search");
        if (input) {
          input.focus();
          input.click();
        }

        if (typeof select.onSearchFocus === "function") {
          select.onSearchFocus();
        }
      });
    },
    abrirListaCreditoPagamento() {
      const pagamentosCredito = this.getPagamentosCredito();
      if (!pagamentosCredito.length) {
        this.$toast.warning("Nenhuma forma de cartão de crédito encontrada");
        return;
      }

      this.pagamentosModalOptions = pagamentosCredito;
      this.atalhoPagamentoSelecionado = null;
      if (!this.isPagamentoCredito(this.pagamento)) this.pagamento = null;
      this.focarListaCreditoPagamento();
    },
    async adicionarPagamentoPorAtalho(atalho) {
      if (!this.canUsePagamentoShortcuts()) return;

      if (atalho === "f5") {
        this.confirmarPagamentoModal();
        return;
      }

      if (
        atalho === "f2" &&
        this.atalhoPagamentoSelecionado?.atalho !== atalho
      ) {
        const pagamentosCredito = this.getPagamentosCredito();
        if (pagamentosCredito.length === 1) {
          const pagamento = pagamentosCredito[0];
          this.pagamento = pagamento;
          this.pagamentosEditados = [];
          this.atalhoPagamentoSelecionado = { atalho, id: pagamento.id };
          this.pagamentosModalOptions = null;
          this.selecionarValorPagamentoModal();
        } else {
          this.abrirListaCreditoPagamento();
        }
        return;
      }

      if (this.atalhoPagamentoSelecionado?.atalho === atalho) {
        this.atalhoPagamentoPendente = atalho;
        const pagamentoAdicionado = await this.adicionarPagamento();
        this.atalhoPagamentoPendente = null;
        if (pagamentoAdicionado) {
          this.atalhoPagamentoSelecionado = null;
          this.pagamentosModalOptions = null;
        }
        return;
      }

      const pagamento = this.buscarPagamentoPorAtalho(atalho);

      if (!pagamento) {
        this.$toast.warning(
          "Forma de pagamento não encontrada para este atalho"
        );
        return;
      }

      this.pagamento = pagamento;
      this.pagamentosEditados = [];
      this.atalhoPagamentoSelecionado = { atalho, id: pagamento.id };
      this.pagamentosModalOptions = null;
      this.selecionarValorPagamentoModal();
    },
    formatValorCalculoQuantidade(valor) {
      if (typeof valor === "number") return valor;
      if (!valor) return 0;

      return this.formatNumberToFloat(String(valor).replace("R$", "").trim());
    },
    abrirModalCalculoQuantidade() {
      if (Number(this.qtyPrec) < 3) {
        this.$toast.warning(
          "Você deve utilizar 3 ou mais casas decimais em quantidades para habilitar essa função"
        );
        return;
      }

      if (!this.produto) {
        this.$toast.warning("Selecione um produto para calcular a quantidade!");
        this.buscarProduto();
        return;
      }

      if (this.valorProdutoSelecionado <= 0) {
        this.$toast.warning("Informe o valor unitário do produto!");
        this.informarValor();
        return;
      }

      this.valorCalculoQuantidade = 0;
      this.$bvModal.show("modal-calculo-quantidade");
    },
    handleOpenCalculoQuantidadeModal() {
      this.$nextTick(() => {
        const inputEl =
          this.$refs.valorCalculoQuantidade?.$el?.querySelector("input") ||
          this.$refs.valorCalculoQuantidade?.$el;

        if (inputEl) {
          inputEl.focus();
          inputEl.select();
        }
      });
    },
    salvarQuantidadeCalculada() {
      const valorDesejado = this.formatValorCalculoQuantidade(
        this.valorCalculoQuantidade
      );
      const precoUnitario = this.valorProdutoSelecionado;

      if (!Number.isFinite(valorDesejado) || valorDesejado <= 0) {
        this.$toast.warning("Informe o valor desejado pelo cliente!");
        this.handleOpenCalculoQuantidadeModal();
        return;
      }

      if (!Number.isFinite(precoUnitario) || precoUnitario <= 0) {
        this.$toast.warning("Informe o valor unitário do produto!");
        this.$bvModal.hide("modal-calculo-quantidade");
        this.informarValor();
        return;
      }

      const quantidadeCalculada = this.roundTo2Digits(
        valorDesejado / precoUnitario,
        this.quantityOptions.precision
      );

      this.quantidade = this.numberToReal(quantidadeCalculada, "quantidade");
      this.$bvModal.hide("modal-calculo-quantidade");

      this.$nextTick(() => {
        const inputEl = this.$refs.quantidade?.$el?.querySelector("input");
        if (inputEl) {
          inputEl.focus();
          inputEl.select();
        }
      });
    },
    applyPrecisions() {
      const qp = this.qtyPrec ? this.qtyPrec : 0;
      const pp = this.pricePrec ? this.pricePrec : 2;

      // Se seu padrão é “1 com N casas decimais” no input de máscara:
      this.quantidade = 1 * Math.pow(10, qp);
      this.price = 1 * Math.pow(10, pp);
    },
    async buscarListasPreco() {
      this.setLoading(true);
      try {
        const response = await this.$http.post(
          "/produtos/get-lista-preco-geral"
        );
        this.listaDePrecos = response.data;
        this.$bvModal.show("listaPreco");
      } catch (error) {
        console.log(error);
      }
      this.setLoading(false);
    },

    async buscarPedidos() {
      this.setLoading(true);
      try {
        const response = await this.$http.post("/pedido/pedidos-autorizados");
        this.pedidosToImport = response.data.sort((a, b) => {
          if (a.id_pedido < b.id_pedido) return -1;
          if (a.id_pedido > b.id_pedido) return 1;
          return 0;
        });
        this.$bvModal.show("importarPedido");
      } catch (error) {
        console.log(error);
      }
      this.setLoading(false);
    },
    async buscarOS() {
      this.setLoading(true);
      try {
        const responseOS = await this.$http.post(
          "/ordemservico/os-autorizadas"
        );
        this.osToImport = responseOS.data.sort((a, b) => {
          if (a.id_ordem_servico < b.id_ordem_servico) return -1;
          if (a.id_ordem_servico > b.id_ordem_servico) return 1;
          return 0;
        });
        this.$bvModal.show("importarOS");
      } catch (error) {
        console.log(error);
      }
      this.setLoading(false);
    },
    onSearchOS(search, loading) {
      loading(true);
      this.searchOS(loading, search, this);
    },
    searchOS: _.debounce(async (loading, search, vm) => {
      vm.osToImport = [];
      await vm.$nextTick();
      if (!search) {
        loading(false);
        return;
      }
      const response = await vm.$http.post("/ordemservico/os-autorizadas", {
        numero: search,
      });
      vm.osToImport = _.cloneDeep(response.data);
      loading(false);
    }, 500),
    async importarOS() {
      this.addLoadingToButton("importar_os");
      try {
        const os = this.selectedOS.map(({ id_ordem_servico }) => ({
          id_ordem_servico,
        }));
        const selectedOSSnapshot = [...(this.selectedOS ?? [])];
        const response = await this.$http.post("/nfe/importar-os", {
          os,
        });

        this.os = os;
        // Captura estado do carrinho ANTES de adicionar os produtos deste import.
        // Se já havia produto sem pagamento, novos imports não devem trazer pagamento.
        const hadUncoveredBefore = this._temProdutoSemPagamento();
        const pendingBefore = this._getPendingValue();
        const [formFaturamento, formProduto, formCliente] =
          this.extractDataFromImport(response.data);
        this.venda.observation = response.data.observation;

        this.store.productOfTradeCollection = [
          ...this.store.productOfTradeCollection,
          ...this.normalizarItensEstoqueVenda(formProduto.produtos),
        ];

        // Snapshot como fonte autoritativa (API pode omitir pagamentos não-à-vista)
        const snapshotOSPayments = selectedOSSnapshot.flatMap((o) => {
          try {
            return JSON.parse(o.pagamentos ?? "[]");
          } catch {
            return [];
          }
        });
        const rawOSToCheck =
          snapshotOSPayments.length > 0
            ? snapshotOSPayments
            : response?.data?.paymentModeCollection ?? [];
        await this._aplicarPagamentosImportados(
          rawOSToCheck,
          selectedOSSnapshot.length,
          pendingBefore,
          hadUncoveredBefore
        );

        if (formCliente) {
          this.valueCliente = { ...formCliente };
          this.venda.buyer = this.valueCliente;
        }

        this.selectedOS = null;
        this.$toast.success("OS(s) importada(s) com sucesso!");
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("importar_os");
      this.$bvModal.hide("importarOS");
    },
    async buscarOrcamentos() {
      this.setLoading(true);
      try {
        const response = await this.$http.post(
          "/orcamento/orcamentos-autorizados"
        );
        this.orcamentosToImport = response.data.sort((a, b) => {
          if (a.id_orcamento < b.id_orcamento) return -1;
          if (a.id_orcamento > b.id_orcamento) return 1;
          return 0;
        });
        this.$bvModal.show("importarOrcamento");
      } catch (error) {
        console.log(error);
      }
      this.setLoading(false);
    },
    onSearchOrcamento(search, loading) {
      loading(true);
      this.searchOrcamento(loading, search, this);
    },
    searchOrcamento: _.debounce(async (loading, search, vm) => {
      vm.orcamentosToImport = [];
      await vm.$nextTick();
      if (!search) {
        loading(false);
        return;
      }
      const response = await vm.$http.post(
        "/orcamento/orcamentos-autorizados",
        {
          numero: search,
        }
      );
      vm.orcamentosToImport = _.cloneDeep(response.data);
      loading(false);
    }, 500),
    async importarOrcamento() {
      this.addLoadingToButton("importar_orcamento");
      try {
        const orcamentos = this.selectedOcamentos.map(({ id_orcamento }) => ({
          id_orcamento,
        }));
        const selectedOrcamentosSnapshot = [...(this.selectedOcamentos ?? [])];
        const response = await this.$http.post("/nfe/importar-orcamento", {
          orcamentos,
        });

        // Captura estado do carrinho ANTES de adicionar os produtos deste import.
        // Se já havia produto sem pagamento, novos imports não devem trazer pagamento.
        const hadUncoveredBefore = this._temProdutoSemPagamento();
        const pendingBefore = this._getPendingValue();
        const [formFaturamento, formProduto, formCliente] =
          this.extractDataFromImport(response.data);
        this.venda.observation = response.data.observation;
        this.venda.discount = response.data.discount;
        this.valueDiscount = response.data.discount;
        this.store.productOfTradeCollection = [
          ...this.store.productOfTradeCollection,
          ...this.normalizarItensEstoqueVenda(formProduto.produtos),
        ];

        // Snapshot como fonte autoritativa (API pode omitir pagamentos não-à-vista)
        const snapshotPayments = selectedOrcamentosSnapshot.flatMap((orc) => {
          try {
            return JSON.parse(orc.pagamentos ?? "[]");
          } catch {
            return [];
          }
        });
        const rawToCheck =
          snapshotPayments.length > 0
            ? snapshotPayments
            : response?.data?.paymentModeCollection ?? [];
        await this._aplicarPagamentosImportados(
          rawToCheck,
          selectedOrcamentosSnapshot.length,
          pendingBefore,
          hadUncoveredBefore
        );

        if (formCliente) {
          this.valueCliente = { ...formCliente };
          this.venda.buyer = this.valueCliente;
        }

        // Armazenar orçamentos para enviar no create/update da venda
        this.orcamentos = orcamentos;

        this.$toast.success("Orçamento(s) importado(s) com sucesso!");
        this.$bvModal.hide("importarOrcamento");
        this.selectedOcamentos = null;
        this.removeLoadingToButton("importar_orcamento");
      } catch (error) {
        this.$bvModal.hide("importarOrcamento");
        this.removeLoadingToButton("importar_orcamento");
        console.log(error);
      }
    },
    onSearchPedido(search, loading) {
      loading(true);
      this.searchPedido(loading, search, this);
    },
    searchPedido: _.debounce(async (loading, search, vm) => {
      vm.pedidosToImport = [];
      await vm.$nextTick();
      if (!search) {
        loading(false);
        return;
      }
      const response = await vm.$http.post("/pedido/pedidos-autorizados", {
        numero: search,
      });
      vm.pedidosToImport = _.cloneDeep(response.data);
      loading(false);
    }, 500),

    onSearchLista(search, loading) {
      loading(true);
      this.searchLista(loading, search, this);
    },
    searchLista: _.debounce(async (loading, search, vm) => {
      vm.listaDePrecos = [];
      await vm.$nextTick();
      if (!search) {
        loading(false);
        return;
      }
      const response = await vm.$http.post("/produtos/get-lista-preco-geral", {
        descricao: search,
      });
      vm.listaDePrecos = _.cloneDeep(response.data);
      loading(false);
    }, 500),

    async selecionarListaPreco() {
      this.addLoadingToButton("selecionar_lista");
      try {
        this.$toast.success("Lista selecionada com sucesso!");
        this.$bvModal.hide("listaPreco");
        (this.selectedPedidos = null),
          this.removeLoadingToButton("selecionar_lista");
      } catch (error) {
        this.$bvModal.hide("listaPreco");
        this.removeLoadingToButton("selecionar_lista");
      }
    },

    // Limpa o pagamento que veio de import quando o usuário altera produtos
    // (excluir, adicionar, editar quantidade ou preço). Chamado a partir dos
    // pontos onde o usuário interage com a lista de produtos.
    _onProdutosAlteradosManualmente() {
      if (this.produtosSnapshotAposImport === null) return;
      this.venda.paymentModeCollection = [];
      this.listaPagamentos = [];
      this.produtosSnapshotAposImport = null;
    },

    _signatureProdutos(produtos) {
      try {
        return JSON.stringify(
          (produtos ?? []).map((p) => [
            p?.product?.id_product ?? p?.id_product ?? p?.id ?? null,
            p?.quantity ?? null,
            p?.price ?? p?.product?.preco ?? null,
          ])
        );
      } catch {
        return String((produtos ?? []).length);
      }
    },

    // Calcula o saldo pendente atual: subtotal dos produtos - soma dos pagamentos já existentes.
    // Usado para decidir se um novo import pode trazer pagamento (se > 0, não traz).
    // Usa os mesmos computados (`total` e `valorPago`) que o restante da tela exibe,
    // garantindo consistência com o que o usuário enxerga.
    _getPendingValue() {
      const subtotal = parseFloat(this.total) || 0;
      const pago = parseFloat(this.valorPago) || 0;
      return subtotal - pago;
    },

    // Indica se o carrinho já possui produtos sem pagamento aplicado.
    // Quando true, novos imports não devem trazer pagamentos automaticamente.
    _temProdutoSemPagamento() {
      const subtotal = parseFloat(this.total) || 0;
      if (subtotal <= 0.01) return false;
      const lista = this.listaPagamentos?.length
        ? this.listaPagamentos
        : this.venda.paymentModeCollection ?? [];
      if (!lista || lista.length === 0) return true;
      const pago = parseFloat(this.valorPago) || 0;
      return subtotal - pago > 0.01;
    },

    // Centraliza a lógica de pagamentos importados.
    // Regras:
    // - Se já havia produtos no carrinho sem pagamento aplicado → não puxa pagamento.
    // - Pedidos count > 1 + qualquer não-à-vista → bloqueia sessão.
    // - Existentes + novos: se TODOS forem à vista → soma em 1; senão não adiciona.
    async _aplicarPagamentosImportados(
      rawPayments,
      pedidosCount,
      pendingBefore,
      hadUncoveredBefore
    ) {
      // Regra: se já havia produtos sem pagamento antes deste import, não traz pagamento.
      // Aceita tanto a flag explícita (preferida) quanto o saldo pendente como fallback.
      if (hadUncoveredBefore === true) return;
      if ((pendingBefore ?? 0) > 0.01) return;

      const count = pedidosCount != null ? pedidosCount : 1;
      if (this.pagamentoImportacaoBloqueado && count > 1) return;

      const resolved = this.resolvePaymentsToImport(rawPayments, count);

      if (!resolved) {
        // 2+ itens com pagamento não-à-vista: bloqueia sessão e limpa o acumulado
        if (count > 1 && this.hasImportablePayments(rawPayments)) {
          this.pagamentoImportacaoBloqueado = true;
          this.produtosSnapshotAposImport = null;
          this.venda.paymentModeCollection = [];
          this.listaPagamentos = [];
        }
        return;
      }

      const existing = this.venda.paymentModeCollection ?? [];
      let novaLista;

      if (existing.length === 0) {
        novaLista = [...resolved];
      } else {
        // Tenta consolidar: usa as regras de "todos à vista → soma em 1" sobre o conjunto.
        const merged = this.resolvePaymentsToImport(
          [...existing, ...resolved],
          2
        );
        if (!merged) {
          // Misturou tipos diferentes (ex.: existing à vista + novo à prazo). Não adiciona.
          return;
        }
        novaLista = [...merged];
      }

      this.venda.paymentModeCollection = novaLista;
      this.listaPagamentos = novaLista;
      await this.$nextTick();
      this.produtosSnapshotAposImport = this._signatureProdutos(
        this.store.productOfTradeCollection
      );
    },

    async importarPedido() {
      this.addLoadingToButton("importar_pedido");
      const pedidos = this.selectedPedidos.map(({ id_pedido }) => ({
        id_pedido,
      }));
      try {
        const { data } = await this.$http.post("/pedido/importar", {
          pedidos,
        });
        const selectedPedidosSnapshot = [...(this.selectedPedidos ?? [])];
        // Captura estado do carrinho ANTES de adicionar os produtos deste import.
        // Se já havia produto sem pagamento, novos imports não devem trazer pagamento.
        const hadUncoveredBefore = this._temProdutoSemPagamento();
        const pendingBefore = this._getPendingValue();
        const [formFaturamento, formProduto, formCliente] =
          this.extractDataFromImport(data);
        this.pedidos = pedidos;
        this.discountPedidoImportado = data.discount;
        this.store.productOfTradeCollection = [
          ...this.store.productOfTradeCollection,
          ...this.normalizarItensEstoqueVenda(formProduto.produtos),
        ];
        this.venda.observation = data.observation;

        // Usa snapshot como fonte autoritativa: o API pode omitir pagamentos não-à-vista
        const snapshotPayments = selectedPedidosSnapshot.flatMap((pedido) => {
          try {
            return JSON.parse(pedido.pagamentos ?? "[]");
          } catch {
            return [];
          }
        });
        const rawToCheck =
          snapshotPayments.length > 0
            ? snapshotPayments
            : data?.paymentModeCollection ?? [];
        await this._aplicarPagamentosImportados(
          rawToCheck,
          selectedPedidosSnapshot.length,
          pendingBefore,
          hadUncoveredBefore
        );

        if (data.discount > 0) {
          this.descontoPedidoAplicado = true;
          this.venda.discount = data.discount;
          this.valueDiscount = data.discount;
          this.descontoPedido = data.discount;
          if (data.descontoItem) {
            this.descontoItemPedido = true;
          }
        }

        if (formCliente) {
          this.valueCliente = { ...formCliente };
          this.venda.buyer = this.valueCliente;
        }

        this.$toast.success("Pedido(s) importado(s) com sucesso!");
        this.$bvModal.hide("importarPedido");
        (this.selectedPedidos = null),
          this.removeLoadingToButton("importar_pedido");
      } catch (error) {
        this.$bvModal.hide("importarPedido");
        this.removeLoadingToButton("importar_pedido");
      }
    },

    changePagamento(parcelaIndex, pagamentoIndex) {
      if (
        this.isPagamentoCreditoCliente(this.listaPagamentos[pagamentoIndex])
      ) {
        return;
      }
      this.selectedPagamento = {
        pagamento: pagamentoIndex,
        parcelaIndex: parcelaIndex,
      };
    },
    async loadCaixaInfo() {
      const { data: caixaMovimentacaoData } = await this.$http.post(
        "/caixa/movimentacao"
      );
      this.caixaInfo = caixaMovimentacaoData;
    },
    async abrirCaixa() {
      this.setLoading(true);
      try {
        const { data } = await this.$http.post("/caixa/create", {
          id_tipo: 1,
          impressao_comprovante: this.caixaImpressaoComprovante,
          valor_abertura: this.caixaValorAbertura,
        });
        if (this.caixaImpressaoComprovante)
          this.imprimir(data["comprovante-url"]);
        this.isCaixaFechadoManual = false;

        const momentData = this.$moment(data.caixa.data.data_abertura.date);
        const dataFormatted = momentData.format("HH:mm [de] DD/MM/YY");
        this.caixaAberturaHorario = dataFormatted;
        try {
          await this.loadCaixaInfo();
        } catch (error) {
          console.log(error);
        }
        this.$toast.success("Caixa aberto com sucesso!");
      } catch (error) {
        console.log("Erro ao salvar o caixa");
      }
      this.setLoading(false);
    },
    async fecharCaixa() {
      const fechamentoAsCegas = this.store.fechamentoAsCegas;
      const swalOptions = {
        icon: "warning",
        title: "Fechar o caixa",
        showCancelButton: true,
        confirmButtonText: `Sim`,
        cancelButtonText: `Não`,
        confirmButtonColor: "#f64e60",
      };

      if (fechamentoAsCegas) {
        swalOptions.width = "640px";
        swalOptions.html = `
          <p style="margin: 0 0 14px;">Você deseja fechar o movimento do caixa?</p>
          <div style="display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px 16px; text-align: left;">
            <div>
              <label
                for="fechamento-dinheiro"
                style="display: block; font-size: 13px; font-weight: 600; margin-bottom: 6px;"
                title="Meio de pagamento: Dinheiro"
              >
                Dinheiro R$(=)
              </label>
              <input
                id="fechamento-dinheiro"
                class="swal2-input"
                inputmode="decimal"
                placeholder="0,00"
                style="box-sizing: border-box; height: 42px; margin: 0; width: 100%;"
              />
            </div>
            <div>
              <label
                for="fechamento-pix"
                style="display: block; font-size: 13px; font-weight: 600; margin-bottom: 6px;"
                title="Meio de pagamento: Pix"
              >
                Pix R$(=)
              </label>
              <input
                id="fechamento-pix"
                class="swal2-input"
                inputmode="decimal"
                placeholder="0,00"
                style="box-sizing: border-box; height: 42px; margin: 0; width: 100%;"
              />
            </div>
            <div>
              <label
                for="fechamento-credito-loja"
                style="display: block; font-size: 13px; font-weight: 600; margin-bottom: 6px;"
                title="Meios de pagamento: parcelamentos, cheque, outros, crédito loja, boleto bancário, depósito bancário, transferência bancária e cashback"
              >
                Crédito loja R$(=)
              </label>
              <input
                id="fechamento-credito-loja"
                class="swal2-input"
                inputmode="decimal"
                placeholder="0,00"
                style="box-sizing: border-box; height: 42px; margin: 0; width: 100%;"
              />
            </div>
            <div>
              <label
                for="fechamento-cartoes"
                style="display: block; font-size: 13px; font-weight: 600; margin-bottom: 6px;"
                title="Meios de pagamento: débito, crédito, vale refeição, vale alimentação e vale combustível"
              >
                Cartões R$(=)
              </label>
              <input
                id="fechamento-cartoes"
                class="swal2-input"
                inputmode="decimal"
                placeholder="0,00"
                style="box-sizing: border-box; height: 42px; margin: 0; width: 100%;"
              />
            </div>
          </div>
        `;
        swalOptions.focusConfirm = false;
        swalOptions.didOpen = () => {
          const input = document.getElementById("fechamento-dinheiro");
          if (input) input.focus();
        };
        swalOptions.preConfirm = () => {
          const valores = {
            dinheiro: this.getValorFechamentoInput("fechamento-dinheiro"),
            pix: this.getValorFechamentoInput("fechamento-pix"),
            credito_loja: this.getValorFechamentoInput(
              "fechamento-credito-loja"
            ),
            cartoes: this.getValorFechamentoInput("fechamento-cartoes"),
          };

          const valoresValidos = Object.values(valores).every(
            (valor) => !Number.isNaN(valor) && valor >= 0
          );
          if (!valoresValidos) {
            this.$swal.showValidationMessage(
              "Informe valores de fechamento válidos."
            );
            return false;
          }

          return valores;
        };
      } else {
        swalOptions.text = " Você deseja fechar o movimento do caixa?";
      }

      this.$swal.fire(swalOptions).then(async (result) => {
        if (result.isConfirmed) {
          this.setLoading(true);
          try {
            const payload = {
              id_tipo: 2,
              impressao_comprovante: true,
            };
            if (fechamentoAsCegas) {
              payload.fechamento_pagamentos = result.value;
              payload.valor_movimento = Object.values(result.value).reduce(
                (total, valor) => total + valor,
                0
              );
            }

            const response = await this.$http.post("/caixa/create", payload);
            this.imprimir(response.data["comprovante-url"]);
            this.resetCaixaInfo();
            this.caixaValorAbertura = null;
            this.$toast.success("Caixa fechado com sucesso!");
            this.isCaixaFechadoManual = true;
            this.$router.push({ name: "vendasLista" });
          } catch (error) {
            console.log(error);
          }
          this.setLoading(false);
          swal.stopLoading();
          swal.close();
          return;
        }
      });
    },
    parseValorMonetario(value) {
      if (typeof value === "number") {
        return value;
      }

      const valor = String(value).replace(/\s/g, "");

      if (valor.includes(",")) {
        return parseFloat(valor.replace(/\./g, "").replace(",", "."));
      }

      return parseFloat(valor);
    },
    getValorFechamentoInput(id) {
      const input = document.getElementById(id);
      const value = input?.value?.trim();

      return value ? this.parseValorMonetario(value) : 0;
    },
    formatCaixaValorSigiloso(valor) {
      if (this.store.fechamentoAsCegas) {
        return "-";
      }

      return this.numberToReal(valor);
    },
    resetCaixaInfo() {
      this.caixaInfo = {
        caixa: null,
        dados_abertura: {
          valor_abertura: 0,
        },
        pagamentos: [],
        pagamentos_usados: [],
        sangria: 0,
        suprimento: 0,
        total: 0,
        total_contas_recebidas: 0,
        total_da_gaveta: 0,
        total_venda_na_gaveta: 0,
        total_venda_nao_gaveta: 0,
      };
    },
    async salvarSangriaSuprimento(operacao) {
      if (this.isSavingSangriaSuprimento) return;

      this.isSavingSangriaSuprimento = true;
      this.setLoading(true);
      try {
        const { data } = await this.$http.post("/caixa/create", {
          id_tipo: operacao === "Sangria" ? 3 : 4,
          impressao_comprovante: this.sangria_suprimento_comprovante,
          valor_movimento: this.caixaValorOperacao,
          descricao: this.descricaoOperacao ?? null,
        });
        if (this.sangria_suprimento_comprovante)
          this.imprimir(data["comprovante-url"]);
        await this.loadCaixaInfo();
        this.caixaValorOperacao = null;
        this.descricaoOperacao = null;
        this.keyToRender = this.keyToRender + 1;
        this.$toast.success("Caixa atualizado com sucesso!");
      } catch (error) {
        console.log(error);
      }
      this.setLoading(false);
      this.isSavingSangriaSuprimento = false;
    },

    handleShowPagamentoModal({ transmitir, isSave }) {
      if (this.store.vendedorObrigatorio && !this.venda.vendedor) {
        this.$toast.warning("Obrigatório informar o vendedor!");
        return;
      }

      this.$bvModal.show("modal-forma-pagamento");
      this.transmitir = transmitir;
      this.pagamento = this.pagamentos.find(
        (pagamento) =>
          pagamento.descricao === "À vista" || pagamento.descricao === "A vista"
      );
      this.justSave = isSave;
    },
    requestFullScreen() {
      this.isFullScreen = true;
      const elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      }
    },
    closeFullscreen() {
      this.isFullScreen = false;
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    resetCartaoInfo() {
      this.selectedAdmnistradora = null;
      this.selectedBandeira = null;
      this.codigoNsu = null;
    },
    handleSaveCardInfo() {
      this.posStep = 1;
      this.handlePosPagamento();
    },
    onSearchAdmin(search, loading) {
      if (search.length) {
        loading(true);
        this.searchAdmin(loading, search, this);
      }
    },
    searchAdmin: _.debounce(async (loading, search, vm) => {
      const { data } = await vm.$http.post("/pessoa/get-administradoras", {
        nome: search,
      });
      vm.administradoras = data;
      loading(false);
    }, 350),
    async handlePosPagamento() {
      if (this.paymentCardListIndex === this.paymentsCartao.length) {
        if (this.solicitarDadosCartao) this.$bvModal.show("modal-pos-venda");
        this.posStep = 2;
        try {
          const config = await this.garantirConfiguracaoPdvWeb();
          const dadosVenda = {
            ...this.venda,
            credito_cliente: null,
            serie: config.serie,
            id_configuracao:
              config.id_configuracao || config.id || this.idConfiguracaoPadraoPdvWeb,
          };

          const { data } = await this.$http.post("/nfe/update", {
            dados: { ...dadosVenda, id: this.nota.id },
          });
          this.nota = { ...this.nota, ...data };
          await this.transmitirNFCe(this.nota.id);

          this.posStep = 3;

          const printNFCe = await this.imprimirNFCe(this.nota.id);

          if (printNFCe["danfe-url"]) {
            this.imprimir(printNFCe["danfe-url"]);
          }

          if (printNFCe["voucher-url"]) {
            this.imprimir(printNFCe["voucher-url"]);
          }
          this.imprimirVoucherCreditoResidual(this.nota);
          this.paymentsCartao = [];
        } catch (error) {
          console.log(error);
        }
        this.setLoading(false);
        this.isLoadingSubmit = false;
        this.notificationStore.lastPosNotification = {};
        this.paymentCardListIndex = 0;
        this.$bvModal.hide("modal-pos-venda");
        this.posStep = 0;
        this.novaVenda();
        return;
      }
      this.posStep = 1;

      const idCardPaymentToUpdate =
        this.paymentsCartao[this.paymentCardListIndex].id;
      const indexPaymentModeCollectionCard =
        this.venda.paymentModeCollection.findIndex(
          (payment) =>
            payment.id === idCardPaymentToUpdate && !payment?.administradora
        );

      if (!this.solicitarDadosCartao) {
        if (
          this.nota.id != this.notificationStore.lastPosNotification.message.id
        ) {
          this.$toast.warning("Não foi possível atulizar a venda!");
          this.posStep = 6;
          return;
        }
        this.venda.paymentModeCollection[indexPaymentModeCollectionCard] = {
          ...this.venda.paymentModeCollection[indexPaymentModeCollectionCard],
          administradora: {
            cnpj_cpf:
              this.notificationStore.lastPosNotification.message.cnpj_cpf,
          },
          bandeira: this.notificationStore.lastPosNotification.message.bandeira,
          autorizacao:
            this.notificationStore.lastPosNotification.message.autorizacao,
        };
      } else {
        this.venda.paymentModeCollection[indexPaymentModeCollectionCard] = {
          ...this.venda.paymentModeCollection[indexPaymentModeCollectionCard],
          administradora: {
            cnpj_cpf: this.selectedAdmnistradora.cnpj_cpf,
          },
          bandeira: this.selectedBandeira.descricao,
          autorizacao: this.codigoNsu,
        };
        this.resetCartaoInfo();
      }
      this.paymentCardListIndex = this.paymentCardListIndex + 1;
      if (this.paymentCardListIndex < this.paymentsCartao.length)
        this.$bvModal.show("modal-pos-cartao");
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    addBuyer() {
      if (!this.newBuyer) {
        this.$toast.error("Preencha os campos obrigatórios");
        return;
      }
      this.valueCliente = { nome: this.newBuyer };
      this.valueCliente.cnpj_cpf = this.newBuyerCnpjCpf;
      this.venda.buyer.nome = this.newBuyer;
      this.venda.buyer.cnpj_cpf = this.newBuyerCnpjCpf;
      this.venda.observation = !this.nfe?.observation
        ? this.informacoesComplementares
        : this.nfe.observation;
      this.$bvModal.hide("modal-client-new");
      this.newBuyer = null;
      this.newBuyerCnpjCpf = null;
    },
    selectVencimento(index, date, pagamentoIndex) {
      if (
        this.isPagamentoCreditoCliente(this.listaPagamentos[pagamentoIndex])
      ) {
        return;
      }
      this.indexVencimento = index;
      this.vencimentoSelected = date;
      this.selectedPagamento.pagamento = pagamentoIndex;
    },
    changePagamentoEdited(valor) {
      this.pagamentoEditado = valor;
    },
    salvarVencimento() {
      this.listaPagamentos[this.selectedPagamento.pagamento].range[
        this.indexVencimento
      ].date = this.vencimentoSelected;
      this.$bvModal.hide("modal-calendar");
    },
    salvarPagamento() {
      this.listaPagamentos[this.selectedPagamento.pagamento].range[
        this.selectedPagamento.parcelaIndex
      ].value = this.roundTo2Digits(this.pagamentoEditado);
      this.pagamentoEditado = this.roundTo2Digits(this.pagamentoEditado);

      const indexEditPagamento = this.pagamentosEditados.findIndex(
        (pagamento) => pagamento?.index === this.selectedPagamento.parcelaIndex
      );
      if (indexEditPagamento === -1) {
        this.pagamentosEditados.push({
          index: this.selectedPagamento.parcelaIndex,
          value: this.pagamentoEditado,
        });
      } else {
        this.pagamentosEditados.splice(indexEditPagamento, 1, {
          index: this.selectedPagamento.parcelaIndex,
          value: this.pagamentoEditado,
        });
      }
      const pagamentosEditadosTotal = this.pagamentosEditados.reduce(
        (acc, pagamento) => {
          if (pagamento?.value)
            return this.roundTo2Digits(acc + pagamento.value);
          else return acc;
        },
        0
      );
      const editPagamentoCount = this.pagamentosEditados.length;

      const pagamentoRestante = this.roundTo2Digits(
        this.listaPagamentos[this.selectedPagamento.pagamento].value -
          pagamentosEditadosTotal
      );

      const valorParcelasRestantes = this.roundTo2Digits(
        pagamentoRestante /
          (this.listaPagamentos[this.selectedPagamento.pagamento].range.length -
            editPagamentoCount)
      );
      this.listaPagamentos[this.selectedPagamento.pagamento].range =
        this.listaPagamentos[this.selectedPagamento.pagamento].range.map(
          (item, index) => {
            const hasInPagamentosEditado = this.pagamentosEditados.find(
              (pagamento) => pagamento.index === index
            );
            return {
              ...item,
              value: hasInPagamentosEditado
                ? this.roundTo2Digits(hasInPagamentosEditado.value)
                : index !== this.selectedPagamento
                ? valorParcelasRestantes
                : this.pagamentoEditado,
            };
          }
        );

      this.$bvModal.hide("modal-pagamento");
    },
    substractQtd(index) {
      if (!this.store.productOfTradeCollection[index]) {
        return;
      }

      const itemAtual = this.store.productOfTradeCollection[index];
      // Kit com unidade propria: mantem o preco da unidade do kit (180),
      // nao o preco do produto base (15).
      let price = itemAtual?.isKitUnidade || itemAtual?.embalagem
        ? itemAtual.price
        : itemAtual.product.preco;
      let quantity =
        parseFloat(this.store.productOfTradeCollection[index].quantity) -
        parseFloat(1);

      if (quantity <= 0) {
        return;
      }

      const itemRetornavel = Boolean(
        this.store.productOfTradeCollection[index].vasilhame
      );
      const produtoItem = this.store.productOfTradeCollection[index].product;
      const atacadoHabilitado = produtoItem?.atacado_pdv_habilitado;
      const isAtacadoValue = this.produtoAtendeRegraAtacado(
        produtoItem,
        quantity,
        atacadoHabilitado
      );

      if (isAtacadoValue && !itemRetornavel && !itemAtual?.embalagem) {
        price = parseFloat(produtoItem.preco_atacado);
        this.store.productOfTradeCollection[index].price = price;
        produtoItem.tipo_atacado = true;
        produtoItem.preco = price;
      } else if (
        produtoItem.tipo_atacado &&
        !itemRetornavel &&
        !itemAtual?.embalagem
      ) {
        price = parseFloat(
          produtoItem?.preco_normal_atacado_pdv ?? produtoItem?.originalPreco
        );
        this.store.productOfTradeCollection[index].price = price;
        produtoItem.tipo_atacado = false;
        produtoItem.preco = price;
      }

      this.store.productOfTradeCollection[index].quantity = quantity;
      this.store.productOfTradeCollection[index].totalPrice =
        parseFloat(price) * quantity;
      this.store.productOfTradeCollection[index] = atualizarVasilhameDoItem(
        this.store.productOfTradeCollection[index],
        quantity
      );
      this._onProdutosAlteradosManualmente();
    },
    getPrecoItemPDV(item) {
      const preco = item?.price ?? item?.product?.preco ?? 0;
      if (typeof preco === "number") return preco;
      return this.formatNumberToFloat(String(preco).replace("R$", "").trim());
    },
    parseValorAjusteItem(value) {
      if (typeof value === "number") return value;
      const valor = String(value || "0")
        .replace("R$", "")
        .replace("%", "")
        .trim();

      if (!valor) return 0;

      return this.formatNumberToFloat(valor);
    },
    abrirModalAjusteItem(index) {
      const item = this.store.productOfTradeCollection[index];
      if (!item || !item.active) return;

      const precoAtual = this.getPrecoItemPDV(item);
      const precoOriginal = item.precoOriginalPDV || precoAtual;

      this.ajusteItemModal = {
        index,
        produto: item.product?.descricao || "",
        operacao: item.operacaoAjustePDV || "desconto",
        tipo: item.tipoAjustePDV || 2,
        valor: "",
        precoBase: precoAtual,
        precoOriginal,
        precoAtual,
      };
      this.$bvModal.show("modal-ajuste-item");
    },
    abrirModalAjusteUltimoProduto() {
      const produtos = this.store.productOfTradeCollection;
      const index = produtos
        .map((item, itemIndex) => ({ item, itemIndex }))
        .reverse()
        .find(({ item }) => item?.active)?.itemIndex;

      if (index === undefined) {
        this.$toast.warning("Adicione um produto para aplicar ajuste!");
        return;
      }

      this.abrirModalAjusteItem(index);
    },
    setOperacaoAjusteItem(operacao) {
      this.ajusteItemModal.operacao = operacao;
    },
    focusAjusteItemInput() {
      this.$nextTick(() => {
        const inputEl =
          this.$refs.ajusteItemInput?.$el || this.$refs.ajusteItemInput;

        if (inputEl) {
          inputEl.focus();
          inputEl.select();
        }
      });
    },
    calcularValorAjusteItem() {
      const precoBase = Number(this.ajusteItemModal.precoBase || 0);
      const valorAjuste = this.parseValorAjusteItem(this.ajusteItemModal.valor);

      if (!Number.isFinite(precoBase) || precoBase <= 0) {
        return 0;
      }

      if (!Number.isFinite(valorAjuste) || valorAjuste <= 0) {
        return 0;
      }

      return this.ajusteItemModal.tipo === 2
        ? precoBase * (valorAjuste / 100)
        : valorAjuste;
    },
    calcularPrecoComAjusteItem() {
      const precoBase = Number(this.ajusteItemModal.precoBase || 0);
      const valorAjuste = this.calcularValorAjusteItem();

      if (!Number.isFinite(precoBase) || precoBase <= 0) {
        return 0;
      }

      if (!Number.isFinite(valorAjuste) || valorAjuste <= 0) {
        return precoBase;
      }

      const novoPreco =
        this.ajusteItemModal.operacao === "acrescimo"
          ? precoBase + valorAjuste
          : precoBase - valorAjuste;

      return this.roundTo2Digits(
        Math.max(novoPreco, 0),
        this.priceOptions.precision
      );
    },
    aplicarAjusteItem() {
      const index = this.ajusteItemModal.index;
      const item = this.store.productOfTradeCollection[index];
      const valorAjuste = this.parseValorAjusteItem(this.ajusteItemModal.valor);

      if (!item) return;

      if (!Number.isFinite(valorAjuste) || valorAjuste <= 0) {
        this.$toast.warning("Informe o valor do ajuste!");
        this.focusAjusteItemInput();
        return;
      }

      if (
        this.ajusteItemModal.operacao === "desconto" &&
        this.ajusteItemModal.tipo === 2 &&
        valorAjuste > 100
      ) {
        this.$toast.warning("O desconto percentual não pode passar de 100%!");
        this.focusAjusteItemInput();
        return;
      }

      const precoBase = Number(this.ajusteItemModal.precoBase || 0);
      const valorAjusteEmReais = this.calcularValorAjusteItem();

      if (
        this.ajusteItemModal.operacao === "desconto" &&
        valorAjusteEmReais > precoBase
      ) {
        this.$toast.warning(
          "O desconto em reais não pode ser maior que o preço unitário!"
        );
        this.focusAjusteItemInput();
        return;
      }

      const novoPreco = this.calcularPrecoComAjusteItem();
      const quantidade = parseFloat(item.quantity || 0);
      const totalPrice = this.roundTo2Digits(
        novoPreco * quantidade,
        this.priceOptions.precision
      );
      const product = {
        ...item.product,
        preco: novoPreco,
      };
      const produtoComAjuste = {
        ...item,
        price: novoPreco,
        product,
        totalPrice,
        precoOriginalPDV: item.precoOriginalPDV || precoBase,
        operacaoAjustePDV: this.ajusteItemModal.operacao,
        tipoAjustePDV: this.ajusteItemModal.tipo,
        valorAjustePDV: this.roundTo2Digits(
          valorAjusteEmReais,
          this.priceOptions.precision
        ),
        descontoPDV:
          this.ajusteItemModal.operacao === "desconto"
            ? this.roundTo2Digits(
                valorAjusteEmReais,
                this.priceOptions.precision
              )
            : 0,
        acrescimoPDV:
          this.ajusteItemModal.operacao === "acrescimo"
            ? this.roundTo2Digits(
                valorAjusteEmReais,
                this.priceOptions.precision
              )
            : 0,
      };

      const applyAjusteItem = () => {
        this.$set(this.store.productOfTradeCollection, index, produtoComAjuste);
        this.$bvModal.hide("modal-ajuste-item");
        this.$toast.success("Ajuste aplicado no item!");
      };

      if (this.ajusteItemModal.operacao === "desconto") {
        return this.getRequestAdmin(applyAjusteItem);
      }

      return applyAjusteItem();
    },
    async abrirModalProdutoFiscalPDV(index) {
      const item = this.store.productOfTradeCollection[index];
      const productId = item?.product?.id || item?.product?.id_produto;

      if (!item?.active || !productId) {
        return;
      }

      const produtoCompleto = await this.getProdutoCompletoFiscalPDV(
        item.product
      );
      const product = this.mergeProdutoFiscalPDV(item.product, produtoCompleto);
      this.produtoFiscalForm = {
        id: product.id || product.id_produto || productId,
        currentIndex: index,
        perfil_tributario:
          product.perfil_tributario || product.perfilTributario || null,
        cst_csosn: product.cst_csosn || product.cstCsosn || null,
        cst_csosn_contribuinte:
          product.cst_csosn_contribuinte ||
          product.cstCsosnContribuinte ||
          null,
        cfop: product.cfop || null,
        cfop_nfce: product.cfop_nfce || product.cfopNfce || null,
        cest: product.cest || null,
        ncm: product.ncm || null,
        excecaoFiscal: product.excecaoFiscal || "",
        cenq: product.cenq || null,
        cst_ipi: product.cst_ipi || product.cstIpi || null,
        cst_pis: product.cst_pis || product.cstPis || null,
        cst_cofins: product.cst_cofins || product.cstCofins || null,
        tributacao: product.tributacao || null,
        tributacao_s_t: product.tributacao_s_t || product.tributacaoST || null,
        fcp: product.fcp || null,
        ipi: product.ipi || 0,
        pis: product.pis || 0,
        cofins: product.cofins || 0,
        mva: product.mva || 0,
        codigo_beneficio: product.codigo_beneficio || "",
      };
      this.carregarDadosFiscaisProdutoPDV();
      this.produtoFiscalModalOpen = true;
    },
    async getProdutoCompletoFiscalPDV(product) {
      const id = product?.id || product?.id_produto || product?.codigo;

      if (!id) return null;

      try {
        const { data } = await this.$http.post("/produtos/find", { id });
        return data;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    mergeProdutoFiscalPDV(product, produtoCompleto) {
      const produtoBase = _.cloneDeep(product || {});
      const produtoCadastro = _.cloneDeep(produtoCompleto || {});

      Object.entries(produtoCadastro).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          produtoBase[key] = value;
        }
      });

      return produtoBase;
    },
    closeModalProdutoFiscalPDV() {
      this.produtoFiscalModalOpen = false;
      this.produtoFiscalForm = {};
      this.isSavingProdutoFiscalPDV = false;
    },
    async carregarDadosFiscaisProdutoPDV() {
      const [
        cstcsosns,
        tributacoes,
        cenqs,
        cstipis,
        cstspis,
        cstscofins,
      ] = await Promise.all([
        this.getCstCsosn(),
        this.getTributacao(),
        this.getCenqByCodigo(),
        this.getCSTIPIByCodigo(),
        this.getCSTPISByCodigo(),
        this.getCSTCofinsByCodigo(),
      ]);

      this.cstcsosnsPDV = cstcsosns;
      this.tributacoesPDV = tributacoes;
      this.cenqsPDV = cenqs;
      this.cstipisPDV = cstipis;
      this.cstspisPDV = cstspis;
      this.cstscofinsPDV = cstscofins;
    },
    getIdFromFiscalObject(value, idKey) {
      if (!value) return null;
      if (value[idKey]) return value[idKey];
      if (value.id) return value.id;
      return null;
    },
    normalizarPercentualFiscalPDV(value) {
      if (value === null || value === undefined || value === "") return 0;
      if (typeof value === "number") return value;

      return this.formatNumberToFloat(String(value).replace("%", "").trim());
    },
    montarPayloadFiscalProdutoPDV() {
      const form = this.produtoFiscalForm;

      return {
        id: form.id,
        id_perfil_tributario: this.getIdFromFiscalObject(
          form.perfil_tributario,
          "id"
        ),
        id_cfop: this.getIdFromFiscalObject(form.cfop, "id_cfop"),
        id_cfop_nfce: this.getIdFromFiscalObject(form.cfop_nfce, "id_cfop"),
        id_cest: this.getIdFromFiscalObject(form.cest, "id_cest"),
        id_ncm: this.getIdFromFiscalObject(form.ncm, "id_ncm"),
        id_cst_csosn: this.getIdFromFiscalObject(
          form.cst_csosn,
          "id_cst_csosn"
        ),
        id_cst_csosn_contribuinte: this.getIdFromFiscalObject(
          form.cst_csosn_contribuinte,
          "id_cst_csosn"
        ),
        id_cenq: this.getIdFromFiscalObject(form.cenq, "id_cenq"),
        id_cstipi: this.getIdFromFiscalObject(form.cst_ipi, "id_cstipi"),
        id_cstpis: this.getIdFromFiscalObject(form.cst_pis, "id_cstpis"),
        id_cstcofins: this.getIdFromFiscalObject(
          form.cst_cofins,
          "id_cstcofins"
        ),
        id_tributacao: this.getIdFromFiscalObject(form.tributacao, "id"),
        id_tributacao_st: this.getIdFromFiscalObject(
          form.tributacao_s_t,
          "id"
        ),
        id_fcp: this.getIdFromFiscalObject(form.fcp, "id"),
        ipi: this.normalizarPercentualFiscalPDV(form.ipi),
        pis: this.normalizarPercentualFiscalPDV(form.pis),
        cofins: this.normalizarPercentualFiscalPDV(form.cofins),
        mva: this.normalizarPercentualFiscalPDV(form.mva),
        codigo_beneficio: form.codigo_beneficio || null,
        excecaoFiscal: form.excecaoFiscal || null,
      };
    },
    setPerfilTributarioPDV(perfil) {
      this.produtoFiscalForm.perfil_tributario = perfil;

      if (!perfil) return;

      const relationMap = {
        cst_csosn: "cst_csosn",
        cst_csosn_contribuinte: "cst_csosn_contribuinte",
        cfop: "cfop",
        cfop_nfce: "cfop_nfce",
        cest: "cest",
        ncm: "ncm",
        cenq: "cenq",
        cst_ipi: "cst_ipi",
        cst_pis: "cst_pis",
        cst_cofins: "cst_cofins",
        tributacao: "tributacao",
        tributacao_s_t: "tributacao_st",
        fcp: "fcp",
      };

      Object.entries(relationMap).forEach(([formField, profileField]) => {
        if (perfil[profileField]) {
          this.$set(this.produtoFiscalForm, formField, perfil[profileField]);
        }
      });

      [
        "ipi",
        "pis",
        "cofins",
        "mva",
        "codigo_beneficio",
        "excecaoFiscal",
      ].forEach((field) => {
        if (perfil[field] !== null && perfil[field] !== undefined) {
          this.$set(this.produtoFiscalForm, field, perfil[field]);
        }
      });
    },
    onSearchPerfilTributarioPDV(search, loading) {
      const busca = this.prepararBuscaDireta(search, loading);
      busca.loading(true);
      this.searchPerfilTributarioPDV(busca.loading, busca.termo, this);
    },
    searchPerfilTributarioPDV: _.debounce(async (loading, search, vm) => {
      vm.perfisTributariosPDV = await vm.getPerfilTributarioByDescricao(search);
      loading(false);
    }, 350),
    onSearchCFOPPDV(search, loading) {
      if (!search) return;
      loading(true);
      this.searchCFOPPDV(loading, search, this);
    },
    searchCFOPPDV: _.debounce(async (loading, search, vm) => {
      vm.cfopsPDV = await vm.getCFOPByCodigo(search);
      loading(false);
    }, 350),
    onSearchCFOPNfcePDV(search, loading) {
      if (!search) return;
      loading(true);
      this.searchCFOPNfcePDV(loading, search, this);
    },
    searchCFOPNfcePDV: _.debounce(async (loading, search, vm) => {
      vm.cfopsNfcePDV = await vm.getCFOPByCodigo(search);
      loading(false);
    }, 350),
    onSearchCESTPDV(search, loading) {
      if (!search) return;
      loading(true);
      this.searchCESTPDV(loading, search, this);
    },
    searchCESTPDV: _.debounce(async (loading, search, vm) => {
      vm.cestsPDV = await vm.getCESTByCodigo(search);
      loading(false);
    }, 350),
    onSearchNCMPDV(search, loading) {
      if (!search) return;
      loading(true);
      this.searchNCMPDV(loading, search, this);
    },
    searchNCMPDV: _.debounce(async (loading, search, vm) => {
      vm.ncmsPDV = await vm.getNCM(search);
      loading(false);
    }, 350),
    onSearchCENQPDV(search, loading) {
      if (!search) return;
      loading(true);
      this.searchCENQPDV(loading, search, this);
    },
    searchCENQPDV: _.debounce(async (loading, search, vm) => {
      vm.cenqsPDV = await vm.getCenqByCodigo(search);
      loading(false);
    }, 350),
    onSearchCSTIPIPDV(search, loading) {
      if (!search) return;
      loading(true);
      this.searchCSTIPIPDV(loading, search, this);
    },
    searchCSTIPIPDV: _.debounce(async (loading, search, vm) => {
      vm.cstipisPDV = await vm.getCSTIPIByCodigo(search);
      loading(false);
    }, 350),
    onSearchCSTPISPDV(search, loading) {
      if (!search) return;
      loading(true);
      this.searchCSTPISPDV(loading, search, this);
    },
    searchCSTPISPDV: _.debounce(async (loading, search, vm) => {
      vm.cstspisPDV = await vm.getCSTPISByCodigo(search);
      loading(false);
    }, 350),
    onSearchCSTCOFINSPDV(search, loading) {
      if (!search) return;
      loading(true);
      this.searchCSTCOFINSPDV(loading, search, this);
    },
    searchCSTCOFINSPDV: _.debounce(async (loading, search, vm) => {
      vm.cstscofinsPDV = await vm.getCSTCofinsByCodigo(search);
      loading(false);
    }, 350),
    async salvarProdutoFiscalPDV() {
      const index = this.produtoFiscalForm.currentIndex;
      const item = this.store.productOfTradeCollection[index];

      if (!item) return;

      this.isSavingProdutoFiscalPDV = true;
      let data = null;
      try {
        const response = await this.$http.post(
          "/produtos/update-fiscal-pdv",
          this.montarPayloadFiscalProdutoPDV()
        );
        data = response.data;
      } catch (error) {
        this.isSavingProdutoFiscalPDV = false;
        throw error;
      }
      const produtoAtualizado = data || this.produtoFiscalForm;
      const preco = this.getPrecoItemPDV(item);
      const quantidade = parseFloat(item.quantity || 0);
      const totalPrice = this.roundTo2Digits(
        preco * quantidade - parseFloat(item.discount || 0),
        this.priceOptions.precision
      );
      const product = {
        ...item.product,
        ...produtoAtualizado,
        cfop:
          produtoAtualizado.cfop ||
          this.produtoFiscalForm.cfop ||
          item.product.cfop,
        cfop_nfce:
          produtoAtualizado.cfopNfce ||
          produtoAtualizado.cfop_nfce ||
          this.produtoFiscalForm.cfop_nfce ||
          item.product.cfop_nfce,
        ncm:
          produtoAtualizado.ncm || this.produtoFiscalForm.ncm || item.product.ncm,
        cest:
          produtoAtualizado.cest ||
          this.produtoFiscalForm.cest ||
          item.product.cest,
        cst_csosn:
          produtoAtualizado.cstCsosn ||
          produtoAtualizado.cst_csosn ||
          this.produtoFiscalForm.cst_csosn ||
          item.product.cst_csosn,
        cst_csosn_contribuinte:
          produtoAtualizado.cstCsosnContribuinte ||
          produtoAtualizado.cst_csosn_contribuinte ||
          this.produtoFiscalForm.cst_csosn_contribuinte ||
          item.product.cst_csosn_contribuinte,
        cst_ipi:
          produtoAtualizado.cstIpi ||
          produtoAtualizado.cst_ipi ||
          this.produtoFiscalForm.cst_ipi ||
          item.product.cst_ipi,
        cst_pis:
          produtoAtualizado.cstPis ||
          produtoAtualizado.cst_pis ||
          this.produtoFiscalForm.cst_pis ||
          item.product.cst_pis,
        cst_cofins:
          produtoAtualizado.cstCofins ||
          produtoAtualizado.cst_cofins ||
          this.produtoFiscalForm.cst_cofins ||
          item.product.cst_cofins,
        tributacao:
          produtoAtualizado.tributacao ||
          this.produtoFiscalForm.tributacao ||
          item.product.tributacao,
        tributacao_s_t:
          produtoAtualizado.tributacaoST ||
          produtoAtualizado.tributacao_s_t ||
          this.produtoFiscalForm.tributacao_s_t ||
          item.product.tributacao_s_t,
        fcp:
          produtoAtualizado.fcp ||
          this.produtoFiscalForm.fcp ||
          item.product.fcp,
        perfil_tributario:
          produtoAtualizado.perfilTributario ||
          produtoAtualizado.perfil_tributario ||
          this.produtoFiscalForm.perfil_tributario ||
          item.product.perfil_tributario,
        preco,
      };

      this.$set(this.store.productOfTradeCollection, index, {
        ...item,
        product,
        price: preco,
        totalPrice,
        exibirEdicaoFiscalPDV: false,
        erroFiscalPDV: null,
      });

      this.closeModalProdutoFiscalPDV();
      this.$toast.success("Cadastro fiscal do produto atualizado!");
    },
    buscarProduto() {
      this.$refs.buscarProduto.$el.querySelector("input").focus();
    },
    setIsPercent(tipo = "desconto") {
      if (tipo === "acrescimo") {
        this.tipoAcrescimoValue = this.tipoAcrescimoValue === 1 ? 2 : 1;
        return;
      }

      this.tipoDescontoValue = this.tipoDescontoValue === 1 ? 2 : 1;
      this.isPercent = this.tipoDescontoValue === 2;
    },
    setDesconto(value) {
      this.valueDiscount = value;
    },
    setAcrescimo(value) {
      this.valueExtraValue = value;
    },
    produtoAtendeRegraAtacado(produto, quantidade, atacadoHabilitado) {
      const precoAtacado = parseFloat(produto?.preco_atacado ?? 0);
      const quantidadeAtacado = parseFloat(produto?.quantidade_atacado ?? 0);
      const quantidadeInformada = this.getNumeroPdv(quantidade);
      const precoListaCliente = parseFloat(produto?.preco_lista_cliente ?? 0);

      if (precoAtacado <= 0 || precoListaCliente > 0) return false;
      if (atacadoHabilitado === true) return true;

      return quantidadeInformada >= quantidadeAtacado;
    },
    getNumeroPdv(valor) {
      if (typeof valor === "number") return valor;
      const valorTexto = String(valor ?? "").trim();

      if (valorTexto.includes(",")) {
        return parseFloat(this.valorUS(valorTexto)) || 0;
      }

      return parseFloat(valorTexto) || 0;
    },
    getPrecoNormalProdutoPdv(produto) {
      const precoNormal =
        produto?.preco_normal_atacado_pdv ?? produto?.preco ?? 0;

      return this.getNumeroPdv(precoNormal);
    },
    toggleModoAtacado() {
      this.modoAtacadoAtivo = !this.modoAtacadoAtivo;
    },
    addDescontoAcrescimo() {
      if (this.valorTotal === 0) return;
      if (this.desconto === 0 && this.acrescimo === 0) {
        this.valorTotal = this.store.productOfTradeCollection.reduce(
          (total, item) => total + item.totalPrice,
          0
        );
        this.descontoAplicado = false;
        this.acrescimoAplicado = false;
      } else {
        if (this.desconto !== 0) {
          this.valorTotal = this.valorTotal - this.desconto;
          this.descontoAplicado = true;
        } else {
          this.valorTotal = this.valorTotal + this.acrescimo;
          this.acrescimoAplicado = true;
        }
      }
    },
    addQtd(index) {
      if (!this.store.productOfTradeCollection[index]) {
        return;
      }

      const itemAtual = this.store.productOfTradeCollection[index];
      // Kit com unidade propria (fardo/caixa): mantem o preco da unidade do kit
      // (ex.: 180 do fardo), nao recalcula a partir do preco do produto base
      // (15 do mouse), que serve apenas para baixa de estoque convertida.
      let price = itemAtual?.isKitUnidade || itemAtual?.embalagem
        ? itemAtual.price
        : itemAtual.product.preco;
      let quantity =
        parseFloat(this.store.productOfTradeCollection[index].quantity) +
        parseFloat(1);

      if (!this.validarEstoqueItemVenda(index, quantity)) {
        return;
      }

      const itemReserva = this.store.productOfTradeCollection[index];
      const reservadaCondicional =
        parseFloat(itemReserva?.product?.quantidade_reservada_condicional) || 0;

      if (this.store.desconsiderarEstoqueCondicional) {
        // Flag ativa: pula validacao de reserva condicional
      } else if (reservadaCondicional > 0) {
        const estoqueReserva = this.getEstoqueDisponivelProduto(itemReserva);

        if (estoqueReserva !== null) {
          const disponivelReserva = estoqueReserva - reservadaCondicional;
          // Usa a quantidade convertida (kit-unidade: 1 fardo -> 12 un) para
          // comparar contra a reserva condicional do estoque fisico.
          const conversor = this.getFatorConversaoItem(itemReserva);
          const quantidadeReserva =
            conversor > 0
              ? this.getQuantidadeBaixaEstoqueItemTotal(itemReserva) -
                this.getQuantidadeBaixaEstoqueItem(itemReserva) +
                this.toFloatQuantidade(quantity) * conversor
              : this.getQuantidadeTotalProduto(itemReserva, index, quantity);

          if (quantidadeReserva > disponivelReserva) {
            this.$toast.warning(
              "Este produto possui quantidades reservadas em condicional e não pode ser lançado na venda."
            );
            return;
          }
        }
      }

      const itemRetornavel = Boolean(
        this.store.productOfTradeCollection[index].vasilhame
      );
      const produtoItem = this.store.productOfTradeCollection[index].product;
      const atacadoHabilitado = produtoItem?.atacado_pdv_habilitado;
      const isAtacadoValue = this.produtoAtendeRegraAtacado(
        produtoItem,
        quantity,
        atacadoHabilitado
      );

      if (isAtacadoValue && !itemRetornavel && !itemAtual?.embalagem) {
        price = parseFloat(produtoItem.preco_atacado);

        this.store.productOfTradeCollection[index].price = price;
        produtoItem.tipo_atacado = true;
        if (produtoItem.preco_normal_atacado_pdv === undefined) {
          produtoItem.preco_normal_atacado_pdv = produtoItem.preco;
        }
        produtoItem.originalPreco = produtoItem.preco;
        produtoItem.preco = price;
      }

      // Kit-unidade: garante que o price da unidade do kit (180) e mantido,
      // pois os blocos de atacado acima nao se aplicam a itens de kit-unidade.
      if (itemAtual?.isKitUnidade || itemAtual?.embalagem) {
        this.store.productOfTradeCollection[index].price = price;
      }

      this.store.productOfTradeCollection[index].quantity = quantity;
      this.store.productOfTradeCollection[index].totalPrice =
        parseFloat(price) * quantity;
      this.store.productOfTradeCollection[index] = atualizarVasilhameDoItem(
        this.store.productOfTradeCollection[index],
        quantity
      );
      this.avisarEstoqueMinimo(
        this.store.productOfTradeCollection[index],
        index,
        quantity
      );
      this._onProdutosAlteradosManualmente();
    },
    normalizarItensEstoqueVenda(produtos) {
      return (produtos ?? []).map((item) => {
        const product = item?.product ? { ...item.product } : null;

        if (
          product &&
          product.quantidade_original === undefined &&
          product.quantidade_original_produto === undefined
        ) {
          const estoqueProduto = this.getEstoqueDisponivelProduto({ product });

          if (estoqueProduto !== null) {
            product.quantidade_original = estoqueProduto;
          }
        }

        return product ? { ...item, product } : item;
      });
    },
    validarEstoqueItemVenda(index, quantity) {
      if (!this.store.verificaEstoque) {
        return true;
      }

      const item = this.store.productOfTradeCollection[index];
      const estoqueProduto = this.getEstoqueDisponivelProduto(item);

      if (estoqueProduto !== null) {
        // Usa a quantidade convertida (kit-unidade) para comparar contra o
        // estoque fisico do produto base.
        const conversor = this.getFatorConversaoItem(item);
        const qtyConvertida =
          conversor > 0 ? this.toFloatQuantidade(quantity) * conversor : null;
        const quantidadeProduto = qtyConvertida !== null
          ? this.getQuantidadeBaixaEstoqueItemTotal(item) -
            this.getQuantidadeBaixaEstoqueItem(item) +
            qtyConvertida
          : this.getQuantidadeTotalProduto(item, index, quantity);

        if (quantidadeProduto > estoqueProduto) {
          this.$toast.warning(
            "Quantidade informada no item é superior a seu estoque!"
          );
          return false;
        }
      }

      const estoqueLote = this.getEstoqueDisponivelLote(item);

      if (estoqueLote !== null) {
        const quantidadeLote = this.getQuantidadeTotalLote(item, index, quantity);

        if (quantidadeLote > estoqueLote) {
          this.$toast.warning(
            "Quantidade informada no item é superior ao estoque do lote selecionado!"
          );
          return false;
        }
      }

      const estoqueCombinacao = this.getEstoqueDisponivelCombinacao(item);

      if (estoqueCombinacao !== null) {
        const quantidadeCombinacao = this.getQuantidadeTotalCombinacao(item, index, quantity);

        if (quantidadeCombinacao > estoqueCombinacao) {
          this.$toast.warning(
            "Quantidade informada no item é superior ao estoque da variação selecionada!"
          );
          return false;
        }
      }

      return true;
    },
    validarEstoqueNovoProduto(produto, quantity) {
      const item = {
        product: produto,
        lote: produto?.lote_baixa,
        combinacao: produto?.combinacao,
        quantity,
        kit_unidade_medida: produto?.kit_unidade_medida,
        embalagem: produto?.embalagem_selecionada,
      };

      const estoqueProduto = this.getEstoqueDisponivelProduto(item);

      if (estoqueProduto !== null) {
        // Usa a quantidade convertida (kit-unidade: 1 fardo -> 12 un) para
        // comparar contra o estoque fisico do produto base.
        const quantidadeProduto =
          this.getQuantidadeBaixaEstoqueItem(item) +
          this.getQuantidadeBaixaEstoqueItemTotal(produto);

        if (quantidadeProduto > estoqueProduto) {
          this.$toast.warning(
            "Quantidade informada no item é superior a seu estoque!"
          );
          return false;
        }
      }

      const estoqueLote = this.getEstoqueDisponivelLote(item);

      if (estoqueLote !== null) {
        const quantidadeLote =
          this.getQuantidadeTotalLote(item, null, 0) + parseFloat(quantity);

        if (quantidadeLote > estoqueLote) {
          this.$toast.warning(
            "Quantidade informada no item é superior ao estoque do lote selecionado!"
          );
          return false;
        }
      }

      const estoqueCombinacao = this.getEstoqueDisponivelCombinacao(item);

      if (estoqueCombinacao !== null) {
        const quantidadeCombinacao =
          this.getQuantidadeTotalCombinacao(item, null, 0) +
          parseFloat(quantity);

        if (quantidadeCombinacao > estoqueCombinacao) {
          this.$toast.warning(
            "Quantidade informada no item é superior ao estoque da variação selecionada!"
          );
          return false;
        }
      }

      return true;
    },
    avisarEstoqueMinimo(item, indexAlterado = null, quantity = 0) {
      const estoqueMinimo = this.toFloatQuantidade(
        item?.product?.estoque_minimo
      );

      if (estoqueMinimo <= 0) {
        return;
      }

      const estoqueProduto = this.getEstoqueDisponivelProduto(item);

      if (estoqueProduto === null) {
        return;
      }

      const conversor = this.getFatorConversaoItem(item);
      const quantidadeProduto =
        conversor > 0
          ? this.getQuantidadeBaixaEstoqueItemTotal(item) -
            this.getQuantidadeBaixaEstoqueItem(item) +
            this.getQuantidadeBaixaEstoqueItem(item, quantity)
          : this.getQuantidadeTotalProduto(item, indexAlterado, quantity);
      const saldoAposVenda = estoqueProduto - quantidadeProduto;

      if (saldoAposVenda < estoqueMinimo) {
        const descricao = item?.product?.descricao || "O produto selecionado";
        const saldoFormatado = this.numberToReal(saldoAposVenda, "quantidade");
        const minimoFormatado = this.numberToReal(estoqueMinimo, "quantidade");

        this.$toast.warning(
          `${descricao} ficará abaixo do estoque mínimo. Saldo após a venda: ${saldoFormatado}. Estoque mínimo: ${minimoFormatado}.`
        );
      }
    },
    getEstoqueDisponivelProduto(item) {
      const estoque =
        item?.product?.quantidade_original ??
        item?.product?.quantidade_original_produto ??
        item?.product?.estoque_disponivel ??
        item?.product?.estoque ??
        item?.product?.saldo_estoque ??
        item?.product?.quantidade;

      if (estoque === undefined || estoque === null) {
        return null;
      }

      return this.toFloatQuantidade(estoque);
    },
    getEstoqueDisponivelLote(item) {
      const lote = item?.lote ?? item?.product?.lote_baixa;
      const estoque =
        lote?.quantidade_original ?? lote?.quantidade_original_lote;

      if (estoque === undefined || estoque === null) {
        return null;
      }

      return this.toFloatQuantidade(estoque);
    },
    getEstoqueDisponivelCombinacao(item) {
      const combinacao = item?.combinacao ?? item?.product?.combinacao;

      if (!combinacao) {
        return null;
      }

      const estoque =
        item?.product?.quantidade_original_combinacao ??
        item?.quantidade_original_combinacao;

      if (estoque === undefined || estoque === null) {
        return null;
      }

      return this.toFloatQuantidade(estoque);
    },
    getQuantidadeTotalProduto(itemReferencia, indexAlterado, quantity) {
      const idProduto = itemReferencia?.product?.id;

      if (!idProduto) {
        return this.toFloatQuantidade(quantity);
      }

      return this.store.productOfTradeCollection.reduce(
        (total, item, index) => {
          if (item?.product?.id !== idProduto) {
            return total;
          }

          return (
            total +
            this.toFloatQuantidade(
              index === indexAlterado ? quantity : item.quantity
            )
          );
        },
        0
      );
    },
    /**
     * Quantidade efetiva de baixa de estoque para um item.
     *
     * Itens de kit com unidade de medida propria (fardo/caixa) vendem na
     * unidade comercial (ex.: 1 fardo) mas baixam do estoque a quantidade
     * convertida do produto base (ex.: 1 fardo conversor 12 -> 12 un). As
     * validacoes de estoque/reserva devem usar este valor para comparar contra
     * o estoque fisico do produto base.
     */
    getQuantidadeBaixaEstoqueItem(item, quantity) {
      const qty = this.toFloatQuantidade(
        quantity ?? item?.quantity ?? 0
      );
      const conversor = this.getFatorConversaoItem(item);
      if (conversor > 0) {
        return qty * conversor;
      }
      return qty;
    },
    getFatorConversaoItem(item) {
      const embalagem =
        item?.embalagem ??
        item?.embalagem_selecionada ??
        item?.product?.embalagem_selecionada;

      return (
        parseFloat(embalagem?.fator_conversao) ||
        parseFloat(item?.kit_unidade_medida?.conversor) ||
        0
      );
    },
    /**
     * Soma das quantidades de baixa (convertidas) dos itens do mesmo produto
     * que ja estao no carrinho. Usado nas validacoes de estoque/reserva para
     * kits com unidade de medida propria.
     */
    getQuantidadeBaixaEstoqueItemTotal(itemReferencia) {
      const idProduto = itemReferencia?.id ?? itemReferencia?.product?.id;
      if (!idProduto) {
        return 0;
      }
      return this.store.productOfTradeCollection.reduce((total, item) => {
        if (item?.product?.id !== idProduto) {
          return total;
        }
        return total + this.getQuantidadeBaixaEstoqueItem(item);
      }, 0);
    },
    getQuantidadeTotalLote(itemReferencia, indexAlterado, quantity) {
      const idLote = this.getIdLoteItem(itemReferencia);

      if (!idLote) {
        return this.toFloatQuantidade(quantity);
      }

      return this.store.productOfTradeCollection.reduce(
        (total, item, index) => {
          if (this.getIdLoteItem(item) !== idLote) {
            return total;
          }

          return (
            total +
            this.toFloatQuantidade(
              index === indexAlterado ? quantity : item.quantity
            )
          );
        },
        0
      );
    },
    getQuantidadeTotalCombinacao(itemReferencia, indexAlterado, quantity) {
      const chaveCombinacao = this.getChaveCombinacaoItem(itemReferencia);
      const idProduto = itemReferencia?.product?.id;

      if (!chaveCombinacao || !idProduto) {
        return this.toFloatQuantidade(quantity);
      }

      return this.store.productOfTradeCollection.reduce(
        (total, item, index) => {
          if (
            item?.product?.id !== idProduto ||
            this.getChaveCombinacaoItem(item) !== chaveCombinacao
          ) {
            return total;
          }

          return (
            total +
            this.toFloatQuantidade(
              index === indexAlterado ? quantity : item.quantity
            )
          );
        },
        0
      );
    },
    getIdLoteItem(item) {
      const lote = item?.lote ?? item?.product?.lote_baixa;

      return lote?.id_produto_lote ?? null;
    },
    getChaveCombinacaoItem(item) {
      const combinacao = item?.combinacao ?? item?.product?.combinacao;

      if (!combinacao) {
        return null;
      }

      const combinacaoSemQuantidade = { ...combinacao };
      delete combinacaoSemQuantidade.quantidade;
      delete combinacaoSemQuantidade.quantidade_original;
      delete combinacaoSemQuantidade.quantidade_original_combinacao;

      return JSON.stringify(combinacaoSemQuantidade);
    },
    toFloatQuantidade(value) {
      if (value === undefined || value === null || value === "") {
        return 0;
      }

      if (typeof value === "string" && value.includes(",")) {
        return parseFloat(value.replace(/\./g, "").replace(",", "."));
      }

      return parseFloat(value);
    },
    informarValor() {
      this.$nextTick(() => {
        if (this.$refs.valor) {
          this.$refs.valor.$el.querySelector("input").focus();
          let inputEl = this.$refs.valor.$el.querySelector("input");
          setTimeout(() => {
            inputEl.select();
          }, 100);
        }
      });
    },
    async novaVenda() {
      this.desconectarBalanca();
      this.vendaImportadaCondicional = false;
      const config = await this.resetarVendaMantendoConfiguracao();
      this.pagamentoImportacaoBloqueado = false;
      this.produtosSnapshotAposImport = null;
      this.venda = new PdvData({});
      this.venda.id_configuracao =
        config?.id_configuracao || config?.id || this.idConfiguracaoPadraoPdvWeb;
      this.venda.observation = !this.nfe?.observation
        ? this.informacoesComplementares
        : this.nfe.observation;
      this.venda.buyer.cnpj_cpf = " ";
      this.produto = null;
      this.ultimoProduto = {};
      this.pagamento = this.pagamentos.find(
        (pagamento) =>
          pagamento.descricao === "À vista" || pagamento.descricao === "A vista"
      );
      this.cliente = {};
      if (this.$route.params.id) {
        this.id = this.$route.params.id;
        this.nota.id = parseInt(this.$route.params.id);
      } else this.nota = {};
      this.quantidade = 1 * Math.pow(10, this.quantityOptions.precision);
      this.price = 1 * Math.pow(10, this.priceOptions.precision);
      this.valorPgto = 0;
      this.store.productOfTradeCollection = [];
      this.importedSaleText = "";
      this.importationNumbers = [];
      this.importationObs = [];
      this.listaPagamentos = [];
      this.valueDiscount = 0;
      this.extraValue = 0;
      this.searchCodeBar = null;
      this.idPessoaLista = null;
      this.descontoPedido = 0;
      this.descontoPedidoAplicado = false;
      this.discountPedidoImportado = 0;
      this.selectedLista = null;
      this.descontoItemPedido = false;
      this.ajusteItemModal = {
        index: null,
        produto: "",
        operacao: "desconto",
        tipo: 2,
        valor: "",
        precoBase: 0,
        precoOriginal: 0,
        precoAtual: 0,
      };
      document.getElementById("desconto").value = "0,00";
      document.getElementById("acrescimo").value = "0,00";
      this.statusSelecionado = { id: 1, descricao: "Editando" };

      if (this.vendedorLogado?.id_vendedor) {
        this.venda.vendedor = this.vendedorLogado;
      }

      this.serie = this.seriePadraoPdvWeb;
      this.setInitialState();
    },
    async adicionarProduto(produtoKit) {
      if (!this.produto) return;

      const currentIndex = this.store.productOfTradeCollection.length;

      let quantidade = this.valorUS(this.quantidade);

      let price = this.roundTo2Digits(
        this.valorUS(this.price),
        this.priceOptions.precision
      );

      if (parseFloat(quantidade).toFixed(2) <= 0.0 && !produtoKit) {
        this.$toast.warning("Informe a quantidade do item!");
        this.$refs.quantidade.$el.querySelector("input").focus();
        return false;
      }

      if (parseFloat(price).toFixed(2) <= 0.0 && !produtoKit) {
        this.$toast.warning("Informe o valor do item!");
        return false;
      }

      if (this.store.verificaEstoque) {
        if (!this.validarEstoqueNovoProduto(this.produto, quantidade)) {
          return false;
        }
      }

      const reservadaCondicional =
        parseFloat(this.produto?.quantidade_reservada_condicional) || 0;

      if (this.store.desconsiderarEstoqueCondicional) {
        // Flag ativa: pula validacao de reserva condicional
      } else if (reservadaCondicional > 0) {
        const itemReserva = {
          product: this.produto,
          lote: this.produto?.lote_baixa,
          combinacao: this.produto?.combinacao,
          quantity: quantidade,
          // Preserva o conversor do kit-unidade para a validacao converter a
          // quantidade comercial (1 fardo) em quantidade de baixa (12 un).
          kit_unidade_medida: this.produto?.kit_unidade_medida,
          embalagem: this.produto?.embalagem_selecionada,
        };
        const estoqueReserva = this.getEstoqueDisponivelProduto(itemReserva);

        if (estoqueReserva !== null) {
          const disponivelReserva = estoqueReserva - reservadaCondicional;
          // Usa a quantidade convertida (1 fardo conversor 12 -> 12 un) para
          // comparar contra o estoque fisico e a reserva condicional.
          const quantidadeReserva =
            this.getQuantidadeBaixaEstoqueItem(itemReserva) +
            this.getQuantidadeBaixaEstoqueItemTotal(this.produto);

          if (quantidadeReserva > disponivelReserva) {
            this.$toast.warning(
              "Este produto possui quantidades reservadas em condicional e não pode ser lançado na venda."
            );
            return false;
          }
        }
      }

      if (this.produto.pesado) {
        if (this.searchCodeBar && this.searchCodeBar.length === 13) {
          const pesoEmGramas = parseInt(
            this.searchCodeBar.substring(7, 12),
            10
          ); // Converte para número
          const pesoEmKg = pesoEmGramas / 1000; // Converte para kg
          quantidade = pesoEmKg;

          if (this.produto.unidade_medida.sigla !== "KG") {
            quantidade = 1;
          }
        }
      }

      if (parseFloat(this.produto?.preco_lista_cliente ?? 0) > 0) {
        if (!this.produto.embalagem_selecionada) {
          price = parseFloat(this.produto.preco_lista_cliente);
        }
      }

      if (
        !produtoKit &&
        this.produto.retornavel &&
        !Number.isInteger(Number(quantidade))
      ) {
        this.$toast.warning(
          "A quantidade de um produto retornável deve ser inteira."
        );
        return false;
      }

      let itensRetornaveis = null;
      if (!produtoKit && produtoExigeRetorno(this.produto, quantidade)) {
        const quantidadeRetornada =
          await this.$refs.retornavelProdutoModal.abrir({
            produto: this.produto,
            quantidade,
            preco: price,
          });

        if (quantidadeRetornada === null) return false;

        let itemBase = new PdvVendaProduto({
          price,
          quantity: quantidade,
          totalPrice: this.roundTo2Digits(price * quantidade),
          product: this.produto,
          currentIndex: currentIndex + 1,
        });
        itemBase = {
          ...itemBase,
          ...(this.produto.embalagem_selecionada && {
            embalagem: this.produto.embalagem_selecionada,
          }),
          ...(this.produto.variavel && {
            combinacao: this.produto.combinacao,
          }),
          ...(this.produto.lote && { lote: this.produto.lote_baixa }),
        };
        itensRetornaveis = dividirItemRetornavel(itemBase, quantidadeRetornada);
      }

      if (
        price <
        this.roundTo2Digits(
          this.valorUS(this.produto.originalPreco),
          this.priceOptions.precision
        )
      ) {
        this.getRequestAdmin(() => {
          if (this.produto) this.produto.preco = price;
          let produto = !produtoKit
            ? new PdvVendaProduto({
                price: price,
                quantity: quantidade,
                totalPrice: this.roundTo2Digits(price * quantidade),
                product: this.produto,
                currentIndex: currentIndex + 1,
              })
            : { ...produtoKit };

          produto = {
            ...produto,
            ...(this.produto.embalagem_selecionada && {
              embalagem: this.produto.embalagem_selecionada,
            }),
            ...(this.produto.variavel && {
              combinacao: this.produto.combinacao,
            }),
            ...(this.produto.lote && { lote: this.produto.lote_baixa }),
          };

          const produtosAdicionar = itensRetornaveis || [produto];
          this.store.productOfTradeCollection.push(
            ...produtosAdicionar.map((item, index) => ({
              ...item,
              currentIndex: currentIndex + index + 1,
            }))
          );
          this.avisarEstoqueMinimo(
            produtosAdicionar[0],
            currentIndex,
            quantidade
          );
          this._onProdutosAlteradosManualmente();
          const objDiv = document.getElementById("tableItensVenda");
          objDiv.scrollTop = objDiv.scrollHeight;

          this.ultimoProduto = this.produto;
          this.quantidade = 1 * Math.pow(10, this.quantityOptions.precision);
          this.price = 1 * Math.pow(10, this.priceOptions.precision);
          this.produto = null;
          this.desconectarBalanca();
          this.produtos = [];

          return this.abrirVenda();
        });
      } else {
        if (this.produto) this.produto.preco = price;
        let produto = !produtoKit
          ? new PdvVendaProduto({
              price: price,
              quantity: quantidade,
              totalPrice: this.roundTo2Digits(price * quantidade),
              product: this.produto,
              currentIndex: currentIndex + 1,
            })
          : { ...produtoKit };

        produto = {
          ...produto,
          ...(this.produto.embalagem_selecionada && {
            embalagem: this.produto.embalagem_selecionada,
          }),
          ...(this.produto.variavel && { combinacao: this.produto.combinacao }),
          ...(this.produto.lote && { lote: this.produto.lote_baixa }),
        };

        const produtosAdicionar = itensRetornaveis || [produto];
        this.store.productOfTradeCollection.push(
          ...produtosAdicionar.map((item, index) => ({
            ...item,
            currentIndex: currentIndex + index + 1,
          }))
        );
        this.avisarEstoqueMinimo(
          produtosAdicionar[0],
          currentIndex,
          quantidade
        );
        this._onProdutosAlteradosManualmente();
        const objDiv = document.getElementById("tableItensVenda");
        objDiv.scrollTop = objDiv.scrollHeight;

        this.ultimoProduto = this.produto;
        this.quantidade = 1 * Math.pow(10, this.quantityOptions.precision);
        this.price = 1 * Math.pow(10, this.priceOptions.precision);
        this.produto = null;
        this.desconectarBalanca();
        this.produtos = [];
        this.searchCodeBar = null;

        return this.abrirVenda();
      }
    },
    async setProduto(selectProduct, isBarCode = false) {
      if (selectProduct === null) {
        this.desconectarBalanca();
        return false;
      }

      const adicionarAposSelecionarEmbalagem =
        (selectProduct?.multiplas_embalagens === true ||
          selectProduct?.multiplas_embalagens === 1 ||
          selectProduct?.multiplas_embalagens === "1" ||
          selectProduct?.multiplas_embalagens === "true") &&
        Array.isArray(selectProduct.embalagens) &&
        selectProduct.embalagens.length > 0 &&
        !selectProduct.embalagem_selecionada;

      const produtoComEmbalagem = await this.prepararProdutoComEmbalagem(
        selectProduct
      );
      if (!produtoComEmbalagem) {
        this.produto = null;
        return false;
      }
      selectProduct = produtoComEmbalagem;
      const usaEmbalagem = Boolean(selectProduct.embalagem_selecionada);

      const precoNormalAtacadoPdvRaw =
        selectProduct?.preco_normal_atacado_pdv ?? selectProduct?.preco ?? 0;
      const precoNormalAtacadoPdv = this.getNumeroPdv(precoNormalAtacadoPdvRaw);
      const atacadoHabilitado = this.modoAtacadoAtivo;

      if (selectProduct?.variavel) {
        // Define o preço do produto antes de abrir o modal
        const preco_atacado = selectProduct?.preco_atacado ?? 0;
        const isAtacadoValue =
          !usaEmbalagem &&
          this.produtoAtendeRegraAtacado(
            selectProduct,
            this.quantidade,
            atacadoHabilitado
          );

        if (isAtacadoValue) {
          this.price = this.numberToReal(parseFloat(preco_atacado), "preco");
        } else {
          this.price = this.numberToReal(
            parseFloat(selectProduct.preco),
            "preco"
          );
        }

        if (
          !usaEmbalagem &&
          parseFloat(selectProduct?.preco_lista_cliente ?? 0) > 0
        ) {
          this.price = this.numberToReal(
            parseFloat(selectProduct?.preco_lista_cliente),
            "preco"
          );
        }

        this.$set(
          selectProduct,
          "preco_normal_atacado_pdv",
          precoNormalAtacadoPdv
        );
        this.$set(selectProduct, "atacado_pdv_habilitado", atacadoHabilitado);
        this.$set(
          selectProduct,
          "tipo_atacado",
          isAtacadoValue &&
            parseFloat(selectProduct?.preco_lista_cliente ?? 0) <= 0
        );
        this.produto = selectProduct;
        this._syncConexaoBalanca(this.produto);
        this.$bvModal.show("variacaoModal");
        return;
      }

      if (selectProduct?.lote) {
        // Define o preço do produto antes de abrir o modal
        const preco_atacado = selectProduct?.preco_atacado ?? 0;
        const isAtacadoValue =
          !usaEmbalagem &&
          this.produtoAtendeRegraAtacado(
            selectProduct,
            this.quantidade,
            atacadoHabilitado
          );

        if (isAtacadoValue) {
          this.price = this.numberToReal(parseFloat(preco_atacado), "preco");
        } else {
          this.price = this.numberToReal(
            parseFloat(selectProduct.preco),
            "preco"
          );
        }

        if (
          !usaEmbalagem &&
          parseFloat(selectProduct?.preco_lista_cliente ?? 0) > 0
        ) {
          this.price = this.numberToReal(
            parseFloat(selectProduct?.preco_lista_cliente),
            "preco"
          );
        }

        this.$set(
          selectProduct,
          "preco_normal_atacado_pdv",
          precoNormalAtacadoPdv
        );
        this.$set(selectProduct, "atacado_pdv_habilitado", atacadoHabilitado);
        this.$set(
          selectProduct,
          "tipo_atacado",
          isAtacadoValue &&
            parseFloat(selectProduct?.preco_lista_cliente ?? 0) <= 0
        );
        this.produto = selectProduct;
        this._syncConexaoBalanca(this.produto);
        this.atualizarLotes++;
        this.$nextTick(() => {
          this.$bvModal.show("loteModal");
        });
        return;
      }

      if (selectProduct?.isKit) {
        // Kit com unidade de medida propria (fardo, caixa...): lança como
        // 1 item unico, herdando os dados fiscais do produto base e baixando
        // do estoque a quantidade convertida.
        if (selectProduct.usar_unidade_medida) {
          const base =
            selectProduct.productOfTradeCollection?.[0]?.product || {};
          const kitUnidade = selectProduct.unidade_medida || null;
          const valorUnitario = parseFloat(
            selectProduct.valor_unitario || 0
          );
          // A descricao comercial eh o nome do kit ("Fardo de mouse"), nao a do
          // produto base. Mantem os dados fiscais do produto base (NCM/CFOP/...).
          const descricaoKit =
            selectProduct.nome ||
            `${kitUnidade?.nome || "Kit"} de ${base.descricao || ""}`;

          // Busca o produto base atualizado para obter o estoque REAL atual.
          // O JSON do kit congela a quantidade do cadastro (ex.: conversor 12),
          // que nao pode ser confundida com estoque disponivel nas validacoes.
          let baseAtualizada = { ...base };
          try {
            const { data: produtoBase } = await this.$http.post(
              "/produtos/find",
              { id: base.id }
            );
            const produtoData = produtoBase?.data ?? produtoBase;
            if (produtoData) {
              baseAtualizada = {
                ...base,
                quantidade: produtoData.quantidade,
                quantidade_original: produtoData.quantidade,
                quantidade_reservada_condicional:
                  produtoData.quantidade_reservada_condicional,
              };
            }
          } catch (e) {
            console.log("[KIT-UNIDADE] falha ao buscar estoque do produto base", e);
          }

          const produtoToAdd = {
            ...baseAtualizada,
            descricao: descricaoKit,
            product: {
              ...baseAtualizada,
              descricao: descricaoKit,
              // Preserva a quantidade original do produto base como estoque
              // para as validacoes (nao o conversor do fardo).
              quantidade: baseAtualizada.quantidade,
            },
            price: valorUnitario,
            quantity: 1,
            totalPrice: valorUnitario,
            discount: baseAtualizada?.desconto ?? 0,
            active: true,
            currentIndex: 0,
            isKitUnidade: true,
            kit_unidade_medida: kitUnidade,
          };
          this.produto = produtoToAdd;
          this.adicionarProduto(produtoToAdd);
          return;
        }

        selectProduct.productOfTradeCollection.forEach((product, index) => {
          const produtoToAdd = {
            ...product.product,
            product: { ...product.product },
            price: product.product.preco,
            quantity: product.product.quantidade,
            totalPrice: product.product.total,
            discount: product.product?.desconto ?? 0,
            active: true,
            currentIndex: index,
          };
          this.produto = produtoToAdd;
          this.adicionarProduto(produtoToAdd);
        });
        return;
      }

      const preco_atacado = selectProduct?.preco_atacado ?? 0;
      const isAtacadoValue =
        !usaEmbalagem &&
        this.produtoAtendeRegraAtacado(
          selectProduct,
          this.quantidade,
          atacadoHabilitado
        );
      if (isAtacadoValue) {
        this.price = this.numberToReal(parseFloat(preco_atacado), "preco");
      } else
        this.price = this.numberToReal(
          parseFloat(selectProduct.preco),
          "preco"
        );

      if (
        !usaEmbalagem &&
        parseFloat(selectProduct?.preco_lista_cliente ?? 0) > 0
      ) {
        this.price = this.numberToReal(
          parseFloat(selectProduct?.preco_lista_cliente),
          "preco"
        );
      }

      this.produto = {
        ...selectProduct,
        preco: this.price,
        preco_normal_atacado_pdv: precoNormalAtacadoPdv,
        atacado_pdv_habilitado: atacadoHabilitado,
        quantidade: this.quantidade,
        tipo_atacado:
          isAtacadoValue &&
          parseFloat(selectProduct?.preco_lista_cliente ?? 0) <= 0,
      };
      this._syncConexaoBalanca(this.produto);

      const total = this.quantidade * parseFloat(this.price);

      this.produto.originalPreco = this.produto.preco;
      this.produto.quantidade_original = selectProduct.quantidade;
      this.produto.total = total;

      this.ultimoProduto = this.produto;

      this.$nextTick(() => {
        if (this.$refs.quantidade) {
          this.$refs.quantidade.$el.querySelector("input").focus();
          if (!isBarCode) {
            let inputEl = this.$refs.quantidade.$el.querySelector("input");
            setTimeout(() => {
              inputEl.select();
            }, 100);
          }
          const codigoComPeso =
            this.searchCodeBar?.length === 13 &&
            Number.parseInt(this.searchCodeBar.substring(7, 12), 10) > 0;
          if (
            (isBarCode || adicionarAposSelecionarEmbalagem) &&
            (!this.balancaDisponivelParaProduto() || codigoComPeso)
          ) {
            this.adicionarProduto();
          }
        }
      });

      return true;
    },
    async prepararProdutoComEmbalagem(produto) {
      const habilitado =
        produto?.multiplas_embalagens === true ||
        produto?.multiplas_embalagens === 1 ||
        produto?.multiplas_embalagens === "1" ||
        produto?.multiplas_embalagens === "true";

      if (!habilitado) return produto;

      const embalagens = Array.isArray(produto.embalagens)
        ? produto.embalagens
        : [];
      if (!embalagens.length) {
        return { ...produto, embalagem_selecionada: null };
      }

      const embalagem =
        produto.embalagem_selecionada ||
        (await this.$refs.embalagemProdutoModal.abrir({ produto }));
      if (!embalagem) return null;

      if (embalagem.embalagem_padrao) {
        return {
          ...produto,
          embalagem_selecionada: null,
        };
      }

      return {
        ...produto,
        preco: Number(embalagem.preco) || 0,
        embalagem_selecionada: { ...embalagem },
      };
    },
    // ---------- Integração com balança (captura automática de peso) ----------
    async carregarConfigBalanca() {
      // Balanças fica liberado para qualquer empresa (sem gate de plugin).
      // Se não houver dispositivo cadastrado, o recurso fica desabilitado
      // silenciosamente, sem travar o fluxo de vendas.
      try {
        const { data } = await this.$http.post("/balanca/dispositivos/lista", {
          per_page: 1,
          ativo: true,
          terminal_web_uuid: balancaTerminalService.terminalUuid(),
        });
        const dispositivo = data?.data?.[0] ?? data?.[0];
        if (!dispositivo) {
          this.store.balancaHabilitada = false;
          return;
        }
        this.store.balancaHabilitada = true;
        this.store.balancaHost = dispositivo.host_local || "127.0.0.1";
        this.store.balancaPorta = dispositivo.porta_local || 51234;
        this.store.balancaCasasDecimais = dispositivo.casas_decimais ?? 3;
        this.store.balancaModelo = dispositivo.modelo || "";
        // Sinalização online/offline com base no último heartbeat.
        this.store.balancaConectada = !!dispositivo.online;

        balancaService.configurar({
          host: this.store.balancaHost,
          porta: this.store.balancaPorta,
          accessToken: balancaTerminalService.localAccessToken(),
        });
        balancaService.limparCallbacks();
        balancaService.onPesoTempoReal((p) => this._onPesoTempoReal(p));
        balancaService.onPesoEstavel((p) => this._onPesoEstavel(p));
        balancaService.onEstado((e) => this._onEstadoBalanca(e));
        balancaService.onErro(() => {
          this.store.balancaConectada = false;
        });
      } catch (_) {
        // Falha ao buscar config: recurso fica desabilitado silenciosamente,
        // sem travar o fluxo de vendas.
        this.store.balancaHabilitada = false;
      }
    },
    balancaDisponivelParaProduto() {
      return (
        this.store.balancaHabilitada &&
        !!this.produto?.pesado &&
        this.produto?.unidade_medida?.sigla === "KG" &&
        !this.produto?.variavel &&
        !this.produto?.lote
      );
    },
    _syncConexaoBalanca(produtoSelecionado) {
      if (!this.store.balancaHabilitada) return;
      const pesavel =
        !!produtoSelecionado?.pesado &&
        produtoSelecionado?.unidade_medida?.sigla === "KG" &&
        !produtoSelecionado?.variavel &&
        !produtoSelecionado?.lote;
      if (pesavel) {
        this.conectarBalanca();
      } else {
        this.desconectarBalanca();
      }
    },
    _onPesoTempoReal(payload) {
      if (typeof payload?.peso === "number") {
        this.store.balancaPesoTempoReal = payload.peso;
        this.store.balancaEstado = payload.estado || "pesando";
      }
    },
    async _onPesoEstavel(payload) {
      if (typeof payload?.peso !== "number") return;
      this.store.balancaPesoTempoReal = payload.peso;
      this.store.balancaEstado = "estavel";
      await this._aplicarPesoEAdicionar(payload.peso);
    },
    _onEstadoBalanca(payload) {
      this.store.balancaConectada = !!payload?.conectado;
      if (payload?.estado) this.store.balancaEstado = payload.estado;
      if (payload?.estado === "idle") {
        this.store.balancaPesoProcessado = false;
        this.store.balancaAdicionandoItem = false;
      }
    },
    conectarBalanca() {
      if (!this.balancaDisponivelParaProduto()) return;
      balancaService.conectar();
    },
    desconectarBalanca() {
      balancaService.desconectar();
      this.store.balancaEstado = "idle";
      this.store.balancaPesoTempoReal = 0;
      this.store.balancaAdicionandoItem = false;
      this.store.balancaPesoProcessado = false;
    },
    async capturarPesoManual() {
      // Fallback (HTTP) para quando o WebSocket estiver indisponível.
      if (!this.store.balancaHabilitada) return;
      try {
        this.setLoading(true);
        const amostra = await balancaService.lerPeso();
        if (!amostra || amostra.status !== "estavel") {
          this._toastBalanca("Peso instável. Aguarde a balança estabilizar.", "error");
          return;
        }
        await this._aplicarPesoEAdicionar(amostra.peso, true);
      } catch (e) {
        this._toastBalanca(
          "Balança indisponível. Verifique se o aplicativo Balança está aberto.",
          "error"
        );
      } finally {
        this.setLoading(false);
      }
    },
    async _aplicarPesoEAdicionar(peso, capturaManual = false) {
      if (
        !this.balancaDisponivelParaProduto() ||
        this.store.balancaAdicionandoItem ||
        (this.store.balancaPesoProcessado && !capturaManual)
      ) {
        return false;
      }

      const pesoNormalizado = this.roundTo2Digits(
        Number(peso),
        this.quantityOptions.precision
      );
      if (!Number.isFinite(pesoNormalizado) || pesoNormalizado <= 0) {
        return false;
      }

      const descricaoProduto = this.produto?.descricao || "Item";
      this.store.balancaAdicionandoItem = true;
      this.store.balancaPesoProcessado = true;

      // O campo monetário do PDV trabalha com texto no formato brasileiro.
      // Passar o número puro faria valorUS() interpretar a quantidade como zero.
      this.quantidade = this.numberToReal(pesoNormalizado, "quantidade");
      await this.$nextTick();

      const resultado = await this.adicionarProduto();
      if (resultado === false) {
        this.store.balancaAdicionandoItem = false;
        this.store.balancaPesoProcessado = false;
        return false;
      }

      this._toastBalanca(
        `${descricaoProduto} adicionado com ${this.numberToReal(
          pesoNormalizado,
          "quantidade"
        )} kg`,
        "success"
      );
      return true;
    },
    _toastBalanca(mensagem, icon = "success") {
      // SweetAlert não-bloqueante (fecha sozinho), padrão do componente.
      swal({
        text: mensagem,
        icon: icon,
        timer: 2000,
        buttons: false,
        closeOnClickOutside: true,
        closeOnEsc: true,
      });
    },
    onAddProdutoFromVariacao({
      newPreco,
      newQuantidade,
      newTotal,
      newProduto,
    }) {
      const precoString = this.numberToReal(newPreco, "preco");
      const estoqueOriginal =
        this.produto?.quantidade_original ?? this.produto?.quantidade;

      // Constrói a string da combinação a partir do objeto
      if (newProduto?.combinacao) {
        const combinacaoString = [];
        for (const key in newProduto.combinacao) {
          if (key !== "quantidade" && newProduto.combinacao[key]) {
            combinacaoString.push(newProduto.combinacao[key]);
          }
        }

        if (combinacaoString.length > 0) {
          newProduto.descricao = `${
            newProduto.descricao
          } - ${combinacaoString.join("/")}`;
        }
      }

      // produto.preco deve ser string para o watcher de 'quantidade' usar valorUS() corretamente
      this.produto = {
        ...newProduto,
        preco: precoString,
        preco_normal_atacado_pdv:
          this.produto?.preco_normal_atacado_pdv ??
          newProduto?.preco_normal_atacado_pdv ??
          newProduto?.preco,
        atacado_pdv_habilitado:
          this.produto?.atacado_pdv_habilitado ?? this.modoAtacadoAtivo,
        quantidade_original: estoqueOriginal,
      };

      // Quantidade dispara o watcher assíncrono que recalcula this.price com base em produto.preco
      this.quantidade =
        newQuantidade * Math.pow(10, this.quantityOptions.precision);

      // Seta o preço sincronamente (o watcher vai confirmar o mesmo valor)
      this.price = precoString;

      // Aguarda o watcher e o ciclo reativo terminarem antes de adicionar
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.adicionarProduto();
        });
      });
    },
    onAddProdutoFromLote({ newPreco, newQuantidade, newTotal, newProduto }) {
      const precoString = this.numberToReal(newPreco, "preco");
      const estoqueOriginal =
        this.produto?.quantidade_original ?? this.produto?.quantidade;

      // Monta a descrição do lote se existir
      if (newProduto?.lote_baixa) {
        const lote = newProduto.lote_baixa;
        const dataValidade = this.formatDate
          ? this.formatDate(lote.data_validade)
          : new Date(lote.data_validade).toLocaleDateString("pt-BR");
        newProduto.descricao = `${newProduto.descricao} - Nº do Lote: ${lote.numero_lote} / Dt Validade: ${dataValidade}`;
      }

      // produto.preco deve ser string para o watcher de 'quantidade' usar valorUS() corretamente
      this.produto = {
        ...newProduto,
        preco: precoString,
        preco_normal_atacado_pdv:
          this.produto?.preco_normal_atacado_pdv ??
          newProduto?.preco_normal_atacado_pdv ??
          newProduto?.preco,
        atacado_pdv_habilitado:
          this.produto?.atacado_pdv_habilitado ?? this.modoAtacadoAtivo,
        quantidade_original: estoqueOriginal,
      };

      // Quantidade dispara o watcher assíncrono que recalcula this.price com base em produto.preco
      // Como produto.preco agora é string, valorUS() vai retornar o valor correto
      this.quantidade =
        newQuantidade * Math.pow(10, this.quantityOptions.precision);

      // Seta o preço sincronamente (o watcher vai confirmar o mesmo valor)
      this.price = precoString;

      // Aguarda o watcher e o ciclo reativo terminarem antes de adicionar
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.adicionarProduto();
        });
      });
    },
    abrirVenda() {
      this.$nextTick(() => {
        this.registrarLeitorProduto();
        if (this.$refs.buscarProduto) {
          this.$refs.buscarProduto.$el.querySelector("input").focus();
        }
      });
    },
    onSearch(search, loading) {
      if (search.length > 1 && search[0] === "+") {
        loading(true);
        this.searchKit(loading, search, this);
        return;
      }
      if (search.length > 2 || /^[0-9]+$/.test(search)) {
        this.search(loading, search, this);
      }
    },
    search: _.debounce(async (loading, search, vm) => {
      if (search === "" || search === null) {
        return loading(false);
      }

      const $this = vm;

      let busca = search;
      if (busca.split("*").length > 1) {
        let quantidade = 1 * 10 * $this.quantityOptions.precision;
        [quantidade, busca] = busca.split("*");
        $this.quantidade = $this.numberToReal(
          parseFloat(quantidade),
          "quantidade"
        );
      }

      if (busca.split("-").length > 1) {
        let indiceProduto;
        let funcaoDelete = null;
        [funcaoDelete] = busca.split("-");

        if (funcaoDelete === "") {
          [, indiceProduto] = busca.split("-");
          if (indiceProduto % 1 === 0 && indiceProduto !== "") {
            return $this.cancelaProduto(indiceProduto);
          }
        }
      }
      if (busca === "") {
        return false;
      }

      loading(true);

      $this.produtos = await [];
      const { data } = await $this.$http.post("/produtos/filter-item", {
        filter: busca,
        typeFilter: $this.typeFilter,
        ...($this.idPessoaLista && { id_pessoa: $this.idPessoaLista }),
        nfce: true,
        orderBy: $this.sortDir,
        orderbyCampo: $this.sortField,
        ...($this.selectedLista && { lista_selecionada: $this.selectedLista }),
      });
      let adicionouAutomaticamente = false;
      if (data.length === 1) {
        if ($this.isBarCode(busca) && Number.parseInt(busca)) {
          $this.searchCodeBar = busca;
          $this.setProduto(data[0], true);
          adicionouAutomaticamente = true;
        }
      }

      if (
        !adicionouAutomaticamente &&
        $this.entradaProdutoFoiLeitorReferencia(busca)
      ) {
        const produtoReferencia = $this.produtoComReferenciaExataUnica(
          data,
          busca
        );

        if (produtoReferencia) {
          $this.searchCodeBar = busca;
          $this.setProduto(produtoReferencia, true);
          adicionouAutomaticamente = true;
        }
      }

      $this.produtos = data;

      loading(false);
      return true;
    }, 350),
    searchKit: _.debounce(async (loading, search, vm) => {
      const { data } = await vm.$http.post("/kit/get-kit", { search });
      vm.produtos = data.map((kit) => ({
        ...kit,
        descricao: kit.nome,
        isKit: true,
      }));
      loading(false);
    }, 350),
    getKitInfo(kitData) {
      // Kit com unidade de medida propria: mostra o resumo do fardo/caixa.
      if (kitData.usar_unidade_medida) {
        const unidade = kitData.unidade_medida || {};
        const base = kitData.productOfTradeCollection?.[0]?.product || {};
        const conversor = parseFloat(unidade.conversor) || 0;
        return `1 ${unidade.sigla || ""} de ${base.descricao || ""}` +
          (conversor ? ` (${conversor} ${base.unidade_medida?.sigla || "un"})` : "") +
          ` - R$ ${this.numberToReal(kitData.valor_unitario, "preco")}`;
      }
      const description = kitData.productOfTradeCollection.reduce(
        (acc, produto, index) =>
          acc +
          `${index + 1} - ${produto.product.descricao} - QTD: ${
            produto.product.quantidade
          }<br/>`,
        ""
      );
      return description;
    },
    isBarCode(codigo) {
      if (codigo.length === 8) {
        return true;
      }

      if (codigo.length === 12) {
        return true;
      }

      if (codigo.length === 13) {
        return true;
      }

      if (codigo.length === 14) {
        return true;
      }

      return false;
    },
    cancelaProduto(indiceProduto) {
      let produto = indiceProduto - 1;
      if (indiceProduto === null) {
        if (this.store.productOfTradeCollection.length === 0) {
          return false;
        }
        produto = this.store.productOfTradeCollection.length - 1;
      }

      const item =
        this.store.productOfTradeCollection[produto].product.descricao;

      this.$swal
        .fire({
          icon: "warning",
          title: "Cancelar o item " + item + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.store.productOfTradeCollection[produto].active = false;
            this.store.productOfTradeCollection[produto].totalPrice = 0;
            this.store.productOfTradeCollection[produto].quantity = 0;
            this.$toast.success("Item cancelado com sucesso!");
          }
        });
    },
    async defaultPagamento() {
      const pagamentoAVista = this.pagamentos.filter((item) => {
        const itemFilter = item.descricao
          ? item.descricao.toUpperCase()
          : "".toUpperCase();
        const newText = String("À Vista").toUpperCase();
        return itemFilter.indexOf(newText) > -1;
      });

      const pagamento = {
        ...pagamentoAVista[0],
        value: this.roundTo2Digits(this.total),
        meioPagamento: {
          description: "À Vista",
          id: "1",
          name: "À Vista",
        },
      };
      pagamento.range = [
        {
          value: this.roundTo2Digits(this.total),
          date: this.$moment().format("YYYY-MM-DD"),
        },
      ];
      this.pagamentosEditados = [];
      this.venda.paymentModeCollection.push(pagamento);
    },
    async finalizarVenda(transmitirVenda, janelasImpressao = []) {
      const hasCartao = this.venda.paymentModeCollection.find((payment) =>
        payment.descricao.includes("A prazo")
      );
      if (this.venda.buyer.cnpj_cpf) {
        this.venda.buyer.cnpj_cpf = this.normalizeCpfCnpj(this.venda.buyer.cnpj_cpf);
      } else if (transmitirVenda && hasCartao) {
        this.$toast.error("CNPJ obrigatorio para transmitir NFC-e");
        this.setLoading(false);
        this.closeInfoVendaModal();
        this.fecharJanelasImpressaoNaoUtilizadas(janelasImpressao);
        return;
      }

      if (this.store.pafNFCe && !transmitirVenda) {
        this.fecharJanelasImpressaoNaoUtilizadas(janelasImpressao);
        return;
      }

      if (this.total === 0) {
        this.fecharJanelasImpressaoNaoUtilizadas(janelasImpressao);
        return false;
      }
      this.venda.paymentModeCollection = this.normalizarPagamentosVenda(
        this.listaPagamentos
      );

      if (this.venda.paymentModeCollection.length === 0) {
        await this.defaultPagamento();
      }

      try {
        const config = await this.garantirConfiguracaoPdvWeb();
        const troco = this.roundTo2Digits(this.valorPago - this.total);
        this.venda.remainder = troco > 0 ? troco : 0;
        this.venda.price = this.roundTo2Digits(this.total);
        this.venda.isNFce = transmitirVenda;
        if (!this.venda.isNFce) {
          this.venda.status = 7;
          this.venda.statusSelecionado = { id: 7, descricao: "Finalizado" };
        }

        this.venda.productOfTradeCollection =
          this.store.productOfTradeCollection.filter((item) => {
            const itemFilter = item.active.toString();
            return itemFilter.indexOf("true") > -1;
          });

        const dados = {
          ...this.venda,
          serie: config.serie,
          id_configuracao:
            config.id_configuracao || config.id || this.idConfiguracaoPadraoPdvWeb,
        };

        // ── MODO ELECTRON OFFLINE ─────────────────────────────────────────
        if (this.$isDesktop) {
          await this._finalizarVendaOffline(dados);
          return;
        }
        // ─────────────────────────────────────────────────────────────────

        if (!this.nota.id) {
          this.nota = await this.criarNota(dados);
        } else {
          const { data } = await this.$http.post("/nfe/update", {
            dados: {
              ...dados,
              id: this.nota.id,
              isNFce: transmitirVenda,
              ...(this.pedidos.length > 0 && { pedidos: this.pedidos }),
              ...(this.os.length > 0 && { pedidos: this.os }),
            },
          });
          this.nota = { ...this.nota, ...data };
        }
        this.pedidos = [];
        this.os = [];

        if (!this.nota.id) {
          this.setLoading(false);
          this.fecharJanelasImpressaoNaoUtilizadas(janelasImpressao);
          return this.$toast.error("Ocorreu um erro ao salvar!");
        }

        await this.vincularVendaCondicionalSeNecessario();

        let printVenda = {};
        if (!transmitirVenda) {
          if (!this.store.naoGeraImpressao) {
            this.posStep = 3;
            printVenda = await this.imprimirVenda(this.nota.id);
          }
        }

        if (transmitirVenda) {
          this.paymentsCartao = [];
          this.venda.paymentModeCollection.filter((payment) => {
            if (payment.id_meio_pagamento == 3) {
              this.paymentsCartao.push(payment);
            }

            if (payment.id_meio_pagamento == 4) {
              this.paymentsCartao.push(payment);
            }
          });

          if (this.paymentsCartao.length > 0 && this.solicitarDadosCartao) {
            const { data } = await this.$http.post("/nfe/bandeiras");
            this.bandeiras = data;
            this.posStep = 0;
            this.$bvModal.show("modal-pos-cartao");
            this.setLoading(false);
            this.fecharJanelasImpressaoNaoUtilizadas(janelasImpressao);
            return;
          }

          if (this.paymentsCartao.length > 0 && this.integracaoPos) {
            this.posStep = 1;
            this.$bvModal.show("modal-pos-venda");
            this.isLoadingPosData = true;
            this.setLoading(false);
            this.fecharJanelasImpressaoNaoUtilizadas(janelasImpressao);
            return;
          }

          await this.transmitirNFCe(this.nota.id);
          this.posStep = 3;
          let printNFCe = {};

          if (!this.store.naoGeraImpressao) {
            printNFCe = await this.imprimirNFCe(this.nota.id);
          }
          if (printNFCe["danfe-url"]) {
            this.imprimir(
              printNFCe["danfe-url"],
              this.consumirJanelaImpressao(janelasImpressao)
            );
          }

          if (printNFCe["voucher-url"]) {
            this.imprimir(
              printNFCe["voucher-url"],
              this.consumirJanelaImpressao(janelasImpressao)
            );
          }

          if (printNFCe["duplicata"]) {
            this.imprimir(
              printNFCe["duplicata"],
              this.consumirJanelaImpressao(janelasImpressao)
            );
          }
        }

        if (printVenda["venda-url"] && !transmitirVenda) {
          this.imprimir(
            printVenda["venda-url"],
            this.consumirJanelaImpressao(janelasImpressao)
          );
        }

        if (printVenda["voucher-url"] && !transmitirVenda) {
          this.imprimir(
            printVenda["voucher-url"],
            this.consumirJanelaImpressao(janelasImpressao)
          );
        }

        if (printVenda["duplicata"] && !transmitirVenda) {
          this.imprimir(
            printVenda["duplicata"],
            this.consumirJanelaImpressao(janelasImpressao)
          );
        }

        this.imprimirVoucherCreditoResidual(this.nota);

        this.abrirVenda();
        if (this.$route.params.id) {
          this.$router.push({ name: "vendasNovo" });
        } else this.novaVenda();
        if (this.store.aberturaCaixa) {
          await this.loadCaixaInfo();
        }
        this.setLoading(false);
        this.closeInfoVendaModal();
        this.isLoadingSubmit = false;
        this.venda.observation = !this.nfe?.observation
          ? this.informacoesComplementares
          : this.nfe.observation;
        this.valorPagoVenda = 0;
        this.fecharJanelasImpressaoNaoUtilizadas(janelasImpressao);
      } catch (e) {
        this.setLoading(false);
        this.currentErrorMessage =
          this.getMensagemErro(e) || "Não foi possível concluir a NFC-e.";
        try {
          this.marcarProdutoErroFiscalPDV(e);
        } catch (error) {
          console.error("Erro ao identificar o produto fiscal:", error);
        }
        this.isLoadingSubmit = false;
        this.closeInfoVendaModal();
        this.fecharJanelasImpressaoNaoUtilizadas(janelasImpressao);
        if (!e?.response?.data?.message && !e?.response?.data?.msg) {
          this.$toast.error(this.currentErrorMessage);
        }
        return;
      }
    },

    changeDescontoAcrescimo(params) {
      if (params.discount.percentDiscount !== 0) {
        this.setInternalDiscountValue(params.discount.percentDiscount);
      }
      if (
        params.discount.percentDiscount === 0 &&
        params.discount.valueDiscount === 0
      ) {
        this.venda.discount = 0;
      }
      if (
        params.extraValue.percentExtraValue === 0 &&
        params.extraValue.valueExtraValue === 0
      ) {
        this.venda.extraValue = 0;
      }

      if (params.extraValue.percentExtraValue !== 0) {
        this.setInternalExtraValue(params.extraValue.percentExtraValue);
      }

      if (params.discount.valueDiscount !== 0) {
        this.venda.discount = params.discount.valueDiscount;
        this.venda.isPercent = this.isPercent;
        this.venda.tipoDescontoValue = this.tipoDescontoValue;
      }
      if (params.extraValue.valueExtraValue !== 0) {
        this.venda.extraValue = params.extraValue.valueExtraValue;
        this.venda.tipoAcrescimo = this.tipoAcrescimo;
        this.venda.tipoAcrescimoValue = 1;
      }
    },

    setInternalExtraValue(percentExtraValue) {
      if (parseFloat(percentExtraValue) > 0) {
        const total = this.store.productOfTradeCollection.reduce(
          (total, item) => total + item.totalPrice,
          0
        );
        const valueExtraValue = parseFloat(total * percentExtraValue).toFixed(
          2
        );
        this.venda.extraValue = this.valorReal(valueExtraValue);
        this.venda.tipoAcrescimo = {
          value: 1,
          text: "Valor R$",
        };
        this.venda.tipoAcrescimoValue = 1;
      }
    },
    setInternalDiscountValue(percentDiscount) {
      if (percentDiscount > 0) {
        const total = this.store.productOfTradeCollection.reduce(
          (total, item) => total + item.totalPrice,
          0
        );
        const valueDiscount = (total * percentDiscount).toFixed(2);
        this.venda.discount = this.valorReal(valueDiscount);
        this.venda.isPercent = {
          value: 1,
          text: "Valor R$",
        };
        this.venda.tipoDescontoValue = 1;
      }
    },

    /**
     * Finalização de venda no modo Electron (offline).
     * Salva localmente no SQLite e enfileira para sincronização.
     */
    async _finalizarVendaOffline(dados) {
      try {
        const api = this.$electron;

        // Lê configurações do terminal
        const [
          id_terminal_venda,
          uuid_terminal,
          id_empresa,
          id_configuracao,
          serie_nfe,
          proxima_venda_str,
        ] = await Promise.all([
          api.config.get("id_terminal_venda"),
          api.config.get("uuid_terminal"),
          api.config.get("id_empresa"),
          api.config.get("id_configuracao"),
          api.config.get("serie_nfe"),
          api.config.get("proxima_venda"),
        ]);

        const proximaVenda = parseInt(proxima_venda_str || "1", 10);
        const uuid_venda_terminal = crypto.randomUUID();
        const agora = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        const buyer = dados.buyer || {};

        const vendaLocal = {
          uuid_venda_terminal,
          id_terminal_venda:    id_terminal_venda    ? parseInt(id_terminal_venda,    10) : null,
          id_empresa:           id_empresa           ? parseInt(id_empresa,           10) : null,
          identificacaoCliente: buyer.cnpj_cpf       ?? buyer.cpf ?? null,
          nomeCliente:          buyer.nome_fantasia   ?? buyer.nome ?? null,
          numero:               proximaVenda,
          numeroNota:           proximaVenda,
          modelo:               dados.modelo         ?? 65,
          serie:                serie_nfe            ?? dados.serie ?? null,
          finalidade:           dados.finalidade     ?? 1,
          tipoNF:               dados.tpNF           ?? 1,
          valorTotal:           Number(dados.price   ?? this.total ?? 0),
          dtVenda:              agora,
          emissao:              agora,
          status:               1,
          statusTransmissao:    "OFFLINE",
          origem_venda:         "pdv_offline",
          isPDVSync:            1,
          sync_app:             1,
          status_sync:          "pendente",
          // dados completo da NF para o backend montar a nota
          dados_json:           JSON.stringify(dados),
          payload_json:         JSON.stringify({
            dados,
            uuid_terminal,
            id_configuracao,
            id_empresa,
            serie: serie_nfe ?? dados.serie,
            numero: proximaVenda,
          }),
          itens: (dados.productOfTradeCollection || []).map((item) => ({
            id_produto:     item.id_produto  ?? item.product?.id ?? null,
            codigo:         item.codigo      ?? item.product?.codigo ?? null,
            descricao:      item.descricao   ?? item.product?.descricao ?? item.name ?? "",
            cod_barras:     item.cod_barras  ?? item.product?.cod_barras ?? null,
            quantidade:     Number(item.quantidade ?? item.qty ?? 1),
            valor_unitario: Number(item.valor_unitario ?? item.price ?? 0),
            desconto:       Number(item.desconto ?? item.discount ?? 0),
            acrescimo:      Number(item.acrescimo ?? 0),
            total:          Number(item.total ?? item.totalPrice ?? 0),
          })),
          pagamentos: (dados.paymentModeCollection || []).map((pag) => ({
            id_meio_pagamento: pag.id_meio_pagamento ?? null,
            descricao:         pag.descricao         ?? null,
            valor:             Number(pag.value      ?? 0),
            parcelas:          pag.vezes             ?? 1,
            vencimento:        (pag.range && pag.range[0]) ? pag.range[0].date : null,
          })),
        };

        await api.vendas.salvar(vendaLocal);

        // Fila de sync
        await api.sync.enqueue({
          tipo:            "venda",
          uuid_referencia: uuid_venda_terminal,
          payload:         { uuid_venda_terminal },
        });

        this.$toast.success("Venda salva localmente! Será sincronizada quando online.");
        this.abrirVenda();
        this.novaVenda();
        this.setLoading(false);
        this.closeInfoVendaModal();
        this.isLoadingSubmit = false;
      } catch (e) {
        console.error("[PDV Offline] Erro ao salvar venda localmente:", e);
        this.$toast.error(`Erro ao salvar venda: ${e.message}`);
        this.setLoading(false);
        this.isLoadingSubmit = false;
        this.closeInfoVendaModal();
      }
    },

    async criarNota(dados) {
      if (this.id) {
        dados.id = this.id;
      }

      const { data } = await this.$http.post(this.url, {
        dados: {
          ...dados,
          ...(this.pedidos.length > 0 && { pedidos: this.pedidos }),
          ...(this.os.length > 0 && { os: this.os }),
          ...(this.orcamentos.length > 0 && { orcamentos: this.orcamentos }),
        },
      });

      return data;
    },

    async vincularVendaCondicionalSeNecessario() {
      const origemCondicional = this.venda?.origem_condicional;
      const idCondicional = origemCondicional?.id_condicional_mercadoria;
      const idNfe = this.nota?.id;

      if (!idCondicional || !idNfe) {
        return;
      }

      try {
        await this.$http.post("/condicional-mercadorias/vincular-venda", {
          id_condicional_mercadoria: idCondicional,
          id_nfe: idNfe,
        });
        this.venda.origem_condicional = null;
        this.$toast.success("Venda vinculada à condicional.");
      } catch (error) {
        this.$toast.warning(
          error?.response?.data?.msg ||
            "A venda foi salva, mas não foi possível vincular à condicional."
        );
      }
    },

    async imprimirVenda(id) {
      const { data } = await this.$http.post("/nfe/printVenda", {
        id,
      });

      return data;
    },

    async imprimirNFCe(id) {
      const { data } = await this.$http.post("/nfe/printNota", {
        id,
      });

      return data;
    },

    async transmitirNFCe(id) {
      const { data } = await this.$http.post("/nfe/transmitter", {
        id,
      });

      return data;
    },
    reservarJanelasImpressao() {
      // Não reservamos mais uma janela em branco ("Gerando comprovante...").
      // A impressão é feita diretamente em imprimir(), apenas quando há
      // comprovante a ser impresso.
      return [];
    },
    consumirJanelaImpressao(janelasImpressao = []) {
      const janela = janelasImpressao.shift();

      if (janela && !janela.closed) {
        return janela;
      }

      return null;
    },
    fecharJanelasImpressaoNaoUtilizadas(janelasImpressao = []) {
      while (janelasImpressao.length) {
        const janela = janelasImpressao.shift();

        if (janela && !janela.closed) {
          janela.close();
        }
      }
    },
    getMensagemErro(error) {
      const payload = error?.response?.data || {};
      return (
        payload.error_message ||
        payload.message ||
        payload.msg ||
        error?.msg ||
        error?.message ||
        ""
      );
    },
    normalizarTextoPDV(value) {
      return String(value || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();
    },
    extrairProdutoErroFiscal(message) {
      const quoted = String(message || "").match(/produto\s+["']([^"']+)["']/i);

      return quoted?.[1] || null;
    },
    marcarProdutoErroFiscalPDV(error) {
      const message = this.getMensagemErro(error);
      const normalizedMessage = this.normalizarTextoPDV(message);

      if (
        !normalizedMessage.includes("dados fiscais") &&
        !normalizedMessage.includes("csosn") &&
        !normalizedMessage.includes("cfop") &&
        !normalizedMessage.includes("ncm")
      ) {
        return;
      }

      const productName = this.extrairProdutoErroFiscal(message);
      const normalizedProductName = this.normalizarTextoPDV(productName);
      const activeItems = this.store.productOfTradeCollection
        .map((item, index) => ({ item, index }))
        .filter(({ item }) => item?.active);
      let itemWithError = activeItems.find(({ item }) => {
        const description = this.normalizarTextoPDV(item.product?.descricao);
        return (
          normalizedProductName &&
          (description === normalizedProductName ||
            description.includes(normalizedProductName))
        );
      });

      if (!itemWithError && activeItems.length === 1) {
        itemWithError = activeItems[0];
      }

      if (!itemWithError) {
        return;
      }

      this.store.productOfTradeCollection.forEach((item, index) => {
        if (!item?.erroFiscalPDV) return;

        this.$set(this.store.productOfTradeCollection, index, {
          ...item,
          exibirEdicaoFiscalPDV: false,
          erroFiscalPDV: null,
        });
      });

      this.$set(this.store.productOfTradeCollection, itemWithError.index, {
        ...itemWithError.item,
        exibirEdicaoFiscalPDV: true,
        erroFiscalPDV: message,
      });
    },
    imprimir(url,  janelaReservada = null) {
      const printDafe =
        janelaReservada && !janelaReservada.closed
          ? janelaReservada
          : window.open(url, "_blank");
          
      if (!printDafe || printDafe.closed) {
        return this.$toast.error(
          "Habilite o popup do navegador para visualizar os relatórios/comprovantes"
        );
      }

      if (janelaReservada) {
        printDafe.location.href = url;
      }

      printDafe.focus();

      return setTimeout(() => {
        printDafe.print();
      }, 1000);
    },
    imprimirVoucherCreditoResidual(nota = this.nota) {
      const url =
        nota?.cliente_credito_voucher_url ||
        nota?.["cliente-credito-voucher-url"];

      if (url) {
        const printVoucher = window.open(url, "_blank");
        if (!printVoucher || printVoucher.closed) {
          this.$swal
            .fire({
              title: "Voucher de troco gerado",
              text: "A impressão automática foi bloqueada pelo navegador.",
              icon: "info",
              showCancelButton: true,
              confirmButtonText: "Abrir voucher",
              cancelButtonText: "Fechar",
              confirmButtonColor: "var(--primary-color)",
            })
            .then((result) => {
              if (result.isConfirmed) {
                this.imprimir(url);
              }
            });
          return;
        }

        printVoucher.focus();
        setTimeout(() => {
          printVoucher.print();
        }, 1000);
      }
    },
    getRangePayment(payment) {
      return payment.reduce((total, item) => total + item.value, 0);
    },
    changeCliente(selectedCliente = null) {
      if (selectedCliente !== null) {
        this.venda.buyer = selectedCliente;
      }
    },
    setCliente(cliente) {
      if (!cliente) {
        this.selectedCliente = null;
        return;
      }

      if (this.bloquearClienteInadimplenteSelecionado(cliente)) {
        this.selectedCliente = null;
        return;
      }

      if (parseFloat(cliente.limite_credito) > 0) {
        if (
          cliente.limite_de_credito &&
          parseFloat(cliente.limite_credito) <
            parseFloat(cliente.limite_de_credito.valor_total)
        ) {
          this.$toast.warning(
            "Limite de crédito do cliente atingido, verifique!"
          );
          this.$bvModal.hide("modal-client");
          this.getRequestAdmin(() => {
            this.setClienteInadimplente(cliente);
          });
          return;
        }
        if (
          cliente.limite_de_credito &&
          parseFloat(cliente.limite_credito) >=
            parseFloat(cliente.limite_de_credito.valor_total)
        ) {
          this.setClienteLimiteCredito(cliente);
          this.selectedCliente = cliente;

          if (cliente.id_pessoa) {
            this.idPessoaLista = cliente.id_pessoa;
          }
          return;
        }
      }
      this.selectedCliente = cliente;

      if (cliente.id_pessoa) {
        this.idPessoaLista = cliente.id_pessoa;
      }
    },

    setClienteLimiteCredito(cliente) {
      this.limiteCreditoAtual = true;
      this.valorLimiteCredito = cliente.limite_credito;
      this.valorLimiteCreditoAtingido = cliente.limite_de_credito.valor_total;
      this.selectedCliente = cliente;
      this.valueCliente = { ...this.selectedCliente };
      this.venda.buyer = this.valueCliente;
      this.selectedCliente = {
        cnpj_cpf: null,
      };
      this.verificarCreditoCliente(this.valueCliente);
    },

    setClienteInadimplente(cliente) {
      this.limiteCreditoAtigindo = true;
      this.valorLimiteCredito = cliente.limite_credito;
      this.valorLimiteCreditoAtingido = cliente.limite_de_credito.valor_total;
      this.selectedCliente = cliente;
      this.valueCliente = { ...this.selectedCliente };
      this.venda.buyer = this.valueCliente;
      this.selectedCliente = {
        cnpj_cpf: null,
      };
      this.verificarCreditoCliente(this.valueCliente);
    },
    async saveCliente() {
      if (!this.selectedCliente)
        return this.$toast.error("Selecione o cliente para salvar!");
      this.valueCliente = { ...this.selectedCliente };
      this.venda.buyer = this.valueCliente;
      this.$toast.success("Adicionado sucesso!");
      this.$bvModal.hide("modal-client");
      this.selectedCliente = {
        cnpj_cpf: null,
      };
      await this.verificarCreditoCliente(this.valueCliente);
      this.fromPagamentoModal = false;
    },
    async verificarCreditoCliente(cliente) {
      if (this.creditoClienteAplicado) {
        this.removerCreditoCliente(false);
      }

      this.creditoClienteSaldo = 0;
      this.creditoClienteValor = 0;
      this.creditoClienteAplicado = false;
      this.creditoClienteVouchers = [];
      this.creditoClienteVoucherSelecionado = null;

      if (!cliente?.id_pessoa) return;

      try {
        const { data } = await this.$http.post(
          "/financeiro/cliente-creditos/vouchers-disponiveis",
          {
            id_pessoa: cliente.id_pessoa,
          }
        );
        this.creditoClienteVouchers = data ?? [];
        this.creditoClienteSaldo = this.roundTo2Digits(
          this.creditoClienteVouchers.reduce(
            (total, voucher) => total + this.valorVoucherCredito(voucher),
            0
          )
        );

        if (this.creditoClienteVouchers.length === 0) return;

        if (this.valorPendenteParaCredito() <= 0) {
          this.$toast.info(
            `Cliente possui voucher(s) com R$ ${this.numberToReal(
              this.creditoClienteSaldo,
              2
            )}. Ajuste os pagamentos para usar como Crédito em Loja.`
          );
          return;
        }

        await this.solicitarUsoCreditoCliente(cliente);
      } catch (error) {
        this.$toast.warning("Não foi possível consultar o crédito do cliente.");
      }
    },
    async solicitarUsoCreditoCliente(cliente) {
      if (!cliente?.id_pessoa || this.creditoClienteVouchers.length === 0)
        return;

      const valorPendente = this.valorPendenteParaCredito();

      if (valorPendente <= 0) return;

      const vouchersOrdenados = [...this.creditoClienteVouchers].sort(
        (a, b) => {
          const saldoA = this.valorVoucherCredito(a);
          const saldoB = this.valorVoucherCredito(b);
          const cobreA = saldoA >= valorPendente;
          const cobreB = saldoB >= valorPendente;

          if (cobreA !== cobreB) return cobreA ? -1 : 1;

          return cobreA ? saldoA - saldoB : saldoB - saldoA;
        }
      );
      const vouchersSugeridos = [];
      let totalSugerido = 0;

      vouchersOrdenados.forEach((voucher) => {
        if (totalSugerido >= valorPendente) return;
        vouchersSugeridos.push(voucher.id);
        totalSugerido = this.roundTo2Digits(
          totalSugerido + this.valorVoucherCredito(voucher)
        );
      });

      const voucherOptionsHtml = vouchersOrdenados
        .map((voucher) => {
          const saldo = this.valorVoucherCredito(voucher);
          const checked = vouchersSugeridos.includes(voucher.id)
            ? "checked"
            : "";
          return `
            <label class="d-flex align-items-center justify-content-between border rounded p-3 mb-2 text-left">
              <span>
                <strong>${voucher.codigo_voucher}</strong><br>
                <small>Saldo: R$ ${this.numberToReal(saldo, 2)}</small>
              </span>
              <input
                type="checkbox"
                class="credito-voucher-option"
                value="${voucher.id}"
                ${checked}
              />
            </label>
          `;
        })
        .join("");

      const result = await this.$swal.fire({
        title: "Escolha os vouchers",
        html: `
          <p class="mb-4">Valor pendente da venda: R$ ${this.numberToReal(
            valorPendente,
            2
          )}.</p>
          <div style="max-height: 320px; overflow-y: auto; overflow-x: hidden; padding-right: 6px; scrollbar-width: thin; scrollbar-color: var(--primary-color, #1cc4b8) #f3f6f9;">
            ${voucherOptionsHtml}
          </div>
        `,
        width: 650,
        showCancelButton: true,
        confirmButtonText: "Aplicar voucher(s)",
        cancelButtonText: "Não usar",
        confirmButtonColor: "var(--primary-color)",
        preConfirm: () => {
          const idsSelecionados = Array.from(
            document.querySelectorAll(".credito-voucher-option:checked")
          ).map((input) => input.value);
          const vouchers = idsSelecionados
            .map((idVoucher) =>
              this.creditoClienteVouchers.find(
                (item) => String(item.id) === String(idVoucher)
              )
            )
            .filter(Boolean);

          if (vouchers.length === 0) {
            return this.$swal.showValidationMessage(
              "Selecione ao menos um voucher."
            );
          }

          return vouchers;
        },
      });

      if (result.isConfirmed) {
        const totalSelecionado = this.roundTo2Digits(
          result.value.reduce(
            (total, voucher) => total + this.valorVoucherCredito(voucher),
            0
          )
        );
        await this.aplicarCreditoCliente(
          Math.min(totalSelecionado, valorPendente),
          result.value
        );
      }
    },
    async aplicarCreditoCliente(valor, vouchersSelecionados) {
      if (this.valueExtraValue > 0 || this.venda.extraValue > 0) {
        this.$toast.warning("Remova o acréscimo antes de aplicar crédito.");
        return;
      }

      this.removerPagamentoCreditoCliente();

      const valorPendente = this.valorPendenteParaCredito();
      const vouchersSelecionadosLista = Array.isArray(vouchersSelecionados)
        ? vouchersSelecionados
        : [vouchersSelecionados];
      const vouchers = [];
      let coberturaVouchers = 0;
      vouchersSelecionadosLista.forEach((voucher) => {
        if (coberturaVouchers >= valor) return;
        vouchers.push(voucher);
        coberturaVouchers = this.roundTo2Digits(
          coberturaVouchers + this.valorVoucherCredito(voucher)
        );
      });
      const valorVoucher = this.roundTo2Digits(
        vouchers.reduce(
          (total, voucher) => total + this.valorVoucherCredito(voucher),
          0
        )
      );
      const valorAplicado = this.roundTo2Digits(Number(valor) || 0);

      if (valorAplicado <= 0) return;

      if (
        vouchers.length === 0 ||
        vouchers.some((voucher) => !voucher?.codigo_voucher || !voucher?.id)
      ) {
        this.$toast.warning("Selecione voucher(s) válido(s).");
        return;
      }

      if (valorAplicado > valorVoucher) {
        this.$toast.warning(
          `O valor usado é maior que o voucher de R$ ${this.numberToReal(
            valorVoucher,
            2
          )}.`
        );
        return;
      }

      if (valorAplicado > valorPendente) return;

      const formaPagamento = await this.obterFormaPagamentoVoucherCliente();

      if (!formaPagamento?.id) {
        this.$toast.warning(
          "Forma de pagamento de voucher não configurada para esta empresa."
        );
        return;
      }

      this.creditoClienteValor = valorAplicado;
      this.creditoClienteAplicado = true;
      this.creditoClienteVoucherSelecionado = vouchers;
      let valorRestante = valorAplicado;
      const vouchersPayload = vouchers.map((voucher) => {
        const saldo = this.roundTo2Digits(this.valorVoucherCredito(voucher));
        const valorUsado = this.roundTo2Digits(Math.min(saldo, valorRestante));
        valorRestante = this.roundTo2Digits(
          Math.max(valorRestante - valorUsado, 0)
        );

        return {
          id_movimento_voucher: voucher.id,
          codigo_voucher: voucher.codigo_voucher,
          saldo_disponivel: saldo,
          valor_usado: valorUsado,
        };
      });
      const primeiroVoucher = vouchersPayload[0];
      this.venda.credito_cliente = {
        id_pessoa: this.valueCliente.id_pessoa,
        id_movimento_voucher: primeiroVoucher?.id_movimento_voucher,
        codigo_voucher: primeiroVoucher?.codigo_voucher,
        vouchers: vouchersPayload,
        valor_usado: valorAplicado,
        saldo_disponivel: valorVoucher,
        valor_residual_previsto: this.roundTo2Digits(
          valorVoucher - valorAplicado
        ),
      };
      this.listaPagamentos.push(
        this.montarPagamentoCreditoCliente(valorAplicado, formaPagamento)
      );
      this.atualizarValorPagamentoPendente();
      this.$toast.success("Voucher aplicado como Crédito em Loja.");
    },
    removerCreditoCliente(exibirMensagem = true) {
      this.removerPagamentoCreditoCliente();
      this.creditoClienteValor = 0;
      this.creditoClienteAplicado = false;
      this.creditoClienteVoucherSelecionado = null;
      this.venda.credito_cliente = null;
      this.atualizarValorPagamentoPendente();
      if (exibirMensagem) {
        this.$toast.success("Crédito removido da venda.");
      }
    },
    async obterFormaPagamentoVoucherCliente() {
      if (this.creditoClienteFormaPagamento?.id) {
        return this.creditoClienteFormaPagamento;
      }

      const { data } = await this.$http.post(
        "/financeiro/cliente-creditos/forma-pagamento-voucher"
      );

      this.creditoClienteFormaPagamento = data;

      return this.creditoClienteFormaPagamento;
    },
    montarPagamentoCreditoCliente(valor, formaPagamento) {
      const meioPagamento =
        formaPagamento?.meioPagamento ?? formaPagamento?.meio_pagamento ?? {};
      const idMeioPagamento =
        formaPagamento?.id_meio_pagamento ?? meioPagamento?.id ?? 21;

      return {
        ...formaPagamento,
        id: formaPagamento.id,
        descricao: formaPagamento.descricao || "Voucher / Crédito Cliente",
        id_meio_pagamento: idMeioPagamento,
        vezes: formaPagamento.vezes ?? 1,
        requer_entrada: false,
        movimenta_caixa: false,
        value: valor,
        credito_cliente: true,
        paymentMode: {
          description: meioPagamento.descricao || "Crédito em Loja",
          id: String(idMeioPagamento),
          name: meioPagamento.descricao || "Crédito em Loja",
        },
        range: [
          {
            value: valor,
            date: this.thisDate(),
          },
        ],
      };
    },
    isPagamentoCreditoCliente(pagamento) {
      const descricao = (pagamento?.descricao ?? "").toLowerCase();
      const idMeioPagamento =
        pagamento?.id_meio_pagamento ?? pagamento?.paymentMode?.id;

      return (
        pagamento?.credito_cliente === true ||
        Number(idMeioPagamento) === 21 ||
        descricao.includes("crédito em loja") ||
        descricao.includes("credito em loja")
      );
    },
    removerPagamentoCreditoCliente() {
      this.listaPagamentos = this.listaPagamentos.filter(
        (pagamento) => !this.isPagamentoCreditoCliente(pagamento)
      );
      this.venda.paymentModeCollection = (
        this.venda.paymentModeCollection ?? []
      ).filter((pagamento) => !this.isPagamentoCreditoCliente(pagamento));
    },
    valorPendenteParaCredito() {
      const totalSemCredito = this.listaPagamentos.reduce(
        (total, pagamento) => {
          if (this.isPagamentoCreditoCliente(pagamento)) return total;
          return total + this.getRangePayment(pagamento.range);
        },
        0
      );

      return this.roundTo2Digits(Math.max(this.total - totalSemCredito, 0));
    },
    valorVoucherCredito(voucher) {
      const saldo = voucher?.saldo ?? voucher?.saldo_disponivel ?? 0;

      if (typeof saldo === "number") {
        return Number.isFinite(saldo) ? saldo : 0;
      }

      if (typeof saldo === "string") {
        const normalizado = saldo
          .replace(/[^\d,.-]/g, "")
          .replace(/\./g, "")
          .replace(",", ".");
        const valor = Number(normalizado);

        return Number.isFinite(valor) ? valor : 0;
      }

      return 0;
    },
    validarCreditoClienteVenda() {
      if (!this.creditoClienteAplicado) return true;

      const vouchersCredito = this.venda.credito_cliente?.vouchers ?? [];
      const vouchersSelecionados = Array.isArray(
        this.creditoClienteVoucherSelecionado
      )
        ? this.creditoClienteVoucherSelecionado
        : [this.creditoClienteVoucherSelecionado].filter(Boolean);
      const valorVoucher = this.roundTo2Digits(
        Number(this.venda.credito_cliente?.saldo_disponivel) ||
          vouchersSelecionados.reduce(
            (total, voucher) => total + this.valorVoucherCredito(voucher),
            0
          ) ||
          0
      );
      const valorUsado = this.roundTo2Digits(
        Number(this.venda.credito_cliente?.valor_usado) ||
          Number(this.creditoClienteValor) ||
          0
      );

      if (
        !this.venda.credito_cliente?.codigo_voucher &&
        vouchersCredito.length === 0
      ) {
        this.$toast.warning("Selecione o(s) voucher(s) usado(s) nesta venda.");
        return false;
      }

      if (valorUsado > valorVoucher) {
        this.$toast.warning(
          `O valor usado é maior que o voucher de R$ ${this.numberToReal(
            valorVoucher,
            2
          )}.`
        );
        return false;
      }

      if (valorUsado > this.roundTo2Digits(this.total)) {
        this.$toast.warning("Remova o voucher e aplique novamente.");
        return false;
      }

      return true;
    },
    atualizarValorPagamentoPendente() {
      const pendente = this.roundTo2Digits(
        Math.max(this.total - this.valorPago, 0)
      );
      this.valorPgto = this.valorReal(pendente);
    },
    onSearchCliente(search, loading) {
      if (search.length > 2) {
        loading(true);
        this.searchClient(loading, search, this);
      }
    },
    searchClient: _.debounce(async (loading, search, vm) => {
      vm.clientes = await vm.getPessoaNome(search);
      loading(false);
    }, 500),

    changePagamentos(selectedPagamento) {
      this.pagamento = selectedPagamento;
      if (
        this.isPagamentoModalOpen &&
        this.isPagamentoCredito(selectedPagamento)
      ) {
        this.atalhoPagamentoSelecionado = {
          atalho: "f2",
          id: selectedPagamento.id,
        };
        this.pagamentosModalOptions = null;
      } else if (this.isPagamentoModalOpen) {
        this.atalhoPagamentoSelecionado = null;
      }
      this.$nextTick(() => {
        const input = this.getValorPagamentoModalInput();
        if (input) {
          input.focus();
          input.select();
          return;
        }
        this.$refs.valorPagamento.$el.querySelector("input").focus();
      });
      this.pagamentosEditados = [];
    },
    changeStatus(selectedStatus) {
      this.statusSelecionado = selectedStatus;
    },
    async adicionarPagamento() {
      const valorPagamentoAtual = this.isPagamentoModalOpen
        ? this.getValorPagamentoModalInput()?.value ?? this.valorPgto
        : this.valorPgto;
      const valor = await this.valorUS(valorPagamentoAtual);

      let pagamento = {
        value: parseFloat(valor),
        ...this.pagamento,
      };
      if (valor > 0 && pagamento.descricao) {
        let range = this.calculateInstallments(
          pagamento,
          parseFloat(pagamento.value)
        );

        const descricaoPagamento = pagamento.descricao.toLowerCase();
        if (
          descricaoPagamento === "à vista" ||
          descricaoPagamento === "cartão de débito 1x" ||
          descricaoPagamento === "pix"
        ) {
          range[0] = {
            ...range[0],
            date: this.thisDate(),
          };
        }

        pagamento = {
          ...pagamento,
          range,
        };

        if (pagamento.value > this.total && this.total !== 0) {
          pagamento = {
            ...pagamento,
            value: this.total,
          };
        }

        if (this.atalhoPagamentoPendente) {
          Object.defineProperty(pagamento, "__atalhoPagamentoKey", {
            value: this.atalhoPagamentoPendente,
            enumerable: false,
            configurable: true,
          });
        }

        this.listaPagamentos.push(pagamento);

        if (descricaoPagamento !== "Nenhum")
          this.checkValorPago(pagamento.value);

        this.parcela = null;
        this.operacao = null;
        this.valueMeioPagamento = null;
        this.pagamento = null;
        this.changePagamentos({});
        this.pagamentoEditado =
          this.listaPagamentos[
            this.selectedPagamento.pagamento
          ].range[0]?.value;
        this.$toast.success("Adicionado com sucesso!");
        this.$refs.finishModal.focus();
        return true;
      }

      return false;
    },
    removePagamento(indice) {
      const [deletedPagamento] = this.listaPagamentos.splice(indice, 1);
      if (this.isPagamentoCreditoCliente(deletedPagamento)) {
        this.creditoClienteValor = 0;
        this.creditoClienteAplicado = false;
        this.creditoClienteVoucherSelecionado = null;
        this.venda.credito_cliente = null;
        this.atualizarValorPagamentoPendente();
        this.$toast.success("Crédito removido da venda.");
        return;
      }

      if (
        deletedPagamento.__atalhoPagamentoKey ===
        this.atalhoPagamentoSelecionado?.atalho
      ) {
        this.atalhoPagamentoSelecionado = null;
      }
      this.checkValorPago(
        deletedPagamento.descricao === "Nenhum" ? deletedPagamento.value : 0
      );
      this.$toast.success("Removido com sucesso!");
    },
    checkValorPago(valor = 0) {
      if (this.valorPagoVenda === 0 && valor === 0) {
        this.valorPgto = this.valorReal(this.total);
        return;
      }
      const valorPagar = this.total - (this.valorPagoVenda + valor);

      this.valorPgto = valorPagar < 0 ? "0,00" : this.valorReal(valorPagar);

      this.valorPgaoVenda += valor;
    },
    calcValue(percent) {
      const valor = parseFloat(percent / 100);
      return valor;
    },
    normalizarPagamentosVenda(pagamentos = []) {
      return pagamentos.map((pagamento) => ({
        ...pagamento,
        value: this.roundTo2Digits(pagamento.value || 0),
        range: (pagamento.range || []).map((parcela) => ({
          ...parcela,
          value: this.roundTo2Digits(parcela.value || 0),
        })),
      }));
    },
    setInitialState() {
      this.valueDiscount = 0;
      this.percentDiscount = 0;
      this.valueExtraValue = 0;
      this.percentExtraValue = 0;
      this.tipoDescontoValue = 1;
      this.tipoAcrescimoValue = 1;
      this.modoAtacadoAtivo = false;
      this.descontoAcrescimoAberto = false;
      this.valueCliente = {};
      this.creditoClienteSaldo = 0;
      this.creditoClienteValor = 0;
      this.creditoClienteAplicado = false;
      this.creditoClienteVouchers = [];
      this.creditoClienteVoucherSelecionado = null;
      this.limiteCreditoAtigindo = false;
      this.limiteCreditoAtual = false;
      this.valorLimiteCredito = 0;
      this.valorLimiteCreditoAtingido = 0;
    },
    setTipoAcrecimo(tipo) {
      if (tipo) {
        this.tipoAcrescimoValue = tipo.value;
      }
    },
    async saveDescontoAcrescimo() {
      if (
        this.venda.discount !== 0 &&
        this.venda.discount === this.valueDiscount
      )
        return;
      if (
        this.venda.extraValue !== 0 &&
        this.venda.extraValue === this.valueExtraValue
      )
        return;
      let discount;
      let extraValue;

      if (this.tipoDescontoValue === 2 && this.valueDiscount !== 0) {
        discount = {
          valueDiscount: 0,
          percentDiscount: this.calcValue(this.valueDiscount),
        };
      } else {
        discount = {
          valueDiscount: this.valueDiscount,
          percentDiscount: 0,
        };
      }
      if (this.tipoAcrescimoValue === 2 && this.valueExtraValue !== 0) {
        extraValue = {
          valueExtraValue: 0,
          percentExtraValue: this.calcValue(this.valueExtraValue),
        };
      } else {
        extraValue = {
          valueExtraValue: this.valueExtraValue,
          percentExtraValue: 0,
        };
      }
      let params = {
        discount,
        extraValue,
      };

      if (this.pedidos.length && this.discountPedidoImportado > 0) return;

      const applyDescontoAcrescimo = () => {
        this.descontoAplicado = this.valueDiscount !== 0;
        this.acrescimoAplicado = this.valueExtraValue !== 0;
        return this.changeDescontoAcrescimo(params);
      };
      const hasDiscount =
        Number(discount.valueDiscount || 0) > 0 ||
        Number(discount.percentDiscount || 0) > 0;

      if (hasDiscount) {
        return this.getRequestAdmin(applyDescontoAcrescimo);
      }

      return applyDescontoAcrescimo();
    },
    handleSairDaVenda() {
      this.$swal
        .fire({
          icon: "warning",
          title: "Cancelar a venda em andamento?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.$router.push({ name: "vendasLista" });
          }
        });
    },
    handleFinalizar(finalizarVenda) {
      if (this.store.pafNFCe && !finalizarVenda) return;
      if (this.posStep === 5) return;
      this.isNfce = finalizarVenda;
      this.posStep = 5;
      if (this.roundTo2Digits(this.valorPago) > 0) {
        if (
          this.roundTo2Digits(this.valorPago) < this.roundTo2Digits(this.total)
        ) {
          this.closeInfoVendaModal();
          return this.$toast.warning(
            "Valor pago deve ser igual ao total da venda!"
          );
        }
      }
      if (this.listaPagamentos.length === 0) {
        this.closeInfoVendaModal();
        this.$toast.warning("Necessário incluir pagamento!");
        return;
      }
      if (!this.validarCreditoClienteVenda()) {
        this.closeInfoVendaModal();
        return;
      }
      const hasAprazoPagamento = !!this.listaPagamentos.find(
        (element) => element?.informar_cliente
      );
      if (this.listaPagamentos.length > 0 && hasAprazoPagamento) {
        if (
          JSON.stringify(this.valueCliente) === "{}" ||
          !this.valueCliente ||
          this.valueCliente.length === 0
        ) {
          this.$toast.warning("Necessário incluir cliente!");
          this.$bvModal.hide("modal-forma-pagamento");
          this.$bvModal.show("modal-client");
          this.closeInfoVendaModal();
          return;
        }
      }
      this.$bvModal.show("modal-pos-venda");
      this.$bvModal.hide("modal-forma-pagamento");
      this.finalizarVenda(finalizarVenda, this.reservarJanelasImpressao());
    },

    async handleSalvarVenda(transmitirVenda) {
      this.posStep = 5;
      this.$bvModal.hide("modal-forma-pagamento");
      this.$bvModal.show("modal-pos-venda");
      if (!this.validarCreditoClienteVenda()) {
        this.handleShowPagamentoModal({ transmitir: false, isSave: true });
        return;
      }
      if (this.roundTo2Digits(this.valorPago) > 0) {
        if (
          this.roundTo2Digits(this.valorPago) < this.roundTo2Digits(this.total)
        ) {
          this.handleShowPagamentoModal({ transmitir: false, isSave: true });
          return this.$toast.warning(
            "Valor pago deve ser igual ao total da venda!"
          );
        }
      }
      if (this.total === 0) {
        return false;
      }

      this.venda.paymentModeCollection = this.normalizarPagamentosVenda(
        this.listaPagamentos
      );

      if (this.venda.paymentModeCollection.length === 0) {
        await this.defaultPagamento();
      }

      try {
        const config = await this.garantirConfiguracaoPdvWeb();
        const troco = this.roundTo2Digits(this.valorPago - this.total);
        this.venda.remainder = troco > 0 ? troco : 0;
        this.venda.price = this.roundTo2Digits(this.total);
        this.venda.isNFce = transmitirVenda;
        if (!this.venda.isNFce) {
          this.venda.status = this.statusSelecionado.id;
          this.venda.statusSelecionado = this.statusSelecionado;
        }

        this.venda.productOfTradeCollection =
          await this.store.productOfTradeCollection.filter((item) => {
            const itemFilter = item.active.toString();
            return itemFilter.indexOf("true") > -1;
          });

        const dados = {
          ...this.venda,
          serie: config.serie,
          id_configuracao:
            config.id_configuracao || config.id || this.idConfiguracaoPadraoPdvWeb,
        };
        if (dados.buyer.cnpj_cpf) {
          dados.buyer.cnpj_cpf = dados.buyer.cnpj_cpf.replace(/[^\d]+/g, "");
        }

        if (!this.nota.id) {
          this.nota = await this.criarNota(dados);
        } else {
          const { data } = await this.$http.post("/nfe/update", {
            dados: {
              ...dados,
              id: this.nota.id,
              ...(this.pedidos.length > 0 && { pedidos: this.pedidos }),
              ...(this.os.length > 0 && { os: this.os }),
              ...(this.orcamentos.length > 0 && {
                orcamentos: this.orcamentos,
              }),
            },
          });
          this.nota = { ...this.nota, ...data };
        }
        this.pedidos = [];
        this.os = [];
        this.orcamentos = [];

        await this.vincularVendaCondicionalSeNecessario();

        this.imprimirVoucherCreditoResidual(this.nota);

        this.setLoading(false);
        this.isLoadingSubmit = false;
        this.$router.push({ name: "vendasLista" });
      } catch (e) {
        this.setLoading(false);
        this.currentErrorMessage =
          this.getMensagemErro(e) || "Não foi possível salvar a venda.";
        try {
          this.marcarProdutoErroFiscalPDV(e);
        } catch (error) {
          console.error("Erro ao identificar o produto fiscal:", error);
        }
        this.isLoadingSubmit = false;
        this.closeInfoVendaModal();
        return this.$toast.error(this.currentErrorMessage);
      }
      this.closeInfoVendaModal();
    },
    closeInfoVendaModal() {
      this.$bvModal.hide("modal-pos-venda");
      this.posStep = 0;
    },
    removeCliente() {
      if (this.creditoClienteAplicado) {
        this.removerCreditoCliente(false);
      }
      this.venda.buyer = {};
      this.valueCliente = {};
      this.creditoClienteSaldo = 0;
      this.creditoClienteValor = 0;
      this.creditoClienteAplicado = false;
      this.creditoClienteVouchers = [];
      this.creditoClienteVoucherSelecionado = null;
      this.$toast.success("Cliente removido com sucesso!");
      this.limiteCreditoAtigindo = false;
      this.limiteCreditoAtual = false;
      this.valorLimiteCredito = 0;
      this.valorLimiteCreditoAtingido = 0;
      this.idPessoaLista = null;
    },
    setStatusVenda(status) {
      if (status) {
        this.statusVenda = status;
      }
    },
    onSearchVendedor(search, loading) {
      const busca = this.prepararBuscaDireta(search, loading);
      busca.loading(true);
      this.searchVendedor(busca.loading, busca.termo, this);
    },
    searchVendedor: _.debounce(async (loading, search, vm) => {
      vm.vendedores = await vm.getVendedorByNome(search);
      if (loading) loading(false);
    }, 500),
    async getIntegracaoPos() {
      try {
        const { data } = await this.$http.post("/pos/get");
        if (data.length > 0) {
          this.integracaoPos = true;
          this.equipamentosPos = data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async solicitarPagamentoPos() {
      this.posStep = 6;
      this.isLoadingPosData = false;
      this.solicitadoPagamentoPos = true;

      await this.$http.post("/pos/solicitar-pagamento", {
        equipamento: this.equipamentosSelecionado,
        pagamentos: this.listaPagamentos,
        nfce: this.nota,
      });
    },
    setEquipamento(equipamento) {
      this.equipamentosSelecionado = equipamento;
      this.solicitadoPagamentoPos = true;
    },
    async cancelarPagamentoPos() {
      this.posStep = 1;
      this.isLoadingPosData = true;
      this.solicitadoPagamentoPos = true;

      const data = await this.$http.post("/pos/cancelar-pagamento", {
        equipamento: this.equipamentosSelecionado,
        pagamentos: this.listaPagamentos,
        nfce: this.nota,
      });

      if (data.data.responseCode == 200) {
        this.$toast.success(
          "Cancelamento efetuado com sucesso, atualize a lista de pagamentos no APP!"
        );
        this.solicitadoPagamentoPos = false;
        this.solicitarDadosCartao = false;
        this.paymentsCartao = [];
      }
    },
    async gerarPAFEstoqueTotal() {
      this.addLoadingToButton("gerarPAFEstoqueTotal");
      try {
        const result = await this.$http.post("/paf/estoque-total");
        if (result["data"]["file_url"]) {
          window.open(result["data"]["file_url"], "_blank");
        }
        this.$toast.success("Arquivo gerado com sucesso!");
        this.$bvModal.hide("estoqueTotal");
      } catch (error) {
        console.log(error);
        this.removeLoadingToButton("gerarPAFEstoqueTotal");
      }
      this.removeLoadingToButton("gerarPAFEstoqueTotal");
    },
  },
  computed: {
    labelOperacaoAjusteItem() {
      return this.ajusteItemModal.operacao === "acrescimo"
        ? "Acréscimo"
        : "Desconto";
    },
    precoUnitarioComAjusteItem() {
      return this.calcularPrecoComAjusteItem();
    },
    valorProdutoSelecionado() {
      return this.formatValorCalculoQuantidade(this.price);
    },
    receberContaTotal() {
      return this.receberContaSelecionadas.reduce(
        (total, conta) => total + this.getValorContaReceberPdv(conta),
        0
      );
    },
    canReceberContaPdv() {
      return (
        !this.isRecebendoContaPdv &&
        this.receberContaSelecionadas.length > 0 &&
        !!this.receberContaFormaPagamento
      );
    },
    canReceberContaParcialPdv() {
      return (
        !this.isRecebendoContaPdv &&
        !this.isLoadingRecebimentoParcialPdv &&
        this.receberContaSelecionadas.length === 1
      );
    },
    receberContaStatusTexto() {
      if (this.receberContaLoading) return "Buscando contas abertas...";
      if (this.receberContaBusca.trim().length < 3) {
        return "Digite nome ou CPF/CNPJ para buscar contas abertas.";
      }
      if (this.receberContaResultados.length === 0) {
        return "Nenhuma conta aberta encontrada.";
      }
      return `${this.receberContaSelecionadas.length} conta(s) selecionada(s).`;
    },
    total() {
      const produtos = this.store.productOfTradeCollection;
      let valor = produtos.reduce(
        (total, item) => this.roundTo2Digits(total + item.totalPrice),
        0
      );
      if (!this.descontoItemPedido) {
        if (this.venda.discount) {
          valor -= this.venda.discount;
        }
      }
      if (this.venda.extraValue) {
        valor += parseFloat(this.venda.extraValue);
      }
      return this.roundTo2Digits(valor);
    },
    modalTitle() {
      return this.posStep < 1
        ? "Consultando POS"
        : `Finalizando a ${this.isNfce ? "NFce" : "Pré-venda"}`;
    },
    valorPrimeiraParcela() {
      if (this.listaPagamentos[this.selectedPagamento.pagamento] === undefined)
        return 0;
      return (
        this.listaPagamentos[this.selectedPagamento.pagamento].range[0].value ??
        0
      );
    },
    troco() {
      return parseFloat(this.valorPgto) - parseFloat(this.total);
    },
    valorPago() {
      if (this.listaPagamentos.length === 0 || !this.listaPagamentos) {
        return 0;
      }

      return this.listaPagamentos.reduce(
        (total, item) =>
          this.roundTo2Digits(total + this.getRangePayment(item.range)),
        0
      );
    },
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "itsblocked",
    ]),
    ...mapState(["loading"]),
    ...mapState({
      currentUser: (state) => state.auth.user,
      vendedorLogado: (state) => state.auth.vendedor,
    }),
    // Preferência "mostrar atalhos em tela" — vem do banco ( usuário logado).
    mostrarAtalhosEmTela() {
      return !!this.currentUser?.mostrar_atalhos_pdv;
    },
    isLoading() {
      return this.loading.loading;
    },
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    toolbarDisplay() {
      return true;
    },
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
    displaySubheaderOnDashboard() {
      return this.$route.name !== "dashboard";
    },
    qtyPrec() {
      return Number(quantityOptions.precision);
    },
    pricePrec() {
      return Number(priceOptions.precision);
    },
  },
};
</script>

<style>
@media (max-width: 767px) {
  .right-card {
    /* Mobile styles */
    padding-top: 1rem;
    margin-top: 1.5rem;
  }
}

.vs-pedido-clean .vs__selected {
  display: none;
}

.busca-produto .vs__search {
  font-weight: 700;
  font-size: 1.45rem !important;
  margin-bottom: 0.5rem !important;
  line-height: 1.2 !important;
  text-transform: uppercase !important;
}

.busca-produto .vs__dropdown-toggle {
  border: 0px !important;
}

.busca-produto .vs__actions {
  display: none;
}

.busca-produto .vs__selected-options {
  max-width: 100%;
  flex-wrap: initial;
}

.busca-produto .vs__selected {
  text-align: left !important;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.busca-cliente .vs__search {
  font-size: 18px;
}

.busca-cliente .vs__dropdown-toggle {
  color: var(--primary-color);
  background-color: #fff;
  border: 2px solid #dedede;
  height: 40px;
}

.busca-cliente .vs--open .vs__dropdown-toggle {
  background-color: #fff;
  border: 2px solid var(--primary-color);
}

.busca-cliente .vs__actions {
  display: none;
}

.busca-cliente .vs__dropdown-option--highlight,
.vs__dropdown-menu li:hover,
.vs__dropdown-menu li:focus {
  background-color: var(--primary-color) 5e !important;
  color: var(--primary-color) !important;
}

.busca-cliente .vs__dropdown-menu {
  color: var(--primary-color) !important;
  z-index: 9999 !important;
}

.busca-cliente .vs__selected-options {
  max-width: 100%;
  flex-wrap: initial;
}

.busca-cliente .vs__selected {
  text-align: left !important;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.credito-cliente-box {
  align-items: center;
  background: color-mix(in srgb, var(--primary-color) 8%, #fff);
  border: 1px solid var(--primary-color);
  border-radius: 6px;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  padding: 0.75rem;
}

.pdv-form {
  top: -30px;
}

.pdv-shortcuts-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 1.5rem;
  row-gap: 0.65rem;
}

.pdv-atacado-toggle-col {
  align-items: flex-start;
  display: flex;
  padding-left: 0;
  padding-top: 1.65rem;
}

.pdv-atacado-toggle {
  align-items: center;
  border: 1px solid #e4e6ef;
  border-radius: 0.42rem;
  display: inline-flex;
  height: 34px;
  justify-content: center;
  padding: 0;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    box-shadow 0.15s ease, color 0.15s ease;
  width: 38px;
}

.pdv-atacado-toggle--active {
  border-color: #1bc5bd;
  box-shadow: 0 0 0 3px rgba(27, 197, 189, 0.16);
}

.pdv-atacado-toggle .material-design-icon {
  display: inline-flex;
}

.pdv-shortcut-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.65rem 0;
  border-bottom: 1px solid #f0f1f4;
  color: #3f4254;
  font-weight: 600;
}

.pdv-shortcut-row:last-child {
  border-bottom: 0;
}

.pdv-shortcut-row-title {
  grid-column: 1 / -1;
  justify-content: flex-start;
  border-bottom: 0;
  padding-bottom: 0;
  color: #7e8299;
  font-size: 0.78rem;
  text-transform: uppercase;
}

@media (max-width: 640px) {
  .pdv-shortcuts-list {
    grid-template-columns: 1fr;
  }
}

/* ── Toggle "Mostrar atalhos em tela" (cabeçalho do modal de atalhos) ── */
.pdv-shortcuts-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.6rem 0.9rem;
  margin-bottom: 0.9rem;
  border-radius: 8px;
  background-color: #f3f6f9;
  border: 1px solid #ebedf2;
}

.pdv-shortcuts-toggle__label {
  font-weight: 600;
  color: #3f4254;
  font-size: 0.9rem;
}

/* ── Badge de atalho exibido dentro dos botões do PDV ─────────────────── */
.pdv-btn-atalho {
  font-size: 0.7rem;
  font-weight: 600;
  opacity: 0.85;
  white-space: nowrap;
}

.pdv-shortcut-row kbd {
  min-width: 72px;
  padding: 0.35rem 0.55rem;
  border-radius: 5px;
  background-color: #f3f6f9;
  color: #3f4254;
  box-shadow: inset 0 -1px 0 rgba(15, 23, 42, 0.15);
  text-align: center;
  font-size: 0.82rem;
}

.pdv-payment-modal-body {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 220px);
  overflow: visible;
  padding: 1rem 1.25rem 0 !important;
}

.pdv-payment-modal-body .busca-cliente .vs__dropdown-menu {
  z-index: 9999 !important;
  position: absolute;
}

.pdv-payment-form-row {
  flex: 0 0 auto;
  margin: 0.35rem 0 0.75rem !important;
}

.pdv-payment-form-row .font-weight-bolder {
  margin-bottom: 0.45rem !important;
}

.pdv-payment-add-button {
  width: 100%;
  min-height: 38px;
  white-space: nowrap;
}

.pdv-payment-shortcuts {
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.4rem;
}

.pdv-payment-shortcuts__item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  border: 1px solid #e4e6ef;
  border-radius: 6px;
  background-color: #f3f6f9;
  color: #3f4254;
  height: 30px;
  min-width: 0;
  padding: 0 0.35rem;
  text-align: center;
  font-size: 0.72rem;
  font-weight: 800;
  white-space: nowrap;
}

.pdv-payment-shortcuts__item strong {
  color: var(--primary-color);
  font-size: 0.72rem;
}

.pdv-payment-shortcuts__item span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pdv-payment-shortcuts__item:hover,
.pdv-payment-shortcuts__item:focus {
  border-color: var(--primary-color);
  color: var(--primary-color);
  outline: 0;
}

.pdv-payment-list-scroll {
  flex: 1 1 auto;
  min-height: 80px;
  max-height: 240px;
  overflow-x: hidden;
  overflow-y: auto;
  margin-top: 0.45rem;
  padding-right: 0.25rem;
  border-top: 1px solid #edf0f4;
}

.pdv-payment-list-scroll .form-group {
  margin-bottom: 0 !important;
}

.pdv-payment-list-scroll .row {
  margin-left: 0;
  margin-right: 0;
}

.pdv-payment-list-scroll > .row > .col,
.pdv-payment-list-scroll .busca {
  padding-left: 0;
  padding-right: 0;
}

.pdv-payment-item-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.45rem 0.75rem 0.2rem;
}

.pdv-payment-list-scroll .pdv-payment-item-header:not(:first-child) {
  border-top: 1px solid #edf0f4;
  margin-top: 0.25rem;
}

.pdv-payment-list-scroll .table {
  margin-bottom: 0.25rem;
}

.pdv-payment-list-scroll .table th,
.pdv-payment-list-scroll .table td {
  padding-top: 0.35rem !important;
  padding-bottom: 0.35rem !important;
}

.pdv-payment-list-scroll .card-body,
.pdv-payment-list-scroll .table-responsive {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.pdv-payment-summary {
  flex: 0 0 auto;
  margin: 0.75rem 0 0 !important;
  padding: 0.85rem 0.75rem 0.25rem;
  background-color: #fff;
}

.pdv-payment-summary .mt-5 {
  margin-top: 0 !important;
}

.pdv-shortcuts-button-area {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.85rem;
  padding-right: 0.75rem;
}

.pdv-shortcuts-button {
  border: 1px solid #d7dae5;
  border-radius: 8px;
  background-color: #fff;
  color: #3f4254;
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.06);
  font-size: 0.92rem;
  font-weight: 700;
  padding: 0.55rem 0.95rem;
}

.pdv-shortcuts-button:hover,
.pdv-shortcuts-button:focus {
  border-color: var(--primary-color);
  color: var(--primary-color);
  outline: 0;
}

.remove-pgto {
  font-weight: bold;
  font-size: 18px;
  color: #4f4f4f;
}

.add-pgto {
  font-weight: bold;
  font-size: 22px;
  color: var(--primary-color);
  float: right;
}

.input-quantidade {
  font-size: 1.75rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  background: transparent;
  border: transparent;
  color: #fff;
  padding: 0px;
  margin-top: -10px;
  margin-bottom: 0px;
  text-align: right;
}

.input-quantidade:focus {
  box-shadow: 0 0 0 0;
  border: 0 none;
  outline: 0;
  border: 0px;
  background-color: transparent;
  color: #fff;
}

.card {
  border: 0;
}

h4 {
  color: #6d747c;
  /* font-weight: 900; */
}

.pdv-card-logo {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  width: 100vh;
  background-color: #fff;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  max-height: calc(100vh - 375px);
  height: calc(100vh - 375px);
  border: 0px;
  top: -20px !important;
  text-align: center !important;
  position: relative;
}

.pdv-card-logo img {
  max-width: 100%;
  height: auto;
}

.pdv-acoes {
  position: absolute;
  width: 100%;
  margin-top: -32px;
}

.pdv-atalhos {
  position: absolute;
  bottom: 0px;
  left: 0px;
}

.pdv-atalhos .btn-success {
  background-color: #eee5ff;
  border-color: var(--primary-color);
}

.pdv-atalhos button {
  margin-right: 0px !important;
  background-color: #fff;
  color: #4f4f4f;
  font-size: 14px;
  margin-top: 8px;
  height: 60px;
}

.pdv-atalhos button:hover {
  background-color: var(--color-secondary);
  border-color: var(--color-secondary);
}

.btn-finalizar-venda {
  background-color: #eee5ff !important;
  font-size: 1.25rem !important;
  text-align: center !important;
  cursor: pointer;
}

.card-total-right p,
.card-total-left p {
  color: #fff !important;
}

/* @media (max-width: 1024px) { */
.card-header h5,
.card-header h3 {
  margin-bottom: 0rem;
}

.card-header .form-control {
  height: auto;
  margin-top: 0px;
}

.card-header .busca-produto {
  margin-top: 2px;
}

.card-titulo-itens .card-body {
  padding: 5px 0 !important;
}

.card-itens .table tr th {
  padding: 5px;
  font-size: 12px;
}

.card-itens .table tr td,
.card-total-right p,
.card-total-left p {
  font-size: 12px;
}

.tableItensVenda {
  max-height: 300px !important;
  height: calc(100vh - 395px) !important;
}

.pdv-acoes {
  margin-top: -32px;
}

.pdv-card-logo {
  max-height: calc(100vh - 345px) !important;
  height: calc(100vh - 345px) !important;
}

.atalhos li a,
.atalhos li button span {
  font-size: 12px !important;
}

.card-total-left,
.card-total-right {
  height: 80px !important;
}

.btn.btn-secondary {
  color: var(--primary-color);
  background-color: #fff;
  border-color: #fff;
}

.venda-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 5rem;
  padding: 1rem;
  width: fit-content;
  border-radius: 8px;
  margin-top: 3.5rem;
  margin: 3.5rem auto 0;
  background-color: white;
  z-index: 999;
}
.font-size-h2-plus {
  font-size: 2.2rem !important; /* levemente maior que h2 */
}

.font-size-h4-plus {
  font-size: 1.5rem !important; /* levemente maior que h4 */
}

@media (max-width: 991.98px) {
  .pdv-venda-page {
    overflow-x: hidden;
  }

  .pdv-venda-page .pdv-top-actions-row,
  .pdv-venda-page .pdv-main-row,
  .pdv-venda-page .pdv-search-row {
    margin-left: 0;
    margin-right: 0;
  }

  .pdv-venda-page .pdv-top-actions-row {
    align-items: flex-start;
    gap: 0.45rem 0;
  }

  .pdv-venda-page .pdv-filter-col {
    flex: 0 0 48px;
    max-width: 48px;
    padding-left: 0;
    padding-right: 0.35rem;
  }

  .pdv-venda-page .pdv-filter-col .dropdown,
  .pdv-venda-page .pdv-filter-col .btn {
    width: 100%;
  }

  .pdv-venda-page .pdv-actions-toolbar {
    display: flex !important;
    flex: 1 1 calc(100% - 48px);
    flex-wrap: wrap;
    gap: 0.4rem;
    justify-content: flex-start !important;
    max-width: calc(100% - 48px);
    min-width: 0;
    padding-left: 0;
    padding-right: 0;
  }

  .pdv-venda-page .pdv-actions-toolbar .btn,
  .pdv-venda-page .pdv-actions-toolbar button {
    flex: 1 1 118px;
    margin-right: 0 !important;
    min-height: 40px;
    min-width: 0;
    padding-left: 0.55rem;
    padding-right: 0.55rem;
    white-space: normal;
  }

  .pdv-venda-page .pdv-actions-toolbar .btn:last-child,
  .pdv-venda-page .pdv-actions-toolbar button:last-child {
    flex: 0 0 46px;
  }

  .pdv-venda-page .pdv-caixa-status,
  .pdv-venda-page .pdv-selected-list {
    flex: 0 0 100%;
    margin-left: 0 !important;
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;
  }

  .pdv-venda-page .pdv-selected-list .badge {
    display: inline-flex;
    max-width: 100%;
    white-space: normal;
  }

  .pdv-venda-page .pdv-main-sale-col,
  .pdv-venda-page .pdv-side-col,
  .pdv-venda-page .pdv-search-col {
    flex: 0 0 100%;
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;
  }

  .pdv-venda-page .pdv-search-col .container-app {
    padding-top: 0;
  }

  .pdv-venda-page .pdv-search-col .card-header {
    padding: 0.75rem !important;
  }

  .pdv-venda-page .pdv-search-col .card-header .card-body {
    padding: 0 !important;
  }

  .pdv-venda-page .pdv-search-col .card-header .card-body > .row {
    display: grid;
    gap: 0.5rem;
    grid-template-columns:
      minmax(82px, 1fr) minmax(82px, 1fr)
      minmax(160px, 1.4fr);
    margin-left: 0;
    margin-right: 0;
  }

  .pdv-venda-page
    .pdv-search-col
    .card-header
    .card-body
    > .row
    > [class*="col"] {
    max-width: none;
    min-width: 0;
    padding-left: 0;
    padding-right: 0;
    width: auto;
  }

  .pdv-venda-page .pdv-search-col .pdv-pesquisa {
    grid-column: 1 / -1;
  }

  .pdv-venda-page .pdv-search-col .pdv-valor,
  .pdv-venda-page .pdv-search-col .pdv-button {
    align-self: stretch;
    padding: 0 !important;
  }

  .pdv-venda-page .pdv-search-col .pdv-valor label {
    margin-bottom: 0.25rem;
    padding-left: 0.25rem;
    text-align: left !important;
  }

  .pdv-venda-page .pdv-search-col .pdv-button > div {
    gap: 0.5rem;
    justify-content: flex-start !important;
  }

  .pdv-venda-page .pdv-search-col .pdv-button button {
    min-width: 0;
  }

  .pdv-venda-page .busca-produto .vs__search {
    font-size: 1rem !important;
    line-height: 1.2 !important;
    margin-bottom: 0 !important;
    min-width: 0;
  }

  .pdv-venda-page .busca-produto .vs__dropdown-toggle {
    min-height: 40px;
  }

  .pdv-venda-page .busca-produto h3 {
    font-size: 1.15rem !important;
    margin-bottom: 0;
  }

  .pdv-venda-page .card-titulo-itens .card-title {
    font-size: 1.35rem;
    padding: 0.65rem 0.35rem;
  }

  .pdv-venda-page .tableItensVenda {
    height: auto !important;
    max-height: calc(100vh - 320px) !important;
    min-height: 265px;
    overflow-x: auto;
    overflow-y: auto;
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }

  .pdv-venda-page .tableItensVenda .table {
    min-width: 560px;
  }

  .pdv-venda-page .tableItensVenda .item-action-buttons {
    min-width: 76px;
  }

  .pdv-venda-page .right-card {
    margin-top: 2.25rem;
  }

  .pdv-payment-modal {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .pdv-payment-modal .modal-dialog {
    margin-left: auto;
    margin-right: auto;
    max-width: calc(100vw - 18px);
    width: calc(100vw - 18px);
  }

  .pdv-payment-modal .modal-dialog-centered {
    align-items: flex-start;
    min-height: auto;
  }

  .pdv-payment-modal .modal-content {
    max-height: calc(100vh - 18px);
    overflow: hidden;
  }

  .pdv-payment-modal .modal-header,
  .pdv-payment-modal .modal-footer {
    padding: 0.75rem 1rem;
  }

  .pdv-payment-modal .modal-title {
    font-size: 1rem;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .pdv-payment-modal-body {
    max-height: calc(100vh - 146px);
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0.75rem 1rem 0 !important;
  }

  .pdv-payment-form-row {
    gap: 0.65rem;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .pdv-payment-form-row > [class*="col"] {
    flex: 0 0 100%;
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;
  }

  .pdv-payment-shortcuts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .pdv-payment-list-scroll {
    max-height: min(35vh, 220px);
    overflow-x: auto;
  }

  .pdv-payment-list-scroll .table-responsive {
    overflow-x: auto;
  }

  .pdv-payment-list-scroll .table {
    min-width: 360px;
  }

  .pdv-payment-summary {
    margin-top: 0.65rem !important;
    padding: 0.75rem 0 0.1rem;
  }

  .pdv-payment-summary > [class*="col"] {
    flex: 0 0 100%;
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;
  }

  .pdv-payment-summary .font-size-h2-plus {
    font-size: 1.65rem !important;
  }

  .pdv-payment-summary .font-size-h3,
  .pdv-payment-summary .font-size-h5-plus {
    font-size: 1rem !important;
  }

  .pdv-payment-modal .modal-footer {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: flex-end;
  }
}

@media (max-width: 575.98px) {
  .pdv-venda-page .pdv-actions-toolbar .btn,
  .pdv-venda-page .pdv-actions-toolbar button {
    flex-basis: calc(50% - 0.4rem);
    font-size: 0.78rem;
  }

  .pdv-venda-page .pdv-actions-toolbar .btn:last-child,
  .pdv-venda-page .pdv-actions-toolbar button:last-child {
    flex-basis: 46px;
  }

  .pdv-venda-page .pdv-search-col .card-header .card-body > .row {
    grid-template-columns: minmax(72px, 1fr) minmax(72px, 1fr);
  }

  .pdv-venda-page .pdv-search-col .pdv-button {
    grid-column: 1 / -1;
  }

  .pdv-venda-page .pdv-search-col .pdv-button > div {
    flex-wrap: wrap;
  }

  .pdv-venda-page .pdv-search-col .pdv-button button {
    flex: 1 1 145px;
  }

  .pdv-venda-page .tableItensVenda {
    max-height: calc(100vh - 360px) !important;
    min-height: 245px;
  }

  .pdv-payment-modal .modal-dialog {
    max-width: calc(100vw - 10px);
    width: calc(100vw - 10px);
  }

  .pdv-payment-modal-body {
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
  }

  .pdv-payment-modal .modal-footer .btn {
    flex: 1 1 calc(50% - 0.5rem);
    margin: 0;
  }
}

.receber-conta-pdv-modal .modal-dialog {
  max-width: min(1180px, calc(100vw - 48px));
}

.receber-conta-pdv-modal .modal-content {
  border: 0;
  border-radius: 8px;
  overflow: hidden;
}

.receber-conta-pdv-header {
  border-bottom: 1px solid #edf0f5;
  padding: 1rem 1.25rem;
}

.receber-conta-pdv-header .modal-title {
  color: #1b2038;
  font-size: 1rem;
  font-weight: 700;
}

.receber-conta-pdv-body {
  padding: 0;
  overflow: hidden;
}

.receber-conta-shell {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 150px);
  min-height: 560px;
  background: #f7f8fb;
}

.receber-conta-topbar {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(220px, 0.65fr) 220px;
  gap: 12px;
  padding: 16px 20px 12px;
}

.receber-conta-search,
.receber-conta-payment,
.receber-conta-total-card {
  background: #fff;
  border: 1px solid #e6eaf1;
  border-radius: 8px;
  padding: 10px 12px;
}

.receber-conta-search label,
.receber-conta-payment label {
  color: #596174;
  display: block;
  font-size: 11px;
  font-weight: 700;
  margin-bottom: 6px;
}

.receber-conta-search .form-control,
.receber-conta-payment .custom-select {
  border-color: #dce2eb;
  font-size: 13px;
  height: 36px;
}

.receber-conta-search span {
  color: #7a8191;
  display: block;
  font-size: 11px;
  margin-top: 6px;
}

.receber-conta-total-card {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.receber-conta-total-card span,
.receber-conta-total-card small {
  color: #7a8191;
  font-size: 11px;
  font-weight: 700;
}

.receber-conta-total-card strong {
  color: #1b2038;
  font-size: 1.25rem;
  line-height: 1.25;
}

.receber-conta-list-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0 20px 10px;
}

.receber-conta-list-header strong {
  color: #1b2038;
  display: block;
  font-size: 13px;
}

.receber-conta-list-header span {
  color: #7a8191;
  display: block;
  font-size: 11px;
}

.receber-conta-table-wrap {
  background: #fff;
  border: 1px solid #e6eaf1;
  border-radius: 8px;
  flex: 1;
  margin: 0 20px;
  min-height: 0;
  overflow: auto;
}

.receber-conta-table {
  font-size: 11.5px;
  margin-bottom: 0;
  min-width: 920px;
}

.receber-conta-table.b-table-sticky-header {
  max-height: none;
}

.receber-conta-table thead th {
  background: #f2f5f9;
  border-bottom: 1px solid #e2e7ef;
  color: #596174;
  font-size: 11px;
  padding: 8px 10px;
  position: sticky;
  top: 0;
  z-index: 2;
}

.receber-conta-table tbody td {
  border-top: 1px solid #edf0f5;
  color: #34394a;
  padding: 7px 10px;
  vertical-align: middle;
}

.receber-conta-cliente strong {
  color: #2f3445;
  display: block;
  font-size: 11.5px;
  line-height: 1.25;
}

.receber-conta-cliente span,
.receber-conta-descricao {
  color: #6f7687;
  display: block;
  font-size: 11px;
  line-height: 1.25;
}

.receber-conta-vencimento {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.receber-conta-vencimento .badge {
  font-size: 10px;
  font-weight: 700;
  padding: 4px 6px;
}

.receber-conta-valor {
  color: #1b2038;
  white-space: nowrap;
}

.receber-conta-actionbar {
  align-items: center;
  background: #fff;
  border-top: 1px solid #e6eaf1;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 12px 20px;
}

.receber-conta-actionbar .btn {
  border-radius: 6px;
  font-weight: 700;
  min-width: 128px;
}

@media (max-width: 900px) {
  .receber-conta-pdv-modal .modal-dialog {
    max-width: calc(100vw - 16px);
  }

  .receber-conta-shell {
    max-height: calc(100vh - 96px);
    min-height: 520px;
  }

  .receber-conta-topbar {
    grid-template-columns: 1fr;
  }

  .receber-conta-total-card strong {
    font-size: 1.1rem;
  }
}

/* ---------- Indicador de pesagem (Balança) ---------- */
.balanca-indicador {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  background: #f1faff;
  color: #0f4c81;
  border: 1px solid #cfe8fb;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
}

.balanca-indicador__icone {
  flex-shrink: 0;
}

.balanca-indicador__texto {
  line-height: 1.2;
}

.balanca-indicador--pesando {
  background: #fff8e1;
  color: #854d0e;
  border-color: #fde68a;
}

.balanca-indicador--estavel {
  background: #dcfce7;
  color: #166534;
  border-color: #86efac;
}
</style>
